{
  "app.name": "Pāginæ",
  "app.skipToContent": "Skip to main content",
  "app.loading": "Loading…",
  "app.error.generic": "Something went wrong. Please try again.",
  "auth.signIn.title": "Sign in",
  "auth.signIn.passkey": "Sign in with a passkey",
  "auth.signIn.oauth": "Continue with {provider}",
  "auth.signIn.noMethods": "No sign-in method is available. Ask your administrator.",
  "auth.signOut": "Sign out",
  "auth.passkey.unsupported": "This browser does not support passkeys.",
  "auth.passkey.cancelled": "Passkey sign-in was cancelled.",
  "setup.title": "Set up Pāginæ",
  "setup.intro": "Create the first administrator account. You need the setup token generated when the app was deployed.",
  "setup.token": "Setup token",
  "setup.name": "Your name",
  "setup.email": "Email address",
  "setup.submit": "Create administrator and register a passkey",
  "setup.done": "Setup is complete. You are signed in as an administrator.",
  "setup.unavailable": "Setup has already been completed.",
  "home.welcome": "Welcome, {name}.",
  "home.admin": "Administration",
  "home.translations": "Translations",
  "admin.title": "Administration",
  "admin.users.title": "Users",
  "admin.users.command": "Administration: users",
  "admin.users.search": "Search by name or email",
  "admin.users.searchList": "People",
  "admin.users.show": "Show",
  "admin.users.filter.everyone": "Everyone",
  "admin.users.filter.admins": "Administrators",
  "admin.users.filter.disabled": "Disabled",
  "admin.users.command.search": "Search users",
  "admin.users.command.filter": "Users: show {filter}",
  "admin.users.count": "{count, plural, =0 {No users} one {# user} other {# users}}",
  "admin.users.none": "Nobody matches.",
  "admin.users.col.name": "Name",
  "admin.users.col.email": "Email",
  "admin.users.col.workspaces": "Workspaces",
  "admin.users.col.lastActive": "Last active",
  "admin.users.col.signIn": "Sign-in",
  "admin.users.col.actions": "Actions",
  "admin.users.chip.admin": "Admin",
  "admin.users.chip.disabled": "Disabled",
  "admin.users.actions": "Actions",
  "admin.users.actionsFor": "Actions for {name}",
  "admin.users.action.admin": "Make administrator",
  "admin.users.action.unadmin": "Remove administrator",
  "admin.users.action.disable": "Disable",
  "admin.users.action.enable": "Enable",
  "admin.users.action.signOut": "Sign out everywhere",
  "admin.users.action.recovery": "Send a recovery link",
  "admin.users.action.delete": "Delete",
  "admin.users.action.admin.for": "Make {name} an administrator",
  "admin.users.action.unadmin.for": "Remove {name} as an administrator",
  "admin.users.action.disable.for": "Disable {name}",
  "admin.users.action.enable.for": "Enable {name}",
  "admin.users.action.signOut.for": "Sign {name} out everywhere",
  "admin.users.action.recovery.for": "Send {name} a recovery link",
  "admin.users.action.delete.for": "Delete {name}",
  "admin.users.done.admin": "{name} is now an administrator.",
  "admin.users.done.unadmin": "{name} is no longer an administrator.",
  "admin.users.done.disable": "{name} is disabled and signed out everywhere.",
  "admin.users.done.enable": "{name} is enabled.",
  "admin.users.done.signOut": "{name} was signed out everywhere.",
  "admin.users.done.recovery": "Recovery link for {name} created: copy it and send it to them.",
  "admin.users.done.delete": "{name} was deleted.",
  "admin.users.method.passkey": "Passkey",
  "admin.users.method.email": "Email link",
  "admin.users.method.google": "Google",
  "admin.users.method.microsoft": "Microsoft",
  "admin.users.method.github": "GitHub",
  "admin.users.method.recoveryCode": "Recovery code",
  "admin.users.now": "Now",
  "admin.users.help": "Actions: make administrator, disable or enable, sign out everywhere, send a recovery link, delete (their pages stay, shown as “Deleted user”).",
  "admin.users.deleteTitle": "Delete {name}?",
  "admin.users.deleteBody": "Their pages and comments stay, under the name “Deleted user”. Their passkeys, sessions and memberships go, and they cannot sign in again. This cannot be undone.",
  "admin.users.deleteConfirm": "Delete",
  "admin.users.error.admin_self": "You cannot do this to your own account.",
  "admin.users.error.last_admin": "The installation needs another administrator first.",
  "admin.users.error.sole_owner": "They are the only owner of a workspace others use: make someone else an owner of it first.",
  "admin.users.error.user_disabled": "Enable the account first.",
  "admin.workspaces.title": "Workspaces",
  "admin.workspaces.command": "Administration: workspaces",
  "admin.workspaces.none": "No workspaces yet.",
  "admin.workspaces.col.name": "Workspace",
  "admin.workspaces.col.owner": "Owner",
  "admin.workspaces.col.members": "Members",
  "admin.workspaces.col.pages": "Pages",
  "admin.workspaces.col.files": "Files",
  "admin.workspaces.col.active": "Active this week",
  "admin.workspaces.col.details": "Details",
  "admin.workspaces.details": "Details",
  "admin.workspaces.detailsFor": "Details of {name}",
  "admin.workspaces.stat.active": "Active members, 4 weeks",
  "admin.workspaces.stat.activeValue": "{active} of {members}",
  "admin.workspaces.stat.edited": "Pages edited this week",
  "admin.workspaces.stat.published": "Published pages · views this month",
  "admin.workspaces.stat.publishedValue": "{published} · {views}",
  "admin.workspaces.help": "Counts only: administrators see names of workspaces, owners and totals, never page content (that is Content search, which is logged).",
  "admin.usage.title": "Usage",
  "admin.usage.command": "Administration: usage",
  "admin.usage.command.refresh": "Refresh usage",
  "admin.usage.intro": "Measured by the app; Cloudflare’s dashboard has the billing figures.",
  "admin.usage.meter.database": "Database (D1)",
  "admin.usage.meter.files": "Files (R2)",
  "admin.usage.meter.emails": "Emails today",
  "admin.usage.meter.webhooks": "Webhook deliveries today",
  "admin.usage.meter.sites": "Published sites",
  "admin.usage.of": "{used} of {limit}",
  "admin.usage.ofBudget": "{used} of {limit} budget",
  "admin.usage.unknown": "not measured",
  "admin.usage.sitesValue": "{count, number} · {size}",
  "admin.usage.alert": "An administrator is emailed at 80% of any limit. The limits are in <link>Settings</link> → Usage limits.",
  "admin.usage.email.subject": "{site}: usage near its limits",
  "admin.usage.email.intro": "Some of {site}’s usage has reached 80% of its limit:",
  "admin.usage.email.line": "{meter}: {percent}%",
  "admin.usage.email.open": "See usage",
  "admin.jobs.title": "Jobs",
  "admin.jobs.command": "Administration: jobs",
  "admin.jobs.col.job": "Job",
  "admin.jobs.col.runs": "Runs",
  "admin.jobs.col.lastRun": "Last run",
  "admin.jobs.col.result": "Result",
  "admin.jobs.col.run": "Run now",
  "admin.jobs.run": "Run now",
  "admin.jobs.runFor": "Run now: {job}",
  "admin.jobs.runningNow": "Running…",
  "admin.jobs.running": "Running",
  "admin.jobs.never": "Never",
  "admin.jobs.failed": "Failed: {error}",
  "admin.jobs.skipped": "Skipped: no files bucket",
  "admin.jobs.ran": "{job}: {result}",
  "admin.jobs.job.automations": "Automations on a schedule",
  "admin.jobs.job.emails": "Notification emails and daily summaries",
  "admin.jobs.job.webhooks": "Webhook deliveries",
  "admin.jobs.job.exports": "Whole-workspace exports",
  "admin.jobs.job.hourly": "Recurring rows, verifications, deleted workspaces and pages’ text for backups",
  "admin.jobs.job.retention": "Trash and retention",
  "admin.jobs.job.backup": "Backup",
  "admin.jobs.job.usage": "Usage check",
  "admin.jobs.job.addresses": "Workspace addresses: adding, removing and checking them",
  "admin.jobs.schedule.every5": "Every 5 minutes",
  "admin.jobs.schedule.hourly": "Every hour",
  "admin.jobs.schedule.daily": "Daily, 03:17 UTC",
  "admin.jobs.result.automations": "{ran, number} ran",
  "admin.jobs.result.emails": "{sent, number} sent",
  "admin.jobs.result.webhooks": "{waiting, number} waiting · {failing, number} failing",
  "admin.jobs.result.exports": "{made, plural, =0 {Nothing waiting} one {# export made} other {# exports made}}",
  "admin.jobs.result.hourly": "{copied, plural, =0 {Done} one {Done · # page’s text backed up} other {Done · # pages’ text backed up}}{waiting, plural, =0 {} other { · # waiting}}",
  "admin.jobs.result.retention": "{deleted, plural, one {# page deleted for good} other {# pages deleted for good}}",
  "admin.jobs.result.backup": "{size} · {tables, plural, one {# table} other {# tables}}{pages, plural, =0 {} one { · # page’s text} other { · # pages’ text}}{pagesWaiting, plural, =0 {} other { ({pagesWaiting, number} still to copy)}}",
  "admin.jobs.result.usage": "{near, plural, =0 {Everything under 80%} one {# near its limit} other {# near their limits}}",
  "admin.jobs.result.addresses": "{added, number} added · {removed, number} removed · {failing, number} failing · {notPointing, number} not pointing here",
  "admin.backups.title": "Backups",
  "admin.backups.command": "Administration: backups",
  "admin.backups.now": "Back up now",
  "admin.backups.col.taken": "Taken",
  "admin.backups.col.database": "Database",
  "admin.backups.col.files": "Files",
  "admin.backups.col.download": "Download",
  "admin.backups.download": "Download",
  "admin.backups.downloadFor": "Download the backup of {when}",
  "admin.backups.manifest": "manifest of {size}",
  "admin.backups.none": "No backups yet: the first is taken tonight.",
  "admin.backups.unavailable": "Backups need the files bucket (R2), which this installation does not have.",
  "admin.backups.help": "The database is exported to the files bucket each night, kept 30 days; files are listed, not copied (R2 keeps them). Restoring: point-in-time from Cloudflare (D1 Time Travel, 30 days), as the self-hosting guide explains.",
  "admin.restore.title": "Restore a page",
  "admin.restore.intro": "A page’s text as one of its backup copies kept it. Its current text is kept as a version first, so a restore can be undone from its Page history.",
  "admin.restore.page": "Page",
  "admin.restore.pageHelp": "Its title, or its ID; any workspace.",
  "admin.restore.matches": "Pages",
  "admin.restore.where": "· {workspace} · last edited {edited}",
  "admin.restore.none": "This page has no backup copies yet.",
  "admin.restore.button": "Restore this copy…",
  "admin.restore.confirmTitle": "Restore “{title}”?",
  "admin.restore.confirmBody": "Its text becomes its copy of {date}, for everyone. Its text as it is now is kept as a version in its Page history; restoring is in its workspace’s audit log.",
  "admin.restore.confirm": "Restore",
  "admin.restore.done": "“{title}” restored. Its text as it was is kept in its Page history.",
  "admin.search.title": "Content search",
  "admin.search.command": "Administration: content search",
  "admin.search.command.focus": "Search content",
  "admin.search.intro": "For investigating abuse or a legal request. Each search, and each page opened, is written to the audit log with your reason, for each workspace it reaches.",
  "admin.search.query": "Search for",
  "admin.search.scope": "Workspace",
  "admin.search.scopeList": "Workspaces",
  "admin.search.scopeHelp": "Leave it empty to search every workspace.",
  "admin.search.reason": "Reason",
  "admin.search.submit": "Search",
  "admin.search.error.query": "Type at least 2 characters to search for.",
  "admin.search.error.reason": "Give the reason for this search.",
  "admin.search.error.scope": "Choose a workspace from the list, or leave the field empty.",
  "admin.search.count": "{count, plural, =0 {No pages found.} one {# page found.} other {# pages found.}}",
  "admin.search.none": "No pages match.",
  "admin.search.results": "Pages found",
  "admin.search.col.page": "Page",
  "admin.search.col.workspace": "Workspace",
  "admin.search.col.owner": "Owner",
  "admin.search.col.edited": "Last edited",
  "admin.search.col.open": "Open",
  "admin.search.open": "Open read-only",
  "admin.search.openFor": "Open read-only: {title}",
  "admin.search.note": "Passages show where the words are; matches in blocks with permissions of their own are not searched.",
  "admin.search.readOnly": "Read-only, as written. Everything on the page is shown, including blocks only some people can see; those are marked.",
  "admin.search.document": "{title}, read-only",
  "admin.search.matches": "Matches",
  "admin.search.flag.restricted": "Restricted: only {people} can see this",
  "admin.search.flag.restrictedSome": "Restricted: only some people can see this",
  "admin.search.flag.others": "{count, plural, one {# other} other {# others}}",
  "admin.search.flag.shared": "Shared with more people than the page",
  "admin.search.flag.hiddenPhones": "Hidden on phones",
  "admin.search.flag.hiddenScreens": "Hidden on some screens",
  "admin.search.flag.shownFrom": "Shown from {date}",
  "admin.search.flag.hiddenFrom": "Hidden from {date}",
  "admin.search.flag.shownConditions": "Shown only in some cases",
  "admin.search.flag.hiddenConditions": "Hidden in some cases",
  "admin.search.todoDone": "Done",
  "admin.search.todoOpen": "Not done",
  "admin.search.image": "Image — “{text}”",
  "admin.search.imageNoText": "Image without a description",
  "admin.search.file": "File: {name}",
  "admin.search.pageLink": "Link to the page “{title}”",
  "admin.search.syncedCopy": "Synced from “{title}”",
  "admin.search.button": "Button: {label}",
  "admin.search.toc": "Table of contents",
  "admin.search.empty": "This page has no text.",
  "admin.search.close": "Close",
  "admin.search.inRestricted": "Found in blocks with permissions of their own",
  "admin.settings.title": "Settings",
  "admin.settings.save": "Save changes",
  "admin.settings.saved": "Settings saved.",
  "admin.settings.category.localisation": "Localisation",
  "admin.nav": "Administration",
  "admin.settings.languagesElsewhere": "The interface's languages, and which of them users can choose, are managed in <link>Translations</link>.",
  "admin.settings.category.content": "Content",
  "admin.settings.category.authentication": "Authentication",
  "admin.settings.category.security": "Security",
  "admin.settings.category.branding": "Branding",
  "settings.i18n.enabledLocales.label": "Enabled interface languages",
  "settings.i18n.enabledLocales.help": "Languages users can choose for the interface.",
  "settings.i18n.defaultLocale.label": "Default interface language",
  "settings.i18n.defaultLocale.help": "Used when a user has no preference and their browser languages are not enabled. Must be one of the enabled languages.",
  "settings.i18n.minCompleteness.label": "Translation needed to offer a language (%)",
  "settings.i18n.minCompleteness.help": "A language is offered to users only when its published translations cover at least this share of the interface's messages.",
  "settings.comments.editWindowMinutes.label": "Minutes to edit a comment freely",
  "settings.comments.editWindowMinutes.help": "After posting, authors may edit their comment for this many minutes; later edits go to people with full access to the page for approval. 0: every edit needs approval. -1: no limit. Pages can set their own in the Share dialog.",
  "settings.auth.oauth.google.label": "Allow sign-in with Google",
  "settings.auth.oauth.google.help": "Requires GOOGLE_CLIENT_ID and GOOGLE_CLIENT_SECRET to be configured.",
  "settings.auth.oauth.microsoft.label": "Allow sign-in with Microsoft",
  "settings.auth.oauth.microsoft.help": "Requires MICROSOFT_CLIENT_ID and MICROSOFT_CLIENT_SECRET to be configured.",
  "settings.auth.oauth.github.label": "Allow sign-in with GitHub",
  "settings.auth.oauth.github.help": "Requires GITHUB_CLIENT_ID and GITHUB_CLIENT_SECRET to be configured.",
  "settings.auth.signUpMode.label": "Who can create an account",
  "settings.auth.signUpMode.help": "With invitations only, accounts come from links that administrators and workspace owners create. Open lets anyone create an account by confirming their address, with an email link or a sign-in provider (Google, Microsoft, GitHub); such accounts start as readers, with no workspace. Open needs one of those ways enabled.",
  "settings.auth.signUpMode.option.invite": "By invitation only",
  "settings.auth.signUpMode.option.open": "Open, for anyone who confirms their address",
  "settings.security.sessionAbsoluteDays.label": "Session lifetime (days)",
  "settings.security.sessionAbsoluteDays.help": "Users must sign in again after this many days, even if active.",
  "settings.security.sessionIdleDays.label": "Session idle timeout (days)",
  "settings.security.sessionIdleDays.help": "Sessions unused for this many days expire. Must not exceed the session lifetime.",
  "settings.branding.displayName.label": "Display name",
  "settings.branding.displayName.help": "Name shown in the interface and page titles.",
  "settings.addresses.subdomainApproval.label": "Approve new workspace addresses",
  "settings.addresses.subdomainApproval.help": "New workspaces, and renamed addresses, wait for an administrator before they answer.",
  "settings.addresses.reservedNames.label": "Reserved names",
  "settings.addresses.reservedNames.help": "Names no workspace address may use, nor anything that looks like them.",
  "admin.settings.category.usage": "Usage limits",
  "settings.limits.databaseGb.label": "Database limit (GB)",
  "settings.limits.databaseGb.help": "Cloudflare D1’s largest database is 10 GB. Administration → Usage measures against this.",
  "settings.limits.filesGb.label": "Files budget (GB)",
  "settings.limits.filesGb.help": "R2 has no limit of its own: the size of uploaded files and published sites you want to hear about.",
  "settings.limits.emailsPerDay.label": "Emails a day",
  "settings.limits.emailsPerDay.help": "Your email provider’s daily limit.",
  "settings.limits.webhooksPerDay.label": "Webhook deliveries a day",
  "settings.limits.webhooksPerDay.help": "How many deliveries a day you expect at most. Administrators are emailed once a day when anything reaches 80% of its limit.",
  "error.validation": "Please correct the highlighted fields.",
  "error.bad_token": "The setup token is not correct.",
  "error.setup_not_configured": "Setup is not configured on the server (PAGINAE_SETUP_TOKEN is missing).",
  "error.setup_complete": "Setup has already been completed.",
  "error.registration_failed": "The passkey could not be registered. Please try again.",
  "error.challenge_invalid": "This attempt expired. Please try again.",
  "error.invalid_credential": "Sign-in failed. Please try again.",
  "error.reauth_required": "For security, confirm it’s you first.",
  "error.unknown_provider": "That sign-in provider is not supported.",
  "error.provider_disabled": "That sign-in method is not enabled.",
  "error.state_mismatch": "The sign-in attempt expired or was tampered with. Please try again.",
  "error.provider_error": "The sign-in provider returned an error. Please try again.",
  "error.not_invited": "No account matches that sign-in. Ask an administrator for an invitation.",
  "error.account_disabled": "This account has been disabled.",
  "auth.reauth.confirm": "Confirm with passkey and save",
  "auth.passkey.inProgress": "Waiting for your passkey…",
  "admin.settings.saving": "Saving…",
  "admin.settings.sensitive": "Changing this requires confirming with your passkey.",
  "provider.google": "Google",
  "provider.microsoft": "Microsoft",
  "provider.github": "GitHub",
  "form.required": "Required",
  "settings.issue.not_enabled": "Choose one of the enabled languages.",
  "settings.issue.exceeds_lifetime": "Must not be longer than the session lifetime.",
  "settings.issue.invalid": "This value is not valid.",
  "settings.issue.duplicate": "Each option can only be chosen once.",
  "action.save": "Save",
  "action.cancel": "Cancel",
  "error.not_found.title": "Page not found",
  "error.not_found": "This page does not exist, or you do not have access to it.",
  "error.forbidden": "You do not have permission to do that.",
  "error.unauthenticated": "Your session has ended. Please sign in again.",
  "error.rate_limited": "Too many requests. Please wait a minute and try again.",
  "error.in_trash": "This page is in the trash. Restore it to make changes.",
  "error.not_in_trash": "This page is not in the trash.",
  "error.cycle": "A page cannot be moved inside itself or one of its sub-pages.",
  "error.too_deep": "Pages cannot be nested this deep.",
  "error.bad_sibling": "That position is no longer available. Please try again.",
  "error.no_such_person": "No account has that email address.",
  "error.no_such_group": "There is no such group.",
  "error.keep_full_access": "You would lose full access to this page. Give yourself full access another way first.",
  "error.expired": "That date has already passed.",
  "error.top_level": "A top-level page has no parent to inherit from.",
  "error.read_only_block": "You can only view that part of the page.",
  "error.comment_rate": "You can post one comment a minute. Please wait a moment.",
  "error.comments_off": "Comments are turned off for this page.",
  "error.comment_page_rate": "Many comments are being posted here just now. Please wait a moment.",
  "error.already_reported": "You have already reported this comment.",
  "error.anchor_behind": "The page changed while you were writing. Please try again.",
  "error.bad_comment": "This comment can't be saved: write something, up to 5,000 characters.",
  "error.bad_anchor": "Select some text in one paragraph to comment on it.",
  "error.sign_up_needs_provider": "Enable and configure sign-in with Google, Microsoft or GitHub first: open sign-up goes through them.",
  "error.has_account": "This email address already has an account. Share pages with it directly.",
  "home.noWorkspace": "Create a workspace to start writing. You will be its owner.",
  "home.reader": "You don't belong to a workspace. Pages shared with you are listed under “Shared with me”.",
  "home.groups": "Groups",
  "home.createWorkspace": "Create workspace",
  "workspace.name": "Workspace name",
  "workspace.icon": "Workspace icon",
  "workspace.language": "Language",
  "workspace.language.default": "The installation’s default: {language}",
  "workspace.language.help": "Top-level pages are in this language unless they have their own; the pages under them follow.",
  "workspace.language.change": "Change language…",
  "workspace.icon.help": "An emoji, shown next to the workspace name. Optional.",
  "workspace.home.intro": "Choose a page in the sidebar, or create one with the + buttons.",
  "workspace.home.private": "Pages in Private are visible only to you. Pages in the workspace section are shared with all its members.",
  "homeView.morning": "Good morning, {name}",
  "homeView.afternoon": "Good afternoon, {name}",
  "homeView.evening": "Good evening, {name}",
  "homeView.recents": "Recently visited",
  "homeView.visited": "Visited {when}",
  "homeView.newPage": "New page",
  "homeView.noRecents": "Pages you open show here.",
  "homeView.tasks": "My tasks",
  "homeView.noTasks": "Nothing assigned to you is waiting.",
  "homeView.taskDue": "{database} · due {due}",
  "homeView.taskNoDate": "{database} · no date",
  "homeView.tasksHelp": "Rows assigned to you, not done, from databases you can open.",
  "homeView.upcoming": "Upcoming",
  "homeView.noUpcoming": "Nothing in the next 7 days.",
  "homeView.upcomingHelp": "Dates in the next 7 days, from databases you can open.",
  "homeView.suggested": "Suggested",
  "homeView.editedBy": "— {name} edited it",
  "homeView.following": "You follow this page · {when}",
  "homeView.fromTemplate": "Start from a template",
  "homeView.startHelp": "Home can be the page the app opens on: Account → Editing → Start page and region.",
  "templates.open": "Templates…",
  "templates.title": "Templates",
  "templates.categories": "Template categories",
  "templates.category.all": "All templates",
  "templates.category.teaching": "Teaching",
  "templates.category.study": "Study",
  "templates.category.projects": "Projects",
  "templates.category.notes": "Notes & wiki",
  "templates.category.personal": "Personal",
  "templates.category.workspace": "This workspace’s",
  "templates.search": "Search templates",
  "templates.list": "Templates",
  "templates.noneHere": "No page here is offered as a template yet: choose “Offer as a template” in a page’s menu.",
  "templates.noMatch": "No template matches.",
  "templates.preview": "Preview",
  "templates.makes": "It makes, in your Private section:",
  "templates.use": "Use “{name}”",
  "templates.choose": "Choose a template",
  "templates.help": "Built in, or any page a workspace offers as a template. A copy is made in your Private section, with its sub-pages; databases inside a workspace’s template are linked, not copied.",
  "templates.used": "“{name}” is ready in Private.",
  "templates.workspaceDescription": "Offered by this workspace",
  "templates.coursePlan.name": "Course plan",
  "templates.coursePlan.description": "Lessons, readings and assessments, with a database of lessons",
  "templates.vocabulary.name": "Vocabulary list",
  "templates.vocabulary.description": "Words with their meaning, gender and tags",
  "templates.readingJournal.name": "Reading journal",
  "templates.readingJournal.description": "One page per book, with notes and quotes",
  "templates.projectTracker.name": "Project tracker",
  "templates.projectTracker.description": "Tasks by stage, with owners and due dates",
  "templates.meetingNotes.name": "Meeting notes",
  "templates.meetingNotes.description": "Agenda, notes and actions, dated",
  "templates.wiki.name": "Wiki",
  "templates.wiki.description": "A start page with topics below it",
  "templates.journal.name": "Journal",
  "templates.journal.description": "A dated entry a day, with your mood",
  "search.action.templates": "Templates…",
  "page.templateOn": "Offer as a template",
  "page.templateOff": "Stop offering as a template",
  "pageTemplate.templateAdded": "“{title}” is offered in the templates gallery.",
  "pageTemplate.templateRemoved": "“{title}” is no longer offered as a template.",
  "breadcrumb.pages": "Pages beside and inside “{name}”",
  "breadcrumb.beside": "Pages beside “{name}”",
  "breadcrumb.here": "here",
  "breadcrumb.inside": "Inside it",
  "sidebar.resize": "Resize the sidebar",
  "account.start.title": "Start page and region",
  "account.start.openOn": "Open the app on",
  "account.start.home": "Home",
  "account.start.last": "The last page I had open",
  "account.start.page": "A page I choose…",
  "account.start.whichPage": "Page",
  "account.start.pages": "Pages",
  "account.start.timeZone": "Time zone",
  "account.start.timeZones": "Time zones",
  "account.start.timeZoneHelp": "“Today” on Home and the dates of the next days follow it. Suggested from this device.",
  "account.start.thisDevice": "{zone} (this device)",
  "account.start.direction": "Text direction of pages",
  "account.start.directionAuto": "From the page’s language (left to right or right to left)",
  "account.start.directionLtr": "Left to right",
  "account.start.directionRtl": "Right to left",
  "account.start.saved": "Preferences saved.",
  "workspace.settings.title": "Workspace settings",
  "export.what": "What",
  "export.scope.page": "This page",
  "export.scope.subpages": "This page and its sub-pages",
  "export.scope.workspace": "The whole workspace “{workspace}”",
  "export.scope.workspaceWho": "owners and administrators",
  "export.comments": "Include comments and discussions",
  "export.files": "Include files and images",
  "export.scopeHelp": "Only pages you may export are included. A whole workspace is prepared in the background; you get a link in your inbox, kept for 7 days.",
  "export.queued": "The workspace is being exported. You will get a link in your inbox, kept for {days, plural, one {# day} other {# days}}.",
  "export.ready": "Your export of the whole workspace, asked for on “{page}”, is ready.",
  "export.download": "Download the export",
  "export.downloadHelp": "Only you can download it, for 7 days after it was made.",
  "export.discussionsHeading": "Discussions",
  "export.resolved": "resolved",
  "export.command.page": "Export: this page",
  "export.command.subpages": "Export: this page and its sub-pages",
  "export.command.workspace": "Export: the whole workspace",
  "export.command.commentsOn": "Export: include comments and discussions",
  "export.command.commentsOff": "Export: leave out comments and discussions",
  "export.command.filesOn": "Export: include files and images",
  "export.command.filesOff": "Export: leave out files and images",
  "export.command.run": "Export now",
  "workspace.security.title": "Security",
  "workspace.security.inviteMembers": "Who may invite members",
  "workspace.security.inviteMembers.admins": "Owners and administrators",
  "workspace.security.inviteMembers.members": "Members too",
  "workspace.security.inviteGuests": "Who may invite guests to pages",
  "workspace.security.inviteGuests.members": "Members",
  "workspace.security.inviteGuests.admins": "Owners and administrators",
  "workspace.security.inviteGuests.none": "No one",
  "workspace.security.movePages": "Members may move pages out of this workspace",
  "workspace.security.movePages.off": "Off: pages stay here; only owners and administrators move them to another workspace.",
  "workspace.security.movePages.on": "On: members with full access to a page may move it to another workspace they belong to.",
  "workspace.security.saved": "Security settings saved.",
  "workspace.security.command.inviteMembers.admins": "Only owners and administrators invite members",
  "workspace.security.command.inviteMembers.members": "Members may invite members too",
  "workspace.security.command.inviteGuests.members": "Members may invite guests to pages",
  "workspace.security.command.inviteGuests.admins": "Only owners and administrators invite guests to pages",
  "workspace.security.command.inviteGuests.none": "No one may invite guests to pages",
  "workspace.security.command.movePagesOn": "Let members move pages out of this workspace",
  "workspace.security.command.movePagesOff": "Keep pages in this workspace (only owners and administrators move them out)",
  "workspace.security.error.invite_members_off": "Only the workspace’s owners and administrators may invite members here.",
  "workspace.security.error.invite_guests_off": "You may not invite guests to this workspace’s pages: its owners say who may.",
  "workspace.security.error.move_out_off": "Pages may not be moved out of this workspace by members: its owners say who may.",
  "workspace.security.error.bad_domain": "That is not a domain name, such as example.com.",
  "workspace.security.error.public_domain": "Public email providers, such as gmail.com, outlook.com, yahoo.com, icloud.com or proton.me, cannot be used: anyone could join.",
  "workspace.security.error.domain_not_yours": "Your own email address must be at that domain to add it.",
  "workspace.security.error.domain_exists": "That domain is in the list already.",
  "workspace.security.error.too_many_domains": "A workspace has at most 20 domains.",
  "workspace.security.error.name_mismatch": "Type the workspace’s name exactly as it is to delete it.",
  "workspace.security.error.export_workspace_admins": "Only the workspace’s owners and administrators export the whole workspace.",
  "workspace.security.error.export_pending": "An export of this workspace is being prepared already; you will get its link in your inbox.",
  "workspace.security.error.purging": "This workspace is being deleted for good and cannot be restored.",
  "workspace.domains.title": "Join by email domain",
  "workspace.domains.intro": "People who sign in with a verified address at these domains join as {role, select, guest {guests} other {members}}, without an invitation.",
  "workspace.domains.help": "Your own address must be at the domain, unless you administer the installation. Public email providers are not accepted.",
  "workspace.domains.list": "Domains",
  "workspace.domains.none": "No domains yet.",
  "workspace.domains.field": "Add a domain",
  "workspace.domains.suggestions": "Domains of the workspace’s people",
  "workspace.domains.add": "Add",
  "workspace.domains.remove": "Remove {domain}",
  "workspace.domains.added": "{domain} added.",
  "workspace.domains.removed": "{domain} removed.",
  "workspace.domains.joinRole": "They join as",
  "workspace.domains.role.member": "Member",
  "workspace.domains.role.guest": "Guest",
  "workspace.domains.command.add": "Add an email domain whose people join this workspace",
  "workspace.domains.command.remove": "Remove the email domain {domain}",
  "workspace.domains.command.joinAs.member": "People who join by email domain are members",
  "workspace.domains.command.joinAs.guest": "People who join by email domain are guests",
  "workspace.delete.title": "Delete this workspace",
  "workspace.delete.body": "Its pages, databases, files and site go to the trash for 30 days, then are deleted for good. Members lose access at once.",
  "workspace.delete.confirm": "Type “{name}” to confirm",
  "workspace.delete.button": "Delete workspace",
  "workspace.delete.done": "“{name}” is in the trash. You can restore it for 30 days.",
  "workspace.delete.command": "Delete this workspace…",
  "workspace.delete.listTitle": "Deleted workspaces",
  "workspace.delete.listHelp": "Their owners can restore them, with their members, until they are deleted for good.",
  "workspace.delete.until": "Deleted for good on {date}",
  "workspace.delete.restore": "Restore",
  "workspace.delete.restoreName": "Restore {name}",
  "workspace.delete.restored": "“{name}” is back.",
  "workspace.delete.command.restore": "Restore the deleted workspace “{name}”",
  "workspace.settings.saved": "Workspace settings saved.",
  "sidebar.label": "Workspace",
  "sidebar.switcher": "Switch workspace",
  "sidebar.search": "Search",
  "sidebar.home": "Home",
  "sidebar.private": "Private",
  "sidebar.shared": "Shared",
  "sidebar.sharedWithMe": "Shared with me",
  "sidebar.teamspaces": "Teamspaces",
  "sidebar.teamspaceSettings": "Settings of {name}",
  "sidebar.archive": "Archive",
  "sidebar.trash": "Trash",
  "sidebar.settings": "Settings",
  "sidebar.empty": "No pages yet.",
  "sidebar.moved": "“{title}” moved.",
  "sidebar.hide": "Hide the sidebar ({keys})",
  "sidebar.show": "Show the sidebar ({keys})",
  "sidebar.addPageIn": "Add a page in {section}",
  "page.untitled": "New page",
  "page.title": "Page title",
  "page.breadcrumbs": "Breadcrumb",
  "page.actions": "Page actions",
  "page.actionsFor": "Actions for {title}",
  "page.addSubpage": "Add a page inside",
  "page.rename": "Rename",
  "page.duplicate": "Duplicate",
  "page.duplicated": "“{title}” duplicated.",
  "page.moveTo": "Move to…",
  "page.moveToWorkspace": "Move to another workspace…",
  "page.moveToWorkspaceOff": "Off in {workspace}: only owners and administrators move pages out.",
  "page.moveToWorkspaceGuest": "Off for guests in {workspace}: they do not move its pages out.",
  "page.moveUp": "Move up",
  "page.moveDown": "Move down",
  "page.movedUp": "“{title}” moved up.",
  "page.movedDown": "“{title}” moved down.",
  "page.moveToTrash": "Move to trash",
  "page.trashed": "“{title}” was moved to the trash.",
  "page.moved": "“{title}” was moved to {to}.",
  "page.history": "Page history",
  "page.export": "Export",
  "page.languageMenu": "Language…",
  "page.backlinks": "{count, plural, one {# backlink} other {# backlinks}}",
  "page.lock": "Lock page",
  "page.unlock": "Unlock page",
  "page.lockedDone": "Page locked.",
  "page.fullWidth": "Use full width",
  "page.narrow": "Use narrow width",
  "page.fullWidthDone": "Page shown full width.",
  "page.narrowDone": "Page shown narrow.",
  "page.unlockedDone": "Page unlocked.",
  "page.lockedBanner": "This page is locked: nobody can edit it until it is unlocked.",
  "page.archive": "Archive",
  "page.archived": "“{title}” was archived.",
  "page.unarchive": "Unarchive",
  "page.unarchived": "Page unarchived.",
  "page.archivedBanner": "This page is archived: it is not in the sidebar or search.",
  "page.archivedAncestor": "A page containing this one is archived, so this page is not in the sidebar or search.",
  "move.destination": "Destination",
  "move.submit": "Move",
  "move.topWorkspace": "Top level of the workspace",
  "move.topPrivate": "Top level of Private",
  "move.topTeamspace": "Top of {name}",
  "move.pageIn": "{title} ({section})",
  "move.sectionWorkspace": "workspace",
  "move.sectionPrivate": "Private",
  "move.sectionShared": "Shared",
  "moveWorkspace.title": "Move to another workspace",
  "moveWorkspace.summary": "<b>{title}</b>{pages, plural, =0 {} one { and its sub-page} other { and its # sub-pages}}{databases, plural, =0 {} one {, including a database and its rows} other {, including # databases and their rows}}.",
  "moveWorkspace.summaryDatabase": "<b>{title}</b> and its rows{pages, plural, =0 {} one {, with a sub-page} other {, with # sub-pages}}.",
  "moveWorkspace.field": "Workspace",
  "moveWorkspace.list": "Workspaces",
  "moveWorkspace.help": "Workspaces you are a member of. Not those you are a guest in.",
  "moveWorkspace.none": "You are not a member of any other workspace.",
  "moveWorkspace.changes": "What changes",
  "moveWorkspace.chosen": "the workspace you choose",
  "moveWorkspace.access": "Access given to everyone in {from} goes to everyone in {to}. Access given to its teamspaces is removed.",
  "moveWorkspace.people": "People and groups it was shared with keep their access.",
  "moveWorkspace.published": "Its published pages are unpublished: the site belongs to {from}.",
  "moveWorkspace.files": "Its files stay in {from}’s library, and still show on the pages.",
  "moveWorkspace.landWorkspace": "It goes to the end of {to}’s workspace section, where everyone in {to} has access to it.",
  "moveWorkspace.landWorkspaceNone": "It goes to the end of that workspace’s section, where everyone in it has access to it.",
  "moveWorkspace.landPrivate": "It goes to the end of your Private pages in {to}, and stays private.",
  "moveWorkspace.landPrivateNone": "It goes to the end of your Private pages there, and stays private.",
  "moveWorkspace.submit": "Move",
  "moveWorkspace.moved": "“{title}” was moved to {to}.",
  "moveWorkspace.offTitle": "Moving pages out is off",
  "moveWorkspace.off": "Only the owners and administrators of {workspace} move its pages to other workspaces. They can let members do it too, in the workspace’s settings, under Security.",
  "moveWorkspace.offGuest": "Guests in {workspace} do not move its pages to other workspaces. Ask one of its owners or administrators to move it.",
  "moveWorkspace.error.move_out_off": "Moving pages out of this workspace is off for you.",
  "moveWorkspace.error.too_many": "A page with 5,000 sub-pages or more is not moved. Move its sub-pages a few at a time.",
  "moveWorkspace.error.in_trash": "This page, or a page it is in, is in the trash. Restore it first.",
  "moveWorkspace.error.not_found": "The page or that workspace was not found, or you are not a member of it any more.",
  "history.title": "Page history",
  "history.empty": "No versions yet. A version is kept every ten minutes or so while the page is edited.",
  "history.versions": "Versions",
  "history.preview": "Version",
  "history.previewOf": "Version of {date}",
  "history.summary": "Compared with now: {changed, plural, one {# block changed} other {# blocks changed}}, {removed, plural, one {# deleted since} other {# deleted since}}, {added, plural, one {# added since} other {# added since}}.",
  "history.changed": "Changed since: ",
  "history.removed": "Deleted since: ",
  "history.someone": "someone",
  "history.image": "[Image]",
  "history.restore": "Restore this version",
  "history.restored": "Version restored. The page as it was is kept in its history.",
  "history.copies": "Backup copies",
  "history.copiesHelp": "Older copies of the page’s text, kept by the nightly backups.",
  "history.copy": "Backup copy",
  "history.copyOf": "Backup copy of {date}",
  "history.restoreCopy": "Restore this copy",
  "history.copyRestored": "Copy restored. The page as it was is kept in its history.",
  "export.title": "Export “{title}”",
  "export.format": "Format",
  "export.markdown": "Markdown",
  "export.html": "HTML",
  "export.run": "Export",
  "export.progress": "Exporting page {count}…",
  "export.done": "Exported.",
  "export.truncated": "Only the first {count} pages were exported.",
  "error.hidden_blocks": "Parts of this page are hidden from you or read-only, so you cannot restore a version.",
  "access.title": "No access to this page",
  "access.intro": "This page does not exist, or you do not have access to it. If it exists, you can ask the people who manage it for access.",
  "access.level": "Access you need",
  "access.level.can_view": "To read it",
  "access.level.can_comment": "To comment",
  "access.level.can_edit": "To edit it",
  "access.message": "Message (optional)",
  "access.request": "Request access",
  "access.sent": "Request sent. If the page exists, the people who manage it will be told.",
  "access.blocksTitle": "Blocks shared with you",
  "access.blocksIntro": "Parts of a page were shared with you. The rest of the page, and its title, are not.",
  "access.askMore": "Request access to the whole page",
  "shared.blocks": "Blocks shared with you",
  "teamspace.title": "Teamspaces",
  "teamspace.intro": "Teamspaces group pages for a team, with their own members. Open teamspaces can be read and joined by everyone in the workspace; closed ones are listed, and their owners add people; private ones are seen by their members only.",
  "teamspace.none": "There are no teamspaces yet.",
  "teamspace.summary": "{privacy} · {count, plural, one {# member} other {# members}}{role, select, owner { · You own it} member { · You are a member} other {}}{archived, select, true { · Archived} other {}}",
  "teamspace.join": "Join",
  "teamspace.joinNamed": "Join {name}",
  "teamspace.joined": "You joined {name}.",
  "teamspace.new": "New teamspace",
  "teamspace.name": "Name",
  "teamspace.description": "Description",
  "teamspace.create": "Create teamspace",
  "teamspace.created": "{name} was created.",
  "teamspace.privacy": "Who can find it",
  "teamspace.privacy.open": "Open",
  "teamspace.privacy.open.help": "everyone in the workspace can read it and join",
  "teamspace.privacy.closed": "Closed",
  "teamspace.privacy.closed.help": "listed; its owners add people",
  "teamspace.privacy.private": "Private",
  "teamspace.privacy.private.help": "only its members see it",
  "teamspace.memberLevel": "Members' access to its pages",
  "teamspace.saved": "Teamspace saved.",
  "teamspace.members": "Members",
  "teamspace.role.owner": "Owner",
  "teamspace.role.member": "Member",
  "teamspace.removeNamed": "Remove {name}",
  "teamspace.memberRemoved": "{name} was removed.",
  "teamspace.membersItems": "members of {name}",
  "teamspace.removeSelected": "Remove selected members",
  "teamspace.confirmRemoveSelected": "{count, plural, one {Remove # member from {name}?} other {Remove # members from {name}?}}",
  "teamspace.confirmRemoveSelectedBody": "They lose the access the teamspace gives them.",
  "teamspace.membersRemovedCount": "{count, plural, one {# member removed.} other {# members removed.}}",
  "teamspace.addByEmail": "Add someone from the workspace",
  "teamspace.addHelp": "Their email address. Guests of the workspace can be added too.",
  "teamspace.memberAdded": "{name} was added.",
  "teamspace.leave": "Leave teamspace",
  "teamspace.left": "You left {name}.",
  "teamspace.archive": "Archive teamspace",
  "teamspace.unarchive": "Restore teamspace",
  "teamspace.archived": "Teamspace archived: its pages left the sidebar.",
  "teamspace.unarchived": "Teamspace restored.",
  "error.last_owner": "There must always be an owner. Make someone else an owner first.",
  "archive.title": "Archive",
  "archive.intro": "Archived pages are kept out of the sidebar and search, with their sub-pages. They can still be opened, and unarchived by anyone who may edit them.",
  "archive.filter": "Filter by title",
  "archive.empty": "No pages are archived.",
  "archive.noMatch": "No archived pages match that title.",
  "archive.archivedBy": "Archived by {name} on {date}",
  "archive.unarchiveNamed": "Unarchive “{title}”",
  "archive.unarchivedNamed": "“{title}” was unarchived.",
  "archive.items": "archived pages",
  "archive.unarchiveSelected": "Unarchive selected pages",
  "archive.unarchivedCount": "{count, plural, one {# page unarchived.} other {# pages unarchived.}}",
  "trash.title": "Trash",
  "trash.intro": "Pages in the trash can be restored with their sub-pages, or deleted permanently.",
  "trash.filter": "Filter by title",
  "trash.empty": "The trash is empty.",
  "trash.noMatch": "No pages in the trash match that title.",
  "trash.deletedBy": "Deleted by {name} on {date}",
  "trash.restore": "Restore",
  "trash.deleteForever": "Delete permanently",
  "trash.confirmTitle": "Delete permanently?",
  "trash.confirmBody": "“{title}” and its sub-pages will be deleted permanently. This cannot be undone.",
  "trash.restored": "Page restored.",
  "trash.restoredNamed": "“{title}” was restored.",
  "trash.deletedNamed": "“{title}” was deleted permanently.",
  "trash.items": "pages in the trash",
  "trash.restoreSelected": "Restore selected pages",
  "trash.deleteSelected": "Delete selected pages permanently",
  "trash.confirmSelectedBody": "{count, plural, one {# page and its sub-pages} other {# pages and their sub-pages}} will be deleted permanently. This cannot be undone.",
  "trash.restoredCount": "{count, plural, one {# page restored.} other {# pages restored.}}",
  "trash.deletedCount": "{count, plural, one {# page deleted permanently.} other {# pages deleted permanently.}}",
  "trash.banner": "This page is in the trash.",
  "trash.bannerAncestor": "A page containing this one is in the trash. Restore it from the trash to edit this page.",
  "editor.todo.checked": "Done",
  "editor.todo.unchecked": "Not done",
  "editor.toggle.expand": "Show contents",
  "editor.toggle.collapse": "Hide contents",
  "editor.connecting": "Connecting…",
  "editor.offline": "Offline. Reconnecting… Editing resumes when the connection is back.",
  "editor.rejected": "Some changes could not be saved: {reason}. The page now shows the latest saved version.",
  "editor.unsaved": "Not saved yet. Retrying…",
  "editor.reason.readOnly": "this block is read-only for you",
  "editor.reason.tooLarge": "too large to send at once",
  "editor.reason.changed": "the page changed meanwhile",
  "editor.reason.invalid": "not valid on this page",
  "editor.reason.lost": "the connection was lost",
  "editor.label": "Page content",
  "editor.slash.menu": "Blocks",
  "editor.media.group": "Media",
  "editor.media.video": "Video",
  "editor.media.video.keywords": "movie film clip mp4 youtube vimeo loom",
  "editor.media.video.hint": "Upload or embed a video",
  "editor.media.audio": "Audio",
  "editor.media.audio.keywords": "sound music recording mp3 podcast",
  "editor.media.audio.hint": "Upload a sound file",
  "editor.media.file": "File",
  "editor.media.file.keywords": "attachment upload download document",
  "editor.media.file.hint": "Any file, to download",
  "editor.media.pdf": "PDF",
  "editor.media.pdf.keywords": "document viewer",
  "editor.media.pdf.hint": "Shown in the page",
  "editor.media.videoDialog": "Add a video",
  "editor.media.videoHelp": "A YouTube, Vimeo or Loom link, shown once each reader allows it; or upload a video file.",
  "editor.media.videoUnsupported": "Use a link to a video on YouTube, Vimeo or Loom, or upload a video file.",
  "editor.media.uploadVideo": "Upload a video file…",
  "editor.media.uploading": "Uploading {name}…",
  "editor.media.added": "{name} added.",
  "editor.media.caption": "Caption",
  "editor.media.captionPlaceholder": "Add a caption",
  "editor.media.captionMenu": "Caption",
  "editor.media.captionCommand": "Add or edit this block's caption",
  "editor.media.download": "Download",
  "editor.media.downloadName": "Download {name}",
  "editor.media.downloadMenu": "Download",
  "editor.media.downloadCommand": "Download this block's file",
  "editor.media.fullScreen": "Full screen",
  "editor.media.fullScreenName": "Show {name} in full screen",
  "editor.media.noViewer": "This browser does not show PDFs in pages: download it to read it.",
  "editor.media.missing": "This file is not available: it was deleted from the workspace's files, or you may not see it.",
  "editor.media.resize": "Width of the video",
  "editor.media.insert.video": "Insert a video",
  "editor.media.insert.audio": "Insert a sound",
  "editor.media.insert.file": "Insert a file",
  "editor.media.insert.pdf": "Insert a PDF",
  "editor.media.type.image": "Image",
  "editor.media.type.video": "Video",
  "editor.media.type.audio": "Sound",
  "editor.media.type.pdf": "PDF document",
  "editor.media.type.word": "Word document",
  "editor.media.type.document": "Document",
  "editor.media.type.spreadsheet": "Spreadsheet",
  "editor.media.type.presentation": "Presentation",
  "editor.media.type.ebook": "E-book",
  "editor.media.type.archive": "Archive",
  "editor.media.type.text": "Text",
  "editor.media.type.file": "File",
  "editor.media.filesKind": "{kind} · {size}",
  "editor.media.tooLarge": "Files can be up to 10 MB: {name} is larger.",
  "editor.media.unsupported.video": "{name} is not a video this page can play: use an MP4, WebM, Ogg or QuickTime file.",
  "editor.media.unsupported.audio": "{name} is not a sound this page can play: use an MP3, M4A, AAC, Ogg, WAV, FLAC or WebM file.",
  "editor.media.unsupported.pdf": "{name} is not a PDF.",
  "editor.media.unsupported.file": "This kind of file cannot be uploaded: programs, scripts, HTML and SVG never can, and documents must be what their names say ({name}).",
  "editor.code.wrap": "Wrap lines",
  "editor.code.caption": "Caption",
  "editor.code.captionField": "Code caption",
  "editor.code.copy": "Copy",
  "editor.code.copied": "Code copied.",
  "editor.code.wrapOn": "Long lines now wrap.",
  "editor.code.wrapOff": "Long lines now scroll.",
  "editor.code.wrapMenuOn": "Wrap lines",
  "editor.code.wrapMenuOff": "Don't wrap lines",
  "editor.code.wrapCommandOn": "Wrap lines in this code",
  "editor.code.wrapCommandOff": "Stop wrapping lines in this code",
  "editor.code.captionMenu": "Caption",
  "editor.code.captionCommand": "Add or edit the code's caption",
  "editor.slash.empty": "No results",
  "editor.slash.results": "{count, plural, one {# result} other {# results}}",
  "editor.slash.text": "Text",
  "editor.slash.text.keywords": "paragraph plain",
  "editor.slash.heading": "Heading {level}",
  "editor.slash.heading.keywords": "heading subheading",
  "editor.slash.bulleted": "Bulleted list",
  "editor.slash.bulleted.keywords": "bullet unordered ul",
  "editor.slash.numbered": "Numbered list",
  "editor.slash.numbered.keywords": "number ordered ol",
  "editor.slash.todo": "To-do list",
  "editor.slash.todo.keywords": "todo checkbox task",
  "editor.slash.toggle": "Toggle list",
  "editor.slash.toggle.keywords": "collapse expand details",
  "editor.slash.quote": "Quote",
  "editor.slash.quote.keywords": "blockquote citation",
  "editor.slash.callout": "Callout",
  "editor.slash.callout.keywords": "note tip highlight",
  "editor.slash.code": "Code",
  "editor.slash.code.keywords": "snippet pre program",
  "editor.slash.divider": "Divider",
  "editor.slash.divider.keywords": "line separator hr rule",
  "editor.slash.blockEquation": "Block equation",
  "editor.slash.blockEquation.keywords": "math equation latex tex formula katex",
  "editor.slash.inlineEquation": "Inline equation",
  "editor.slash.inlineEquation.keywords": "math equation latex tex formula katex inline",
  "editor.slash.toc": "Table of contents",
  "editor.slash.toc.keywords": "contents toc headings outline",
  "editor.slash.breadcrumb": "Breadcrumb",
  "editor.slash.breadcrumb.keywords": "breadcrumb path location parents",
  "editor.equation.edit": "Edit equation:",
  "editor.equation.new": "New equation",
  "editor.equation.dialog": "Equation",
  "editor.equation.latex": "LaTeX",
  "editor.equation.help": "For example x^2 + y^2 = z^2, or \\frac{a}{b}. Inside text, type $$x^2$$ to add one.",
  "editor.equation.preview": "Preview",
  "editor.slash.table": "Table",
  "editor.slash.table.keywords": "table grid rows columns cells simple",
  "editor.slash.columns2": "2 columns",
  "editor.slash.columns2.keywords": "columns side by side layout two",
  "editor.slash.columns3": "3 columns",
  "editor.slash.columns3.keywords": "columns side by side layout three",
  "editor.columns.resize": "Resize column {n}",
  "editor.slash.tabs": "Tabs",
  "editor.slash.tabs.keywords": "tabs sections tabbed panels",
  "editor.slash.calendar": "Calendar",
  "editor.slash.calendar.keywords": "calendar schedule timetable availability week hours busy free",
  "editor.slash.calendar.hint": "A weekly schedule from a database, or availability from your calendars",
  "editor.slash.alternatives": "Alternatives",
  "editor.slash.alternatives.keywords": "alternatives options conditions variants conditional personalised",
  "editor.slash.alternatives.hint": "Options of which each reader sees one, chosen by conditions",
  "editor.tabs.list": "Tabs",
  "editor.tabs.add": "Add a tab",
  "editor.tabs.options": "Options of the tab “{label}”",
  "editor.tabs.untitled": "Tab {n}",
  "editor.tabs.rename": "Rename…",
  "editor.tabs.renameTitle": "Rename the tab",
  "editor.tabs.name": "Name",
  "editor.tabs.moveBefore": "Move before",
  "editor.tabs.moveAfter": "Move after",
  "editor.tabs.delete": "Delete the tab",
  "editor.tabs.renamed": "Tab renamed",
  "editor.tabs.moved": "Tab moved",
  "editor.tabs.deleted": "Tab deleted",
  "editor.slash.synced": "Synced block",
  "editor.slash.synced.keywords": "synced sync shared reuse transclusion copy",
  "editor.synced.original": "Synced block",
  "editor.synced.copy": "Copy and sync",
  "editor.synced.copied": "Copied. Paste it into any page to show these blocks there too.",
  "editor.synced.copyFailed": "Could not copy. Allow this site to use the clipboard and try again.",
  "editor.synced.from": "Synced from {title}",
  "editor.synced.loading": "Loading the synced block…",
  "editor.synced.unavailable": "The original of this synced block is not available to you, or no longer exists.",
  "editor.synced.goToOriginal": "Go to the original",
  "editor.synced.unsync": "Unsync",
  "editor.synced.unsynced": "Unsynced: these are now ordinary blocks.",
  "editor.slash.button": "Button",
  "editor.slash.button.keywords": "button action automate press click",
  "editor.slash.templateButton": "Template button",
  "editor.slash.templateButton.keywords": "template button repeat insert blocks",
  "button.untitled": "New button",
  "button.templateLabel": "Add a new item",
  "button.settings": "Settings of the button “{label}”",
  "button.template": "Blocks it inserts",
  "button.title": "Button",
  "button.label": "Label",
  "button.actions": "When pressed",
  "button.noActions": "It does nothing yet: add what it does.",
  "button.addAction": "Add an action",
  "button.kind.insert": "Insert blocks",
  "button.kind.addPage": "Add a page to a database",
  "button.kind.editPages": "Edit pages in a database",
  "button.kind.notify": "Notify people",
  "button.kind.open": "Open a page or link",
  "button.kind.editThis": "Set this page’s properties",
  "button.kind.email": "Send an email",
  "button.kind.webhook": "Call a webhook",
  "button.value.checked": "{name}: checked",
  "button.noProperties": "This page has no properties to set yet.",
  "button.emailPeople": "Email (at most {max})",
  "button.subject": "Subject",
  "button.emailHelp": "Sent in the name of whoever pressed it, with a link to the page; only to people who may open it.",
  "button.webhookUrl": "Address (https://)",
  "button.webhookSends": "Sends the page’s title and address, and these properties",
  "button.webhookHelp": "Sent only to public HTTPS addresses, as automations’ webhooks are.",
  "button.moveUp": "Move action {n} up",
  "button.moveDown": "Move action {n} down",
  "button.removeAction": "Remove action {n}",
  "button.place": "Where",
  "button.place.below": "Below the button",
  "button.place.top": "At the top of the page",
  "button.place.bottom": "At the bottom of the page",
  "button.database": "Database",
  "button.pageTitle": "Title of the new page",
  "button.filter": "Which pages…",
  "button.allPages": "Every page you may edit.",
  "button.filtered": "Pages that meet {n, plural, one {# condition} other {# conditions}}.",
  "button.value.add": "Set a property",
  "button.value.choose": "Choose…",
  "button.value.label": "Value of {name}",
  "button.value.remove": "Remove {name}",
  "button.value.usePresser": "The person who presses it",
  "button.value.useToday": "The day it is pressed",
  "button.value.presser": "The person who presses it",
  "button.value.today": "The day it is pressed",
  "button.people": "People (at most {max})",
  "button.message": "Message",
  "button.page": "A page",
  "button.link": "Or a link",
  "button.asks": "Ask before doing it",
  "button.confirm": "Question",
  "button.confirmDefault": "Are you sure?",
  "button.continue": "Continue",
  "button.saved": "Button saved",
  "button.ran": "Done",
  "button.partly": "Done, except: {failed}. You may not have permission for it.",
  "button.error.database": "Choose a database for each database action.",
  "button.error.people": "Choose at least one person to notify.",
  "button.error.link": "Choose a page, or enter a link that starts with https://.",
  "button.error.subject": "Give each email a subject.",
  "button.error.webhook": "Enter a webhook address that starts with https://.",
  "editor.slash.bookmark": "Web bookmark",
  "editor.slash.bookmark.keywords": "bookmark link preview card url web",
  "editor.slash.embed": "Embed",
  "editor.slash.embed.keywords": "embed video youtube vimeo figma loom codepen spotify miro iframe",
  "editor.link.url": "Link",
  "editor.link.add": "Add",
  "editor.bookmark.dialog": "Web bookmark",
  "editor.bookmark.help": "The page's title and description are shown, with a link to it.",
  "editor.embed.dialog": "Embed",
  "editor.embed.help": "A link from YouTube, Vimeo, Loom, Figma, CodePen, Spotify or Miro.",
  "editor.embed.unsupported": "This link is not from a provider that can be embedded. Try a web bookmark instead.",
  "editor.embed.open": "Open on {provider}",
  "error.unreachable_link": "That link could not be read. Check it, or add it as a plain link.",
  "editor.code.diagram": "Diagram drawn from the code above",
  "editor.find.label": "Find in page",
  "editor.find.find": "Find in page",
  "editor.find.none": "No matches",
  "editor.find.count": "{current} of {count}",
  "editor.find.previous": "Previous",
  "editor.find.next": "Next",
  "editor.find.replaceWith": "Replace with",
  "editor.find.replace": "Replace",
  "editor.find.replaceAll": "Replace all",
  "editor.command.find": "Find in page",
  "editor.command.wordCount": "Word count",
  "editor.stats.title": "Word count",
  "editor.stats.words": "Words",
  "editor.stats.characters": "Characters",
  "editor.stats.charactersNoSpaces": "Characters without spaces",
  "editor.stats.reading": "Reading time",
  "editor.stats.minutes": "{count, plural, =0 {none} one {# minute} other {# minutes}}",
  "editor.preview.empty": "This page has no text yet.",
  "editor.toc.floating": "On this page",
  "editor.table.toolbar": "Table ({keys} from a cell)",
  "editor.table.rowAbove": "Row above",
  "editor.table.rowBelow": "Row below",
  "editor.table.columnLeft": "Column left",
  "editor.table.columnRight": "Column right",
  "editor.table.deleteRow": "Delete row",
  "editor.table.deleteColumn": "Delete column",
  "editor.table.merge": "Merge cells",
  "editor.table.split": "Split cell",
  "editor.table.headerRow": "Header row",
  "editor.table.headerColumn": "Header column",
  "editor.table.deleteTable": "Delete table",
  "editor.toc.label": "Table of contents",
  "editor.toc.empty": "Add headings to see them here.",
  "editor.block.add": "Add a block below",
  "editor.block.addAbove": "Add block above",
  "editor.block.addBelow": "Add block below",
  "editor.block.addHint": "Click to add below · {alt}-click to add above",
  "editor.block.actions": "Drag to move, or open block actions",
  "editor.block.menu": "Block actions",
  "editor.block.delete": "Delete",
  "editor.block.comment": "Comment",
  "editor.block.permissions": "Permissions…",
  "editor.block.ownPermissions": "Has its own permissions",
  "editor.block.duplicate": "Duplicate",
  "editor.block.moveUp": "Move up",
  "editor.block.moveDown": "Move down",
  "editor.block.turnInto": "Turn into",
  "editor.block.deleted": "Block deleted. Press {undo} to undo.",
  "editor.block.duplicated": "Block duplicated",
  "editor.block.movedUp": "Block moved up",
  "editor.block.movedDown": "Block moved down",
  "editor.presence": "Also on this page",
  "editor.help": "Type / to add a block, [[ to link a page and @ to mention someone. Press {blockMenu} for the current block's actions, {moveUp} or {moveDown} to move it.",
  "statusBar.label": "Status",
  "editor.vim.help": "Vim keys are on: press Escape for Normal mode and i to type again. In Normal mode, Tab leaves the page's text.",
  "editor.vim.panel": "Vim",
  "editor.vim.mode.normal": "Normal",
  "editor.vim.mode.insert": "Insert",
  "editor.vim.mode.replace": "Replace",
  "editor.vim.mode.visual": "Visual",
  "editor.vim.mode.visual_line": "Visual line",
  "editor.vim.mode.visual_block": "Visual block",
  "editor.vim.command": "Vim command",
  "editor.vim.search": "Vim search",
  "editor.vim.saved": "Pages are saved as you type: there is nothing to write.",
  "editor.headingSkipped": "Heading {level} follows {previous, select, 1 {the page title} other {Heading {previous}}}: a heading level is skipped.",
  "members.title": "Members",
  "members.name": "Name",
  "members.role": "Role",
  "members.actions": "Actions",
  "members.you": "(you)",
  "members.roleOf": "Role of {name}",
  "members.roleChanged": "{name} is now {role}.",
  "members.leave": "Leave workspace",
  "members.remove": "Remove {name}",
  "members.removeTitle": "Remove {name} from the workspace?",
  "members.removeBody": "They lose access to its pages, including pages they have open (within a minute). Their private pages stay in the workspace. You can invite them again later.",
  "members.removeConfirm": "Remove",
  "members.leaveTitle": "Leave {workspace}?",
  "members.leaveBody": "You lose access to its pages. To come back, an owner has to invite you again.",
  "members.removed": "{name} was removed from the workspace.",
  "members.left": "You left {workspace}.",
  "workspace.role.owner": "Workspace owner",
  "workspace.role.member": "Member",
  "workspace.role.membership_admin": "Membership admin",
  "workspace.role.guest": "Guest",
  "invites.title": "Invite people",
  "invites.help": "Pāginæ does not send email: create a link for someone's email address and send it to them yourself. Each link works once and expires after 7 days.",
  "invites.email": "Email address",
  "invites.create": "Create invite link",
  "invites.created": "Invite link created for {email}.",
  "invites.link": "Invite link for {email}",
  "invites.linkHelp": "Send it to them yourself. It works once and expires on {date}. It is shown only now: if it gets lost, revoke it and create a new one.",
  "invites.copy": "Copy link",
  "invites.copied": "Copied",
  "invites.copyFailed": "The link could not be copied. Select it and copy it yourself.",
  "invites.pending": "Pending invitations",
  "invites.expires": "expires {date}",
  "invites.revoke": "Revoke invitation for {email}",
  "invites.revoked": "The invitation for {email} was revoked.",
  "invites.items": "pending invitations",
  "invites.revokeSelected": "Revoke selected invitations",
  "invites.confirmRevokeTitle": "{count, plural, one {Revoke # invitation?} other {Revoke # invitations?}}",
  "invites.confirmRevokeBody": "{count, plural, one {Its link} other {Their links}} will stop working. This cannot be undone.",
  "invites.revokeConfirm": "Revoke",
  "invites.revokedCount": "{count, plural, one {# invitation revoked.} other {# invitations revoked.}}",
  "invite.invalidTitle": "Invitation not valid",
  "invite.invalid": "This invitation link has been used, has expired or was revoked. Ask the person who invited you for a new one.",
  "invite.title": "Join {workspace}",
  "invite.body": "{inviter} invited {email} to join as {role}.",
  "invite.readerBody": "{inviter} invited {email} to {app}, to read the pages shared with them.",
  "invite.someone": "Someone",
  "invite.expires": "The invitation expires on {date}.",
  "invite.join": "Join {workspace}",
  "invite.otherAccount": "You're signed in as {current}, but this invitation is for {email}. Sign out, then open the link again.",
  "invite.signInFirst": "{email} already has an account. Sign in to join.",
  "invite.signInAndJoin": "Sign in with a passkey and join",
  "invite.name": "Your name",
  "invite.email": "Email address",
  "invite.emailHelp": "The invitation is for this address, so it can't be changed.",
  "invite.createAndJoin": "Create a passkey and join",
  "error.already_member": "This person is already a member.",
  "error.invite_invalid": "This invitation link is not valid any more.",
  "error.invite_other_email": "This invitation is for a different email address.",
  "error.account_exists": "This email address already has an account. Sign in to accept the invitation.",
  "action.close": "Close",
  "selection.selectAll": "Select all",
  "selection.clearAll": "Clear all",
  "selection.bar": "Choose {items}",
  "selection.count": "{count, plural, one {# selected} other {# selected}}",
  "selection.item": "Select {name}",
  "selection.selectAllOf": "Select all {items}",
  "selection.clearOf": "Clear the selection of {items}",
  "selection.failed": "{count, plural, one {# could not be done} other {# could not be done}}: {error}",
  "selection.removeConfirm": "Remove",
  "files.title": "Files",
  "files.intro": "The images of this workspace's pages, each kept once, with its description and caption in each language. You see those you uploaded and those used on pages you may open.",
  "files.search": "Search files by name",
  "files.none": "No files yet. Images added to pages appear here.",
  "files.noneFound": "No file has that name.",
  "files.unnamed": "Unnamed image",
  "files.noDescription": "No description yet",
  "files.decorative": "Decorative",
  "files.choose": "Choose an image from files",
  "files.uploadInstead": "Upload an image instead",
  "files.placed": "Image added.",
  "files.uploadedBy": "uploaded by {name}",
  "files.texts": "Description and caption",
  "files.editTexts": "Edit the name, description and caption…",
  "files.usedOn": "{count, plural, =0 {Not used on any page} one {Used on # page} other {Used on # pages}}",
  "files.usedElsewhere": "{count, plural, one {And # page you may not open.} other {And # pages you may not open.}}",
  "files.delete": "Delete file…",
  "files.confirm": "Delete this file for good? This cannot be undone.",
  "files.confirmUsed": "{count, plural, one {This file is used on # page.} other {This file is used on # pages.}} Delete it for good? Its blocks will say the file was deleted. This cannot be undone.",
  "files.deleteForGood": "Delete for good",
  "files.deleted": "{name} deleted.",
  "files.items": "files you may delete",
  "files.deleteSelected": "Delete selected files…",
  "files.confirmSelectedTitle": "{count, plural, one {Delete # file for good?} other {Delete # files for good?}}",
  "files.confirmSelected": "{count, plural, one {The file will be deleted for good.} other {The files will be deleted for good.}} This cannot be undone.",
  "files.confirmSelectedUsed": "{used, plural, one {# of them is used on pages.} other {# of them are used on pages.}} Their blocks will say the file was deleted. This cannot be undone.",
  "files.deletedCount": "{count, plural, one {# file deleted.} other {# files deleted.}}",
  "files.name": "Name",
  "files.nameHelp": "Keeps {extension} unless you type another image extension.",
  "files.details": "Details…",
  "files.rename": "Rename…",
  "files.renameTitle": "Rename file",
  "files.renameAction": "Rename",
  "files.renamed": "Renamed to {name}.",
  "files.contextMenu": "File {name}",
  "files.actionsFor": "Actions for {name}",
  "length.unit": "Unit of {field}",
  "length.units": "CSS units",
  "length.invalid": "Use a number and a unit, such as 12em or 40%.",
  "length.range": "This size is too small or too large here.",
  "length.perScreen": "Different on other screens…",
  "length.sameScreens": "Same on every screen",
  "length.screens": "{field} on other screens",
  "length.screensHelp": "Each applies from that screen width up. One left empty keeps the size before it.",
  "length.from": "From {width, number} px · {device}",
  "length.limits": "Limits…",
  "length.minWidth": "Min width",
  "length.maxWidth": "Max width",
  "breakpoint.sm": "large phones, landscape",
  "breakpoint.md": "tablets",
  "breakpoint.lg": "laptops",
  "breakpoint.xl": "desktops",
  "breakpoint.xxl": "large screens",
  "editor.image.minHelp": "None if empty.",
  "editor.image.maxHelp": "The width of the column or page if empty.",
  "editor.columns.column": "Column {n}",
  "editor.columns.minWidth": "Min width of column {n}",
  "editor.columns.maxWidth": "Max width of column {n}",
  "editor.columns.minHelp": "12rem if empty. Narrower than its minimum, a column goes to the next line.",
  "editor.columns.maxHelp": "The width of the row if empty.",
  "editor.columns.sideBySide": "Side by side",
  "editor.columns.sideBySideHelp": "Below the screen width chosen, the columns go one under another.",
  "editor.columns.sideBySide.room": "While each has room (as now)",
  "editor.columns.sideBySide.always": "Always",
  "style.minWidth": "Min text width",
  "style.minWidth.help": "None if empty. Never wider than the window.",
  "error.invalid_name": "Use 1 to 200 characters, without / or \\.",
  "error.invalid_extension": "Keep an extension of this kind of image.",
  "publish.button": "Publish",
  "page.preview": "Preview on devices",
  "page.previewAs": "Preview as {device}",
  "page.previewAsSomeone": "Preview as someone else…",
  "page.device.phone": "Phone",
  "page.device.largePhone": "Large phone, landscape",
  "page.device.tablet": "Tablet",
  "page.device.laptop": "Laptop",
  "page.device.desktop": "Desktop",
  "page.device.large": "Large screen",
  "page.device.custom": "Custom width",
  "preview.devices": "Device",
  "preview.option": "{device} · {width} px",
  "preview.width": "Width in pixels",
  "preview.widthInvalid": "A width from {min} to {max} pixels.",
  "preview.rotate": "Rotate",
  "preview.refresh": "Refresh",
  "preview.close": "Close the preview",
  "preview.turned": "{device}, rotated",
  "preview.summary": "{device} · {width} × {height} px · styled as for {band}.",
  "preview.summaryScaled": "{device} · {width} × {height} px · styled as for {band} (shown at {percent}%).",
  "preview.help": "As readers see it on the site, with what you may see of it. Read-only; edits show once saved.",
  "preview.frame": "The page on: {device}",
  "preview.hiddenFromThem": "A block hidden from them",
  "preview.hiddenFromYou": "A block you cannot see",
  "preview.seenBy": "Seen by",
  "preview.seenByList": "People, groups and roles",
  "preview.seenByHelp": "Someone, or a group or role: an imagined person who has only that.",
  "preview.me": "You",
  "preview.public": "Anyone on the web",
  "preview.signedIn": "Any signed-in person",
  "preview.role.owner": "Role: workspace owner",
  "preview.role.membership_admin": "Role: membership admin",
  "preview.role.member": "Role: workspace member",
  "preview.role.guest": "Role: guest",
  "preview.group": "Group: {name}",
  "preview.teamspaceOwner": "Teamspace owners: {name}",
  "preview.teamspaceMember": "Teamspace members: {name}",
  "preview.unknown": "Choose someone from the list.",
  "preview.asOf": "As of",
  "preview.asOfHelp": "Empty for now.",
  "preview.why": "Why?",
  "preview.whyTitle": "Why {name} sees this",
  "preview.level.full_access": "Full access",
  "preview.level.can_edit": "Can edit",
  "preview.level.can_edit_content": "Can edit content",
  "preview.level.can_comment": "Can comment",
  "preview.level.can_view": "Can view",
  "preview.level.no_access": "No access",
  "preview.seenSummary": "{name}{when, select, now {} other {, on {when}}} · {hidden, plural, =0 {nothing hidden from them} one {1 block hidden from them} other {# blocks hidden from them}}{yours, plural, =0 {} one {, 1 you cannot see} other {, # you cannot see}}.",
  "preview.reason.grant": "{level}: given to {principal} on {node}.",
  "preview.reason.inactive": "{level} for {principal} on {node} is not in force then (expired, or outside its schedule).",
  "preview.reason.scheduled": "{node} is hidden then by its scheduled visibility.",
  "preview.reason.restricted": "{node} has permissions of its own, so it is not published.",
  "preview.reason.none": "Nothing gives them access.",
  "preview.reason.notIncluded": "It has permissions of its own, which do not include them.",
  "preview.reason.published": "This page is published on the site.",
  "preview.reason.unpublished": "This page is not published, so no one on the web sees it.",
  "preview.itself": "It",
  "preview.hiddenTitle": "Hidden from them",
  "preview.hiddenNone": "Nothing on this page is hidden from them.",
  "preview.hiddenBlock": "“{text}”",
  "preview.hiddenBlockEmpty": "An empty block",
  "preview.thisPage": "this page",
  "preview.aBlock": "the block “{text}”",
  "preview.anAncestor": "“{title}”",
  "preview.principal.signed_in": "anyone signed in",
  "preview.principal.workspace": "everyone at {name}",
  "preview.principal.teamspace": "the teamspace {name}",
  "preview.principal.teamspace_owner": "the owners of {name}",
  "preview.principal.group": "the group {name}",
  "preview.principal.user": "{name}",
  "preview.notYours": "Not shown to you either: {count, plural, one {1 block} other {# blocks}} you cannot see.",
  "publish.title": "Publish to the web",
  "publish.extras.onSite": "On the site",
  "publish.extras.search": "Search box for visitors",
  "publish.extras.searchHelp": "For the whole site: its header gets a search box that finds its published pages. It is also in Site settings, under Header.",
  "publish.extras.searchOwners": "Only the workspace’s owners turn it on or off.",
  "publish.extras.searchSaved": "The site’s search box is saved, for every page.",
  "publish.extras.template": "“Duplicate as template”: signed-in people copy it into their workspace",
  "publish.extras.templateHelp": "The published page shows a “Duplicate as template” link. People signed in here copy what is published of it, and its published sub-pages, into a workspace they choose.",
  "publish.extras.templateSaved": "Duplicate as template saved.",
  "publish.extras.structured": "Describe it to search engines as",
  "publish.extras.structured.none": "Not described",
  "publish.extras.structured.article": "Article",
  "publish.extras.structured.course": "Course",
  "publish.extras.structured.webpage": "Web page (plain)",
  "publish.extras.structured.faq": "FAQ (from toggles)",
  "publish.extras.structuredHelp": "Structured data (JSON-LD) with its title, author, dates and cover.",
  "publish.extras.structuredFaqHelp": "Structured data (JSON-LD): each toggle is a question, and what is inside it the answer.",
  "publish.extras.structuredNoneHelp": "Search engines read the page itself; its author’s name is not given.",
  "publish.extras.structuredSaved": "How it is described to search engines is saved.",
  "publish.extras.embed": "Embed",
  "publish.extras.embedCode": "Embed code",
  "publish.extras.embedHelp": "Paste it into another website to show this page there, without the site’s header and footer.",
  "publish.extras.copyEmbed": "Copy embed code",
  "publish.extras.embedCopied": "Embed code copied.",
  "publish.extras.command.searchOn": "Turn on the site’s search box",
  "publish.extras.command.searchOff": "Turn off the site’s search box",
  "publish.extras.command.templateOn": "Offer this page as a template",
  "publish.extras.command.templateOff": "Stop offering this page as a template",
  "publish.extras.command.structured": "Describe this page to search engines as: {type}",
  "publish.extras.command.copyEmbed": "Copy this page’s embed code",
  "publish.extras.duplicateLink": "Duplicate as template",
  "publish.extras.templatePage.title": "Duplicate “{title}” as a template",
  "publish.extras.templatePage.intro": "A copy of what is published of this page, and of its published sub-pages, goes to your Private pages in the workspace you choose.",
  "publish.extras.templatePage.workspace": "Workspace",
  "publish.extras.templatePage.workspaces": "Your workspaces",
  "publish.extras.templatePage.duplicate": "Duplicate",
  "publish.extras.templatePage.command": "Duplicate this template into the workspace chosen",
  "publish.extras.templatePage.unknown": "Choose one of your workspaces.",
  "publish.extras.templatePage.none": "You are not in any workspace to copy it into yet.",
  "publish.extras.templatePage.back": "Back to the published page",
  "publish.columns.title": "Columns shown",
  "publish.columns.help": "The published table shows these columns, and always the rows’ names. Until you change them, they are those of the database’s first view. Columns only some people may see are never published.",
  "publish.columns.saved": "Columns shown saved.",
  "publish.columns.rows": "Publish its rows too",
  "publish.columns.rowsHelp": "Each row anyone may see becomes a page of its own under the database’s address, linked from the table (at most 100 rows).",
  "publish.columns.rowsSaved": "Its rows are published with it.",
  "publish.columns.rowsUndone": "Its rows are no longer published with it.",
  "publish.columns.command.rowsOn": "Publish this database’s rows too",
  "publish.columns.command.rowsOff": "Stop publishing this database’s rows",
  "publish.columns.command.show": "Show the column “{name}” on the published table",
  "publish.columns.command.hide": "Hide the column “{name}” from the published table",
  "publish.columns.summary": "{count, plural, one {# row} other {# rows}}, as published on {date}.",
  "publish.columns.filter": "Filter these rows",
  "publish.columns.showAs": "Show as",
  "publish.columns.layout.table": "Table",
  "publish.columns.layout.list": "List",
  "publish.columns.layout.gallery": "Gallery",
  "publish.columns.apply": "Filter",
  "publish.columns.match": "{shown} of {total} rows match “{q}”.",
  "publish.columns.note": "Each row is a page of its own when published with the database; only the properties chosen are shown.",
  "site.search.label": "Search this site",
  "site.search.title": "Search",
  "site.search.button": "Search",
  "site.search.results": "Results for “{q}”",
  "site.search.count": "{count, plural, one {# page} other {# pages}} found.",
  "site.search.none": "No published page matches “{q}”.",
  "site.search.empty": "Type a word or two to find the site’s pages.",
  "site.search.settingHelp": "Visitors find the site’s published pages with a search box in the header (shown even without the rest of the header). It is also in each page’s Publish dialog.",
  "publish.properties": "Properties shown",
  "publish.propertiesHelp": "None are shown until you switch them on, here, for this page.",
  "publish.propertiesSaved": "Properties shown saved.",
  "publish.noSite": "This workspace has no site yet. An instance administrator gives it an address in Administration → Sites.",
  "publish.toggle": "Publish on {site}",
  "publish.noPermission": "You cannot publish this page: publishing needs full access to it, and this installation or workspace may keep it to some people.",
  "publish.address": "Public address",
  "publish.open": "Open the published page",
  "publish.copied": "Address copied.",
  "publish.done": "The page is published. Anyone with the address can read it.",
  "publish.undone": "The page is no longer published.",
  "publish.liveHelp": "Changes you make appear on the published page within a minute. Hidden content and links to unpublished pages are left out.",
  "publish.isHome": "This is the home page of {site}: it also opens at the site's main address.",
  "publish.makeHome": "Make this the site's home page",
  "publish.homeSet": "This page is now the site's home page.",
  "publish.slug": "Address",
  "publish.slugHelpBefore": "The whole address after the domain. Left as it is, it follows the page’s title, under its parent page’s address.",
  "publish.asHome": "Make it the home page of {site}",
  "publish.beforeHelp": "Nothing is on the web until you publish: review these, then turn publishing on.",
  "publish.firstIsHome": "The first page published on the site is its home page. Nothing is on the web until you publish.",
  "publish.languageInPath": "Start with the page’s language where it changes (when the address follows the title)",
  "publish.languageInPathSaved": "Address saved.",
  "publish.slugHelpAuto": "The whole address after the domain. Left as it is, it follows the page’s title, under its parent page’s address.",
  "publish.slugHelpOwn": "Your own address, after the domain. Earlier addresses keep working, and sub-pages go under it.",
  "publish.slugSave": "Save address",
  "publish.slugFollowTitle": "Follow the title and parent page again",
  "publish.slugSaved": "Address saved. The earlier one redirects to it.",
  "publish.slugReset": "The address follows the title again.",
  "sites.title": "Sites",
  "sites.help": "Choose the address each workspace publishes its pages at. Removing an address takes all of that workspace's published pages off the web.",
  "sites.noHosts": "This installation serves no site addresses yet. Set the PAGINAE_SITE_HOSTS repository variable and deploy (see the self-hosting guide).",
  "sites.none": "No site",
  "sites.assigned": "{workspace} now publishes at {hostname}.",
  "sites.removed": "{workspace} has no site any more; its pages are off the web.",
  "error.no_site": "This workspace has no site yet.",
  "error.site_host_unknown": "This installation does not serve that address.",
  "error.site_host_taken": "Another workspace's site uses that address.",
  "error.not_published": "Publish the page first.",
  "error.slug_taken": "Another published page next to this one already has that address.",
  "error.slug_invalid": "Use at least one letter or digit.",
  "error.publish_failed": "The page could not be published. Please try again.",
  "security.nav": "Account",
  "security.title": "Sign-in and security",
  "security.passkeys.title": "Passkeys",
  "security.passkeys.help": "Each passkey signs you in on this site. Add one for every device or password manager you use, so losing one never locks you out.",
  "security.passkeys.onlyOne": "This is your only passkey. Add another, or create recovery codes, in case you lose it.",
  "security.passkey.unnamed": "Passkey added {date}",
  "security.passkey.meta": "Added {added} · last used {used}.",
  "security.passkey.neverUsed": "never",
  "security.passkey.synced": "Synced across devices.",
  "security.passkey.device": "On one device.",
  "security.passkey.name": "Name",
  "security.passkey.rename": "Rename",
  "security.passkey.renameLabel": "Rename {name}",
  "security.passkey.renamed": "Passkey renamed.",
  "security.passkey.remove": "Remove",
  "security.passkey.removeLabel": "Remove {name}",
  "security.passkey.removeTitle": "Remove “{name}”?",
  "security.passkey.removeBody": "It will no longer sign you in. Remove it from your device or password manager too.",
  "security.passkey.removeConfirm": "Remove passkey",
  "security.passkey.removed": "{name} removed.",
  "security.passkey.newName": "Name for a new passkey (optional)",
  "security.passkey.newNameHelp": "For example the device or password manager that will keep it.",
  "security.passkey.add": "Add a passkey",
  "security.passkey.added": "Passkey added.",
  "security.codes.title": "Recovery codes",
  "security.codes.help": "Each code signs you in once if you cannot use any passkey. Keep them somewhere safe, away from your devices, such as printed or in a password manager.",
  "security.codes.none": "You have no recovery codes.",
  "security.codes.status": "{remaining} of {total} codes left, created {date}.",
  "security.codes.create": "Create recovery codes",
  "security.codes.replace": "Create new codes (the old ones stop working)",
  "security.codes.created": "Recovery codes created. Save them now: they are shown only once.",
  "security.codes.once": "Save these codes now. They are shown only once.",
  "security.codes.listLabel": "Your recovery codes",
  "security.codes.copy": "Copy codes",
  "security.codes.copied": "Codes copied.",
  "security.codes.hide": "I have saved them",
  "account.nav": "Account",
  "account.editing.title": "Editing",
  "account.theme.title": "Appearance",
  "account.theme.system": "Follow this device",
  "account.theme.light": "Light",
  "account.theme.dark": "Dark",
  "account.theme.help": "Kept with your account, for every device.",
  "account.theme.saved": "Theme changed.",
  "account.vim.title": "Vim keys",
  "account.vim.help": "Edit pages with Vim's keys: modes, motions, operators, text objects, registers, marks, macros, searches and commands. Off unless you turn it on; it applies to the pages you open from now on.",
  "account.vim.toggle": "Use Vim keys when editing pages",
  "account.vim.on": "Vim keys are on.",
  "account.vim.off": "Vim keys are off.",
  "account.vim.reference": "Vim keys: the reference",
  "account.typing.title": "Typography",
  "account.typing.help": "Wherever you type: when you type an opening (a bracket, a quotation mark), its closing is added after the cursor, which stays inside; typing the closing just moves past it, and an opening typed over selected text wraps it. Backspace in an empty pair deletes both. In code, quotes stay straight.",
  "account.typing.quotes": "Turn straight quotes into typographic quotes, as the text's language writes them (“ ” ‘ ’, « », „ “…)",
  "account.typing.quotesOn": "Typographic quotes on",
  "account.typing.quotesOff": "Typographic quotes off",
  "account.typing.pairs": "Pairs closed as you type",
  "account.typing.open": "Opening",
  "account.typing.close": "Closing",
  "account.typing.on": "On",
  "account.typing.actions": "Actions",
  "account.typing.closes": "Close {name} as I type",
  "account.typing.delete": "Delete {name}",
  "account.typing.newOpen": "New opening",
  "account.typing.newClose": "Its closing",
  "account.typing.add": "Add the pair",
  "account.typing.added": "Pair added",
  "account.typing.deleted": "Pair deleted",
  "account.typing.pairOn": "Pair on",
  "account.typing.pairOff": "Pair off",
  "account.typing.duplicate": "There is a pair with that opening already.",
  "account.typing.invalid": "Each side takes one to three characters, without spaces.",
  "account.typing.defaults": "Back to the defaults",
  "account.typing.reset": "Typography back to the defaults",
  "account.typing.substitutions": "Text substitutions",
  "account.typing.subHelp": "Text you type anywhere in the app is replaced as soon as you finish typing it. Some come turned on: ... by …, and arrows such as -> by →, <-> by ↔ and => by ⇒; those stay as typed in code, where your own still apply. Backspace right after, before the cursor moves, puts back what you typed.",
  "account.typing.typed": "You type",
  "account.typing.replacement": "It becomes",
  "account.typing.replaces": "Replace {from} by {to}",
  "account.typing.newTyped": "Text you type",
  "account.typing.newReplacement": "Its replacement",
  "account.typing.cursorHelp": "Put {mark} where the cursor should go; two {mark} select the text between them. Without one, the cursor goes after the replacement.",
  "account.typing.putCursor": "Put the cursor here",
  "account.typing.subMarks": "A replacement takes at most two cursor marks: one for the cursor, or two around text to select.",
  "account.typing.addSub": "Add the substitution",
  "account.typing.subAdded": "Substitution added",
  "account.typing.subDeleted": "Substitution deleted",
  "account.typing.subOn": "Substitution on",
  "account.typing.subOff": "Substitution off",
  "account.typing.subDuplicate": "That text is replaced already.",
  "account.typing.subInvalid": "Type 1 to 20 characters, on one line, and a replacement of at most 200.",
  "vimHelp.title": "Vim keys",
  "vimHelp.intro": "Pāginæ can edit pages with the keys of the Vim editor. They are off unless you turn them on, in your account's editing settings.",
  "vimHelp.turnOn": "Turn Vim keys on or off",
  "vimHelp.contents": "Contents",
  "vimHelp.keys": "Keys",
  "vimHelp.does": "What they do",
  "vimHelp.modes.title": "Modes",
  "vimHelp.modes.intro": "The mode is shown below the page, and screen readers announce it when it changes.",
  "vimHelp.modes.normal": "Normal mode: keys are commands. Pages open in Normal mode.",
  "vimHelp.modes.insert": "Insert mode, to type: before or after the cursor, or at the start or end of the line.",
  "vimHelp.modes.open": "A new line below or above, in Insert mode.",
  "vimHelp.modes.visual": "Visual mode: select characters, whole lines or a block (a rectangle).",
  "vimHelp.modes.replace": "Replace mode: what you type replaces the characters under the cursor.",
  "vimHelp.modes.oneCommand": "In Insert mode, one Normal-mode command, then back to typing.",
  "vimHelp.modes.commandLine": "A command line, below the page (see Commands).",
  "vimHelp.modes.leave": "In Normal mode, leave the page's text for the rest of the page, as without Vim. :q does too.",
  "vimHelp.lines.title": "The title is the first line.",
  "vimHelp.lines.intro": "Vim sees the page as lines of text:",
  "vimHelp.lines.blocks": "Then every block is a line: paragraphs, headings, list items, quotes…",
  "vimHelp.lines.breaks": "A line break inside a block (Shift+Enter) and each line of a code block are lines too.",
  "vimHelp.lines.atoms": "Images, dividers and links to pages are empty lines: dd removes them, but nothing can be typed on them (text typed there goes in a new block before them).",
  "vimHelp.lines.split": "A new line (o, O, Enter in Insert mode) is a new block: lists go on as lists, other blocks are followed by a paragraph.",
  "vimHelp.lines.join": "Joining lines (J, or deleting the line break) joins their blocks: the second one's text moves to the end of the first.",
  "vimHelp.lines.nest": ">> and << nest a block in the one above, or take it out, as Tab and Shift+Tab do. In code, they indent by two spaces.",
  "vimHelp.motions.title": "Moving",
  "vimHelp.motions.hjkl": "Left, down, up, right (arrow keys too).",
  "vimHelp.motions.words": "Next word, back a word, end of the word, end of the previous word.",
  "vimHelp.motions.bigWords": "The same, by words that are separated only by spaces.",
  "vimHelp.motions.lineEnds": "Start of the line, first non-blank character, end of the line, last non-blank character.",
  "vimHelp.motions.lineNumbers": "First line, last line, line 5.",
  "vimHelp.motions.find": "To the next or previous given character on the line, or just before it. ; repeats, , repeats backwards.",
  "vimHelp.motions.bracket": "To the matching bracket.",
  "vimHelp.motions.paragraphs": "To the previous or next empty line (an empty block, image or divider).",
  "vimHelp.motions.sentences": "To the previous or next sentence.",
  "vimHelp.motions.screen": "To the top, middle or bottom of the window.",
  "vimHelp.motions.halfPage": "Half a window down or up.",
  "vimHelp.motions.page": "A window down or up.",
  "vimHelp.motions.scroll": "Scroll a line down or up.",
  "vimHelp.motions.centre": "Scroll so the cursor is in the middle, at the top or at the bottom.",
  "vimHelp.motions.displayLines": "Down or up a line as shown on screen, in long wrapped lines.",
  "vimHelp.motions.jumps": "Back or forward through the places you jumped to.",
  "vimHelp.editing.title": "Changing text",
  "vimHelp.editing.x": "Delete the character under or before the cursor.",
  "vimHelp.editing.lineOps": "Delete, change or copy (yank) the line.",
  "vimHelp.editing.toEnd": "Delete or change to the end of the line; copy the line.",
  "vimHelp.editing.operators": "Delete, change or copy as far as a motion goes: dw, c$, yip, d3j…",
  "vimHelp.editing.substitute": "Replace the character, or the whole line, and type.",
  "vimHelp.editing.r": "Replace the character under the cursor.",
  "vimHelp.editing.case": "Switch case, or make lower or upper case (with a motion: guw, gUU).",
  "vimHelp.editing.joinLines": "Join the line with the next one, with or without a space.",
  "vimHelp.editing.put": "Put (paste) after or before the cursor.",
  "vimHelp.editing.undo": "Undo, redo. :undo and :redo too; {undo} still works.",
  "vimHelp.editing.repeat": "Repeat the last change.",
  "vimHelp.editing.numbers": "Add 1 to, or take 1 from, the number under the cursor.",
  "vimHelp.editing.wrap": "Wrap long lines at the text width (:set textwidth=60); each wrapped line becomes a block.",
  "vimHelp.editing.counts": "A number before a command repeats it.",
  "vimHelp.insertKeys.title": "Keys in Insert mode",
  "vimHelp.insertKeys.intro": "Other keys type as without Vim, so the editor's own shortcuts (bold, links, /, @) still work.",
  "vimHelp.insertKeys.ctrlW": "Delete the word before the cursor (some browsers keep Ctrl+W for closing the tab).",
  "vimHelp.insertKeys.ctrlU": "Delete back to the start of the line.",
  "vimHelp.insertKeys.ctrlR": "Insert a register's text.",
  "vimHelp.insertKeys.ctrlT": "Nest the block, or take it out (in code: indent, outdent).",
  "vimHelp.insertKeys.ins": "Switch between Insert and Replace mode.",
  "vimHelp.objects.title": "Text objects",
  "vimHelp.objects.intro": "After an operator or in Visual mode: i is inside, a includes the surroundings (diw, ci\", va(, yap).",
  "vimHelp.objects.words": "A word.",
  "vimHelp.objects.sentences": "A sentence.",
  "vimHelp.objects.paragraphs": "A paragraph: lines up to an empty one.",
  "vimHelp.objects.quotes": "Text in quotes.",
  "vimHelp.objects.parens": "Text in brackets: round ones (ib, ab too), square, curly (iB, aB too) and angle ones.",
  "vimHelp.visual.title": "Visual mode",
  "vimHelp.visual.otherEnd": "Go to the other end of the selection.",
  "vimHelp.visual.reselect": "Select the last selection again.",
  "vimHelp.visual.ops": "Apply an operator to the selection.",
  "vimHelp.visual.block": "In a block selection, type at the start or end of every line in it.",
  "vimHelp.registers.title": "Registers",
  "vimHelp.registers.intro": "Text is deleted and copied into registers. Put \"a before a command to use register a: \"ayy, \"ap.",
  "vimHelp.registers.unnamed": "The last deleted or copied text (the default).",
  "vimHelp.registers.named": "Your own registers; \"A … \"Z add to them.",
  "vimHelp.registers.numbered": "The last copy, and the last deletions.",
  "vimHelp.registers.small": "The last deletion within a line.",
  "vimHelp.registers.clipboard": "The system clipboard (the browser may ask for permission to read it).",
  "vimHelp.registers.blackHole": "Deletes without keeping the text.",
  "vimHelp.registers.readOnly": "The last typed text, command and search.",
  "vimHelp.registers.list": "Show the registers.",
  "vimHelp.marks.title": "Marks",
  "vimHelp.marks.set": "Mark the cursor's place.",
  "vimHelp.marks.jump": "Go to the marked line, or the exact place. They work with operators: d'a.",
  "vimHelp.marks.back": "Back to where you were before the last jump.",
  "vimHelp.marks.special": "The last changed or put text, the last selection, the last change.",
  "vimHelp.marks.list": "Show or delete marks.",
  "vimHelp.macros.title": "Macros",
  "vimHelp.macros.record": "Record keys into a register.",
  "vimHelp.macros.play": "Play a register's keys, the last one again, or several times.",
  "vimHelp.search.title": "Searching",
  "vimHelp.search.intro": "Searches are JavaScript regular expressions. Every match is highlighted until Escape or :nohlsearch.",
  "vimHelp.search.find": "Search forward or backward; Enter goes to the match.",
  "vimHelp.search.next": "The next or previous match.",
  "vimHelp.search.word": "Search for the word under the cursor, forward or backward.",
  "vimHelp.search.history": "In the search or command line, earlier searches or commands.",
  "vimHelp.commands.title": "Commands",
  "vimHelp.commands.intro": "Type : then the command and Enter. Most take a range of lines: :%s (all lines), :2,5d, :'<,'> (the selection).",
  "vimHelp.commands.s": "Substitute: g for every match on a line, i to ignore case, c to confirm each one (y, n, a for all, q to stop).",
  "vimHelp.commands.g": "Run a command on every line that matches: :g/todo/d. :v for lines that do not.",
  "vimHelp.commands.normal": "Run Normal-mode keys on each line of the range: :%norm A;",
  "vimHelp.commands.lineCommands": "Delete, copy (yank), join lines; put a register below.",
  "vimHelp.commands.sort": "Sort lines (! reverses; i ignores case; n by number; u removes duplicates).",
  "vimHelp.commands.set": "Settings: ignorecase, smartcase, hlsearch, incsearch, textwidth… :set option? shows one.",
  "vimHelp.commands.map": "Key mappings (:nmap, :imap, :vmap…). They last until the page is reloaded.",
  "vimHelp.commands.w": "Pages save as you type: :w only says so.",
  "vimHelp.commands.q": "Leave the page's text.",
  "vimHelp.differences.title": "Differences from Vim",
  "vimHelp.differences.pages": "A page is not a text file: lines are blocks (see How a page becomes lines), and there are no files to open or write.",
  "vimHelp.differences.shortcuts": "{quickFind} and {quickFindToo} open Quick Find, {copy} copies a selection, and Tab leaves the text in Normal mode.",
  "vimHelp.differences.tags": "The tag objects it and at, folds (zc, zo), = (indenting by syntax) and spelling commands are not available.",
  "vimHelp.differences.session": "Settings and mappings last until the page is reloaded; registers and marks are kept while it is open.",
  "vimHelp.differences.ime": "In Normal mode, keys typed with an input method or dead keys are read as the character they produce.",
  "vimHelp.differences.others": "Other people editing the page at the same time see your changes as you make them.",
  "auth.recoveryCode.toggle": "Use a recovery code",
  "auth.recoveryCode.label": "Recovery code",
  "auth.recoveryCode.submit": "Sign in with this code",
  "recover.title": "Recover your account",
  "recover.body": "This link lets {name} ({email}) create a new passkey and sign in. Your other sessions will be signed out.",
  "recover.create": "Create a new passkey",
  "recover.invalidTitle": "Recovery link not valid",
  "recover.invalid": "This recovery link has expired, has been used, or was replaced by a newer one. Ask an administrator for a new one.",
  "people.title": "People",
  "people.help": "Everyone with an account. If someone lost every passkey and recovery code, create a recovery link for them: it lets whoever opens it add a passkey to that account, so send it only to them, privately.",
  "people.name": "Name",
  "people.passkeys": "Passkeys",
  "people.lastSeen": "Last active",
  "people.actions": "Actions",
  "people.createLink": "Create recovery link",
  "people.createLinkFor": "Create recovery link for {name}",
  "people.linkCreated": "Recovery link created for {name}.",
  "people.linkLabel": "Recovery link for {name}",
  "people.linkHelp": "Valid for 24 hours and for one use. Creating another replaces it.",
  "people.linkCopied": "Link copied.",
  "error.last_passkey": "Your last passkey cannot be removed.",
  "error.passkey_exists": "This passkey is already registered.",
  "error.recovery_link_invalid": "This recovery link is not valid any more.",
  "editor.slash.toggleHeading": "Toggle heading {level}",
  "editor.slash.toggleHeading.keywords": "toggle heading collapsible fold",
  "editor.block.changed": "Block changed.",
  "editor.block.current": "(current)",
  "editor.block.color": "Colour",
  "editor.block.align": "Alignment",
  "editor.align.left": "Left",
  "editor.align.center": "Centre",
  "editor.align.right": "Right",
  "editor.align.justify": "Justified",
  "editor.block.float": "Float",
  "editor.block.language": "Language…",
  "editor.float.none": "No float",
  "editor.float.left": "Float left",
  "editor.float.right": "Float right",
  "editor.float.clear": "Start below floating blocks",
  "editor.float.clearOn": "Start below floating blocks (on)",
  "editor.block.textColor": "Text colour",
  "editor.block.backgroundColor": "Background colour",
  "editor.color.default": "Default",
  "editor.color.gray": "Grey",
  "editor.color.brown": "Brown",
  "editor.color.orange": "Orange",
  "editor.color.yellow": "Yellow",
  "editor.color.green": "Green",
  "editor.color.blue": "Blue",
  "editor.color.purple": "Purple",
  "editor.color.pink": "Pink",
  "editor.color.red": "Red",
  "editor.block.toggleHeading": "Make it a toggle heading",
  "editor.block.plainHeading": "Make it a plain heading",
  "editor.block.quoteLarge": "Large quote",
  "editor.block.quoteDefault": "Normal-size quote",
  "editor.block.numbering": "Numbering",
  "editor.block.numbering.1": "Numbers (1, 2, 3)",
  "editor.block.numbering.a": "Letters (a, b, c)",
  "editor.block.numbering.i": "Roman numerals (i, ii, iii)",
  "editor.block.icon": "Icon",
  "editor.block.iconOther": "Other icon…",
  "editor.block.iconDialog": "Callout icon",
  "editor.block.iconLabel": "Emoji or character",
  "editor.slash.page": "Page",
  "editor.slash.page.keywords": "page subpage sub-page new",
  "editor.slash.linkPage": "Link to page",
  "editor.slash.linkedDatabase": "Linked view of database",
  "editor.slash.inlineDatabase": "Database – inline",
  "editor.slash.shortAnswer": "Short answer",
  "editor.slash.shortAnswer.keywords": "exercise question answer",
  "editor.slash.longAnswer": "Long answer",
  "editor.slash.longAnswer.keywords": "exercise question essay",
  "editor.slash.multipleChoice": "Multiple choice",
  "editor.slash.multipleChoice.keywords": "exercise question choice quiz",
  "editor.slash.blank": "Blank to fill in",
  "editor.slash.blank.keywords": "exercise gap cloze",
  "editor.slash.send": "Send answers",
  "editor.slash.send.keywords": "exercise submit",
  "editor.slash.linkPage.keywords": "link page reference",
  "editor.slash.linkedDatabase.keywords": "linked view database table board filter",
  "editor.slash.inlineDatabase.keywords": "database inline table new",
  "editor.linkPage.title": "Link to page",
  "editor.linkPage.search": "Search pages",
  "editor.linkPage.help": "Type to filter, then Tab to the list and Enter to choose.",
  "editor.linkPage.results": "Pages",
  "editor.linkPage.none": "No pages match.",
  "editor.linkedDatabase.title": "Linked view of database",
  "editor.linkedDatabase.search": "Search databases",
  "editor.linkedDatabase.results": "Databases",
  "editor.linkedDatabase.none": "No databases match.",
  "editor.mention.menu": "Mention",
  "editor.mention.empty": "No people, pages or dates match",
  "editor.emoji.menu": "Emoji",
  "editor.plus.menu": "Pages",
  "editor.plus.new": "New page “{title}” inside {parent}",
  "editor.plus.created": "Page “{title}” added here.",
  "editor.mention.person": "Person",
  "editor.mention.page": "Page",
  "editor.wiki.menu": "Link to a page",
  "editor.wiki.properties": "Show a property of the page",
  "editor.wiki.alias": "shown as “{alias}”",
  "editor.wiki.property": "Property",
  "editor.mention.date": "Date",
  "editor.mention.today": "today",
  "editor.mention.tomorrow": "tomorrow",
  "editor.mention.yesterday": "yesterday",
  "editor.mention.unknownPerson": "Someone",
  "editor.slash.image": "Image",
  "editor.slash.image.keywords": "image picture photo upload",
  "editor.slash.imageFromFiles": "Image from files",
  "editor.slash.imageFromFiles.keywords": "image picture photo files library choose existing",
  "editor.image.uploading": "Uploading image…",
  "editor.image.saved": "Image details saved.",
  "editor.image.noAlt": "No description yet. Add one in Image details (block menu, {blockMenu}).",
  "editor.image.details": "Image details…",
  "editor.image.dialog": "Image details",
  "editor.image.alt": "Description (alt text)",
  "editor.image.altHelp": "Plain text, read aloud by screen readers: what the image shows or says, for people who cannot see it.",
  "editor.image.decorative": "Decorative: nothing to describe",
  "editor.image.caption": "Caption",
  "editor.image.captionHelp": "Bold, italics and links: type *italics*, **bold**, or paste a link on a selection.",
  "editor.image.link": "Link (optional)",
  "editor.image.linkInvalid": "Use a web address such as https://example.org.",
  "editor.image.missing": "This image is not available: it was deleted from the workspace's files, or you may not see it.",
  "editor.image.shared": "The description and caption are kept with the image in the workspace's files: changing them here changes them on the {count} pages that use it.",
  "editor.image.sharedOne": "The description and caption are kept with the image in the workspace's files, for every page that uses it.",
  "editor.image.language": "Language of the description and caption",
  "editor.image.readOnly": "Only people who may edit a page that uses this image change its description.",
  "editor.image.linkHelp": "The link is this block's only.",
  "error.file_in_use": "The file is used on pages. Confirm to delete it from them too.",
  "error.file_too_large": "Images can be up to 10 MB.",
  "error.unsupported_type": "Use a PNG, JPEG, GIF, WebP or AVIF image.",
  "error.uploads_off": "Uploads are not set up on this installation.",
  "search.title": "Search",
  "search.label": "Search pages and actions",
  "search.placeholder": "Page title, or an action such as “trash”",
  "search.results": "Results",
  "search.recent": "Recent pages",
  "search.pages": "Pages",
  "search.actions": "Actions",
  "search.selection": "Selected text",
  "search.link": "Link at the cursor",
  "search.inText": "In page text",
  "search.none": "Nothing matches “{query}”.",
  "search.count": "{count, plural, one {# result} other {# results}}",
  "search.action.newPage": "New page",
  "search.action.newPage.keywords": "create add page",
  "search.action.home": "Go to Home",
  "search.action.archive": "Open the archive",
  "search.action.archive.keywords": "archive archived unarchive old",
  "search.action.trash": "Open the trash",
  "search.action.trash.keywords": "trash deleted restore bin",
  "search.action.settings": "Workspace settings",
  "search.action.settings.keywords": "settings members invite people workspace",
  "search.action.account": "Sign-in and security",
  "search.action.account.keywords": "account passkey passkeys recovery codes security sign in",
  "search.action.translations": "Translations",
  "search.action.translations.keywords": "translations languages translate admin",
  "search.action.editing": "Editing settings",
  "search.action.editing.keywords": "account editing preferences vim keys keyboard",
  "search.action.vimHelp": "Vim keys: the reference",
  "search.action.vimHelp.keywords": "vim help keys commands reference keyboard",
  "search.action.admin": "Administration",
  "search.action.admin.keywords": "admin administration sites people instance settings",
  "editor.command.blockActions": "Block actions…",
  "editor.command.duplicate": "Duplicate block",
  "editor.command.addAbove": "Add a block above",
  "editor.command.addBelow": "Add a block below",
  "editor.command.bold": "Bold",
  "editor.command.italic": "Italic",
  "editor.command.underline": "Underline",
  "editor.command.strike": "Strikethrough",
  "editor.command.code": "Code",
  "editor.linkEdit.title": "Add a link",
  "editor.linkEdit.titleEdit": "Edit the link",
  "editor.linkEdit.address": "Address",
  "editor.linkEdit.text": "Text",
  "editor.linkEdit.invalid": "Enter a web address (https://…), or a mail or phone link.",
  "editor.linkEdit.remove": "Remove the link",
  "editor.command.textLanguage": "Language of the selected text…",
  "editor.command.moveUp": "Move block up",
  "editor.command.moveDown": "Move block down",
  "editor.slash.codeIn": "Code: {language}",
  "editor.code.plain": "Plain text",
  "editor.code.button": "Code language: {language}. Change",
  "editor.code.choose": "Language…",
  "editor.code.dialog": "Code language",
  "editor.code.search": "Search languages",
  "editor.code.help": "A name or abbreviation, such as py or ts.",
  "editor.code.none": "No language matches.",
  "editor.quote.choose": "Source…",
  "editor.quote.dialog": "Quote source",
  "editor.quote.source": "Source",
  "editor.quote.sourceHelp": "Who said or wrote it, or where it is from, such as Cicero, De officiis 1.22.",
  "editor.quote.link": "Link (optional)",
  "editor.quote.saved": "Quote source saved.",
  "translations.title": "Translations",
  "translations.intro": "Translate the interface into other languages, then publish the translations. A language is offered to users once its published translations cover {percent}% of the messages; missing messages show in its fallback languages, then in English.",
  "translations.languages": "Languages",
  "translations.column.language": "Language",
  "translations.column.progress": "Translated",
  "translations.column.published": "Published",
  "translations.column.users": "Offered to users",
  "translations.column.actions": "Actions",
  "translations.column.version": "Version",
  "translations.column.date": "Published on",
  "translations.column.messages": "Messages",
  "translations.default": "Default",
  "translations.sourceLanguage": "Source language",
  "translations.progress": "{translated} of {total} messages; {reviewed} reviewed; {stale, plural, =0 {none out of date} one {# out of date} other {# out of date}}",
  "translations.notPublished": "Not published yet",
  "translations.publishedVersion": "Version {version}, {messages, plural, one {# message} other {# messages}}",
  "translations.enabled": "{language} is offered to users.",
  "translations.disabled": "{language} is no longer offered to users.",
  "translations.offer": "Offer {language} to users",
  "translations.notReady.locale_data_missing": "Needs complete locale data (names, plural rules), published with its translations.",
  "translations.notReady.not_published": "Publish its translations first.",
  "translations.notReady.incomplete": "Its published translations cover less than {percent}% of the messages.",
  "translations.translate": "Translate",
  "translations.translateLabel": "Translate into {language}",
  "translations.edit": "Details",
  "translations.editLabel": "Details of {language}",
  "translations.makeDefault": "Make default",
  "translations.makeDefaultLabel": "Make {language} the default language",
  "translations.madeDefault": "{language} is the default language.",
  "translations.add": "Add a language",
  "translations.offeredAll": "Offered to everyone",
  "translations.offeredSome": "Offered to some people only",
  "translations.audience": "Who is offered it…",
  "translations.audienceLabel": "Who is offered it… ({language})",
  "translations.audienceTitle": "Who is offered {language}",
  "translations.audienceWho": "Offer it to",
  "translations.audienceSome": "Only the groups and people below",
  "translations.audienceHelp": "Administrators and the language’s translators are always offered it. People who are not signed in are offered it only when it is offered to everyone.",
  "translations.audienceGroups": "Groups",
  "translations.audienceNoGroups": "There are no groups yet.",
  "translations.audiencePeople": "People, by email address",
  "translations.audiencePeopleHelp": "One email address per line.",
  "translations.audienceSaved": "Who is offered {language} saved.",
  "translations.addTitle": "Add a language",
  "translations.addConfirm": "Add language",
  "translations.editTitle": "Details of {language}",
  "translations.added": "{language} added.",
  "translations.saved": "{language} saved.",
  "translations.field.tag": "Language tag",
  "translations.field.tagMatches": "Matching languages",
  "translations.field.tagNone": "No language matches; any language tag can be typed.",
  "translations.field.tagHelp": "A BCP 47 tag, such as pt-BR, grc or la-x-eccl.",
  "translations.field.endonym": "Name in the language itself",
  "translations.field.endonymHelp": "As its speakers write it, for example Lingua Latina.",
  "translations.field.script": "Script",
  "translations.field.scriptHelp": "An ISO 15924 code: Latn, Grek, Cyrl, Arab…",
  "translations.field.dir": "Writing direction",
  "translations.field.ltr": "Left to right",
  "translations.field.rtl": "Right to left",
  "translations.field.fallback": "Fallback languages",
  "translations.field.fallbackHelp": "Tags in order, ending with en, used for messages not translated yet. Languages: {tags}.",
  "translations.error.language_exists": "There is already a language with this tag.",
  "translations.error.invalid_fallback": "Fallback languages must be known languages, without repeats, ending with en.",
  "translations.error.locale_data_missing": "This language needs complete locale data, published with its translations, before it can be offered to users.",
  "translations.error.not_published": "Publish this language's translations before offering it to users.",
  "translations.error.incomplete": "This language's published translations are not complete enough to offer it to users.",
  "translations.error.language_enabled": "Stop offering the language to users first.",
  "translations.error.language_in_fallback": "Other languages fall back to this one.",
  "translations.error.last_language": "At least one language must stay available to users.",
  "translations.error.default_language": "Choose another default language first.",
  "translations.error.unknown_language": "There is no such language.",
  "translations.error.source_language": "English is the source language: its messages are edited in the code.",
  "translations.error.invalid_message": "The translation has errors; correct them and save again.",
  "translations.languageTitle": "Translations: {language}",
  "translations.back": "All languages",
  "translations.publishTitle": "Publishing",
  "translations.publishHelp": "Saved translations are drafts until published. Publishing makes them a new version, which the app uses from its next load; earlier versions can be used again at any time.",
  "translations.publish": "Publish translations",
  "translations.published": "Version {version} published, with {messages, plural, one {# message} other {# messages}}{skipped, plural, =0 {} one {; # message with errors left out} other {; # messages with errors left out}}.",
  "translations.export": "Export (JSON)",
  "translations.import": "Import (JSON)…",
  "translations.imported": "{imported, plural, one {# translation imported} other {# translations imported}} as drafts{rejected, plural, =0 {} one {; # rejected} other {; # rejected}}.",
  "translations.rejected": "{count, plural, one {This message was not imported:} other {These messages were not imported:}} unknown, or with errors.",
  "translations.versions": "Published versions",
  "translations.inUse": "In use",
  "translations.restore": "Use version {version}",
  "translations.restored": "Version {version} is in use.",
  "translations.messages": "Messages",
  "translations.search": "Search messages",
  "translations.filter": "Show",
  "translations.filter.all": "All",
  "translations.filter.untranslated": "Untranslated",
  "translations.filter.stale": "Out of date",
  "translations.filter.draft": "Draft",
  "translations.filter.reviewed": "Reviewed",
  "translations.area": "Area",
  "translations.area.all": "All areas",
  "translations.count": "{shown} of {total} messages.",
  "translations.pages": "Pages of messages",
  "translations.previous": "Previous",
  "translations.next": "Next",
  "translations.page": "Page {page} of {pages}",
  "translations.english": "English",
  "translations.sourceChanged": "The English has changed since this was translated. It was: {previous}",
  "translations.translationOf": "Translation of {key}",
  "translations.preview": "Preview",
  "translations.reviewed": "Reviewed",
  "translations.saveLabel": "Save the translation of {key}",
  "translations.messageSaved": "Translation of {key} saved.",
  "translations.items": "translated messages on this page of the list",
  "translations.reviewSelected": "Mark selected as reviewed",
  "translations.unreviewSelected": "Mark selected as not reviewed",
  "translations.reviewedCount": "{count, plural, one {# translation marked as reviewed.} other {# translations marked as reviewed.}}",
  "translations.unreviewedCount": "{count, plural, one {# translation marked as not reviewed.} other {# translations marked as not reviewed.}}",
  "translations.issue.empty": "The translation is empty.",
  "translations.issue.syntax": "Not valid ICU message syntax: {detail}.",
  "translations.issue.missing_argument": "Keep the placeholder or tag “{detail}” from the English.",
  "translations.issue.extra_argument": "“{detail}” is not in the English: remove it.",
  "translations.issue.argument_type": "“{detail}” must be the same kind of placeholder as in the English.",
  "translations.issue.select_options": "“{detail}” must keep the English choices.",
  "translations.issue.plural_category": "“{detail}” is not a plural category of this language.",
  "localeData.link": "Locale data",
  "localeData.linkLabel": "Locale data of {language}",
  "localeData.title": "Locale data: {language}",
  "localeData.back": "Translations: {language}",
  "localeData.native": "Browsers already know this language's dates and numbers: locale data entered here is not used for it.",
  "localeData.intro": "Browsers know no dates, numbers or plural rules for this language. Choose a base language they know, then give what differs. Fields left empty use the base language. Required: the plural rules, and the full names of months and weekdays. It is used once published with the translations.",
  "localeData.base": "Base language",
  "localeData.base.label": "Base language tag",
  "localeData.base.help": "A language browsers know, whose formats are closest, such as it or el. Everything not given below comes from it.",
  "localeData.plurals": "Plural rules",
  "localeData.plurals.help": "One CLDR rule per category the language uses, such as i = 1 and v = 0 for one. Other applies when no rule does. The test shows the category of each sample number.",
  "localeData.plurals.cardinal": "Counting (1 page, 2 pages)",
  "localeData.plurals.ordinal": "Ordinals (1st, 2nd)",
  "localeData.plurals.rule": "Rule for {category}",
  "localeData.plurals.test": "Test: {results}",
  "localeData.months": "Months",
  "localeData.names.help": "The format forms are used inside dates (as in 24 October); stand-alone ones on their own (as in a calendar's heading). Only the full format names are required.",
  "localeData.weekdays": "Weekdays",
  "localeData.width.wide": "Full",
  "localeData.width.abbreviated": "Abbreviated",
  "localeData.width.narrow": "Narrow",
  "localeData.width.standAlone.wide": "Full, stand-alone",
  "localeData.width.standAlone.abbreviated": "Abbreviated, stand-alone",
  "localeData.width.standAlone.narrow": "Narrow, stand-alone",
  "localeData.eras": "Eras and times of day",
  "localeData.era.0": "Before the era",
  "localeData.era.1": "The era",
  "localeData.dayPeriod.am": "Morning (AM)",
  "localeData.dayPeriod.pm": "Afternoon (PM)",
  "localeData.patterns": "Date and time patterns",
  "localeData.patterns.help": "CLDR patterns, such as EEEE, d MMMM y: y year, M month (MMMM full name), d day, EEEE weekday, G era, H hour, m minutes, and text in single quotes. Empty ones use the base language's.",
  "localeData.patterns.date": "Date",
  "localeData.patterns.time": "Time",
  "localeData.patterns.dateTime": "Date and time together, with '{1}' for the date and '{0}' for the time",
  "localeData.style.full": "Full",
  "localeData.style.long": "Long",
  "localeData.style.medium": "Medium",
  "localeData.style.short": "Short",
  "localeData.example": "Example:",
  "localeData.numbers": "Numbers",
  "localeData.numbers.decimal": "Decimal separator",
  "localeData.numbers.group": "Thousands separator",
  "localeData.numbers.minusSign": "Minus sign",
  "localeData.numbers.plusSign": "Plus sign",
  "localeData.numbers.percentSign": "Per cent sign",
  "localeData.relative": "Relative times",
  "localeData.relative.help": "Words for yesterday, today and tomorrow, and phrases such as 3 days ago, per plural category, with '{0}' where the number goes.",
  "localeData.relative.previous": "Previous (yesterday)",
  "localeData.relative.current": "This one (today)",
  "localeData.relative.next": "Next (tomorrow)",
  "localeData.relative.past": "Ago",
  "localeData.relative.future": "In",
  "localeData.unit.year": "Years",
  "localeData.unit.quarter": "Quarters",
  "localeData.unit.month": "Months",
  "localeData.unit.week": "Weeks",
  "localeData.unit.day": "Days",
  "localeData.unit.hour": "Hours",
  "localeData.unit.minute": "Minutes",
  "localeData.unit.second": "Seconds",
  "localeData.lists": "Lists",
  "localeData.lists.conjunction": "And (A, B and C)",
  "localeData.lists.disjunction": "Or (A, B or C)",
  "localeData.lists.start": "Start",
  "localeData.lists.middle": "Middle",
  "localeData.lists.end": "End",
  "localeData.lists.pair": "Two items",
  "localeData.languageNames": "Names of the languages, in this language",
  "localeData.issues": "Still to complete or correct before the language can be offered:",
  "localeData.issue.base": "Choose a base language browsers know.",
  "localeData.issue.plural_rule": "A plural rule is not valid: {detail}.",
  "localeData.issue.months": "Give the full names of all twelve months.",
  "localeData.issue.weekdays": "Give the full names of all seven weekdays.",
  "localeData.issue.eras": "Give both eras ({detail}) or neither.",
  "localeData.issue.pattern": "A pattern is not valid: {detail}.",
  "localeData.issue.list": "A list pattern needs both '{0}' and '{1}': {detail}.",
  "localeData.issue.relative_time": "A relative time needs '{0}' for the number: {detail}.",
  "localeData.saved": "Locale data saved. Publish the translations to use it.",
  "translations.yes": "Yes",
  "translations.no": "No",
  "translations.exportXliff": "Export (XLIFF)",
  "translations.importXliff": "Import (XLIFF)…",
  "translations.error.wrong_language": "This file is for another language.",
  "translations.error.not_xml": "This file is not XML.",
  "translations.error.not_xliff2": "This file is not XLIFF 2.",
  "translations.error.invalid_file": "This file could not be read.",
  "translations.error.no_such_person": "No account has that email address.",
  "translations.error.default_everyone": "The default language is offered to everyone.",
  "translations.error.restricted_language": "Offer the language to everyone before making it the default.",
  "translations.error.uploads_off": "Uploads are not set up on this installation.",
  "translations.error.unsupported_type": "Use a PNG, JPEG, GIF, WebP or AVIF image.",
  "translations.error.file_too_large": "Screenshots can be up to 2 MB.",
  "glossary.title": "Glossary",
  "glossary.help": "How recurring English terms are translated into this language. A message whose English uses a term, but whose translation does not use the agreed one, shows a reminder.",
  "glossary.term": "English term",
  "glossary.translation": "Translation",
  "glossary.note": "Note",
  "glossary.add": "Add to the glossary",
  "glossary.saved": "“{term}” saved in the glossary.",
  "glossary.remove": "Remove",
  "glossary.removeLabel": "Remove “{term}” from the glossary",
  "glossary.removed": "“{term}” removed from the glossary.",
  "glossary.hint": "Glossary: {term} is usually {translation}.",
  "translators.title": "Translators and publishers",
  "translators.help": "Besides administrators: translators edit this language's messages, locale data and glossary; publishers can also publish them. They need an account here.",
  "translators.person": "{name} ({email}): {role}",
  "translators.role.translator": "Translator",
  "translators.role.publisher": "Publisher",
  "translators.email": "Email address",
  "translators.roleLabel": "Role",
  "translators.add": "Add",
  "translators.added": "{email} added.",
  "translators.removeLabel": "Remove {name}",
  "translators.removed": "{name} removed.",
  "notes.label": "Note for translators:",
  "notes.add": "Add a note",
  "notes.change": "Change the note",
  "notes.addLabel": "Add a note on {key}",
  "notes.changeLabel": "Change the note on {key}",
  "notes.edit": "Note for translators on {key}, for every language",
  "notes.saved": "Note on {key} saved.",
  "notes.screenshot": "Add a screenshot",
  "notes.screenshotLabel": "Add a screenshot of where {key} appears",
  "notes.screenshotAlt": "Where {key} appears",
  "notes.screenshotSaved": "Screenshot saved.",
  "notes.removeScreenshot": "Remove the screenshot",
  "notes.removeScreenshotLabel": "Remove the screenshot of {key}",
  "notes.screenshotRemoved": "Screenshot removed.",
  "share.button": "Share",
  "share.title": "Share",
  "share.email": "Email address",
  "share.levelFor": "Access for {name}",
  "share.invite": "Invite",
  "share.invited": "{name} can now open this page.",
  "share.group": "Group",
  "share.chooseGroup": "Choose a group",
  "share.add": "Add",
  "share.people": "People and groups",
  "share.nobody": "Nobody has been given this page yet.",
  "share.inherited": "From a page above",
  "share.remove": "Remove",
  "share.removeLabel": "Remove {name}",
  "share.removed": "{name} removed.",
  "share.changed": "{name}: {level}.",
  "share.general": "General access",
  "share.workspace": "Everyone at {workspace}",
  "share.signedIn": "Everyone signed in",
  "share.signedInHelp": "Anyone with an account here, never the public.",
  "visibility.menu": "Schedule visibility…",
  "visibility.pageTitle": "Schedule the page’s visibility",
  "visibility.blockTitle": "Schedule the block’s visibility",
  "visibility.help": "Outside its visible time, it is absent for everyone except the workspace’s owners and you. Whatever is under it follows.",
  "visibility.effect": "It is",
  "visibility.visibleDuring": "Visible only during this time",
  "visibility.hiddenDuring": "Hidden during this time",
  "visibility.saved": "Visibility scheduled.",
  "visibility.removed": "The schedule is removed: always visible again.",
  "visibility.remove": "Remove the schedule",
  "visibility.markerHidden": "Hidden from everyone but the workspace’s owners and the schedule’s author.",
  "visibility.markerHiddenUntil": "Hidden from everyone but the workspace’s owners and the schedule’s author, until {when}.",
  "visibility.markerVisible": "Visible now, on a schedule.",
  "visibility.markerVisibleUntil": "Visible now, on a schedule, until {when}.",
  "schedule.start": "Starts",
  "schedule.end": "Ends",
  "schedule.end.none": "Never (from then on)",
  "schedule.end.at": "At a date and time",
  "schedule.end.for": "After a while",
  "schedule.endAt": "Ends at",
  "schedule.hours": "Hours",
  "schedule.minutes": "Minutes",
  "schedule.repeat": "Repeats",
  "schedule.repeat.none": "Does not repeat",
  "schedule.repeat.daily": "Every day",
  "schedule.repeat.weekly": "Every week",
  "schedule.repeat.monthly": "Every month",
  "schedule.repeat.yearly": "Every year",
  "schedule.interval.daily": "Every how many days",
  "schedule.interval.weekly": "Every how many weeks",
  "schedule.interval.monthly": "Every how many months",
  "schedule.interval.yearly": "Every how many years",
  "schedule.days": "On",
  "schedule.day.MO": "Monday",
  "schedule.day.TU": "Tuesday",
  "schedule.day.WE": "Wednesday",
  "schedule.day.TH": "Thursday",
  "schedule.day.FR": "Friday",
  "schedule.day.SA": "Saturday",
  "schedule.day.SU": "Sunday",
  "schedule.repeatEnd": "Stops repeating",
  "schedule.repeatEnd.never": "Never",
  "schedule.repeatEnd.on": "On a date",
  "schedule.repeatEnd.after": "After a number of times",
  "schedule.until": "Last time starts by",
  "schedule.count": "Number of times",
  "schedule.zone": "Times are in {zone}.",
  "schedule.summary.from": "From {start}",
  "schedule.summary.for": "for {hours, plural, =0 {} one {# hour} other {# hours}}{minutes, plural, =0 {} one { # minute} other { # minutes}}",
  "schedule.summary.every.daily": "{n, plural, one {every day} other {every # days}}",
  "schedule.summary.every.weekly": "{n, plural, one {every week} other {every # weeks}}",
  "schedule.summary.every.monthly": "{n, plural, one {every month} other {every # months}}",
  "schedule.summary.every.yearly": "{n, plural, one {every year} other {every # years}}",
  "schedule.summary.count": "{n, plural, one {once} other {# times}}",
  "schedule.summary.until": "until {until}",
  "schedule.error.start": "Choose when it starts.",
  "schedule.error.end": "It must end after it starts.",
  "schedule.error.repeatNeedsEnd": "Something that repeats needs an end each time.",
  "schedule.error.until": "It must stop repeating after it starts.",
  "share.when": "When…",
  "share.whenLabel": "When… ({name})",
  "share.whenTitle": "When {name} has access",
  "share.whenApplies": "The access applies",
  "share.whenAlways": "Always",
  "share.whenScheduled": "Only at the times below",
  "share.whenSaved": "When {name} has access saved.",
  "share.scheduled": "{when}",
  "share.signedInPublished": "Anyone with an account here. The page is published, so they can read it by its link, without it being listed for them.",
  "share.web": "Anyone on the web (not signed in)",
  "share.webPublished": "The page is published: anyone can read <link>its published copy</link>. Change this in Publish.",
  "share.webUnpublished": "The page isn’t published. Publish it to put it on the web.",
  "share.webBlockShown": "This block shows on <link>the published page</link>.",
  "share.webBlockHidden": "This block has permissions of its own, so <link>the published page</link> leaves it out.",
  "share.restricted": "This page has its own permissions, so it no longer follows the page above.",
  "share.blockTitle": "Permissions of this block",
  "share.blockRestricted": "This block has its own permissions, so it no longer follows the page or the block around it.",
  "share.restore": "Restore inheritance",
  "share.restored": "The page follows the page above again.",
  "share.level.full_access": "Full access",
  "share.level.can_edit": "Can edit",
  "share.level.can_edit_content": "Can edit content",
  "share.level.can_comment": "Can comment",
  "share.level.can_view": "Can view",
  "share.level.can_create": "Can create",
  "share.level.no_access": "No access",
  "share.until": "Access until (optional)",
  "share.untilDate": "Until {date}",
  "share.hideInSearch": "Hide in search for {name}",
  "share.hiddenDone": "Hidden in search: people find this page once they have opened it.",
  "share.shownDone": "Shown in search.",
  "share.requests": "Access requests",
  "share.requestFrom": "{name} asks for “{level}”",
  "share.requestsItems": "access requests",
  "share.approveSelected": "Approve selected requests",
  "share.declineSelected": "Decline selected requests",
  "share.confirmDeclineSelected": "{count, plural, one {Decline # access request?} other {Decline # access requests?}}",
  "share.confirmDeclineSelectedBody": "They will not be given access to this page.",
  "share.approvedCount": "{count, plural, one {# request approved.} other {# requests approved.}}",
  "share.declinedCount": "{count, plural, one {# request declined.} other {# requests declined.}}",
  "share.approve": "Approve",
  "share.approveLabel": "Approve {name}'s request",
  "share.decline": "Decline",
  "share.declineLabel": "Decline {name}'s request",
  "share.approved": "{name} has access now.",
  "share.declined": "{name}'s request declined.",
  "shared.title": "Shared with me",
  "shared.none": "Nothing has been shared with you yet.",
  "home.shared": "{count, plural, one {# page is shared with you} other {# pages are shared with you}}",
  "workspace.home.reader": "Pages shared with you here are listed in the sidebar.",
  "auth.signUp.open": "New here? Signing in with one of these creates your account.",
  "groups.title": "Groups",
  "groups.introAdmin": "Groups belong to the whole installation: pages in any workspace can be shared with them. You create groups and choose who manages each one; managers choose its members.",
  "groups.introManager": "The groups you manage. Pages shared with a group reach all its members.",
  "groups.name": "Group name",
  "groups.create": "Create group",
  "groups.created": "Group {name} created.",
  "groups.none": "No groups yet.",
  "groups.members": "Members",
  "groups.managers": "Managers",
  "groups.actions": "Actions",
  "groups.open": "Manage",
  "groups.openLabel": "Manage {name}",
  "groups.rename": "New name",
  "groups.renameButton": "Rename",
  "groups.renamed": "Group renamed to {name}.",
  "groups.managersHelp": "Managers add and remove members. They need not be members themselves.",
  "groups.managerEmail": "Manager's email address",
  "groups.addManager": "Add manager",
  "groups.managerAdded": "{name} manages the group.",
  "groups.removeManager": "Remove {name} as manager",
  "groups.managerRemoved": "{name} no longer manages the group.",
  "groups.memberEmail": "Member's email address",
  "groups.addMember": "Add member",
  "groups.memberAdded": "{name} added.",
  "groups.removeMember": "Remove {name} from the group",
  "groups.memberRemoved": "{name} removed.",
  "groups.managersItems": "managers of {name}",
  "groups.membersItems": "members of {name}",
  "groups.removeSelectedManagers": "Remove selected managers",
  "groups.removeSelectedMembers": "Remove selected members",
  "groups.confirmRemoveManagers": "{count, plural, one {Remove # manager of {name}?} other {Remove # managers of {name}?}}",
  "groups.confirmRemoveManagersBody": "They will no longer manage the group.",
  "groups.confirmRemoveMembers": "{count, plural, one {Remove # member from {name}?} other {Remove # members from {name}?}}",
  "groups.confirmRemoveMembersBody": "They lose whatever access was given to the group.",
  "groups.managersRemovedCount": "{count, plural, one {# manager removed.} other {# managers removed.}}",
  "groups.membersRemovedCount": "{count, plural, one {# member removed.} other {# members removed.}}",
  "groups.nobody": "Nobody yet.",
  "groups.delete": "Delete group",
  "groups.deleteTitle": "Delete {name}?",
  "groups.deleteBody": "Its members lose whatever access was given to the group. This cannot be undone.",
  "groups.deleted": "Group {name} deleted.",
  "readers.title": "Readers",
  "readers.help": "Invite someone who joins no workspace and sees only the pages shared with them, such as a student. Send them the link yourself: it works once, for that email address, for 7 days.",
  "readers.email": "Reader's email address",
  "readers.create": "Create invite link",
  "readers.created": "Invite link created for {email}.",
  "readers.linkFor": "Invite link for {email}",
  "readers.pending": "{email} · expires {date}",
  "readers.revoke": "Revoke",
  "readers.revokeFor": "Revoke the invitation for {email}",
  "readers.revoked": "Invitation for {email} revoked.",
  "readers.items": "pending reader invitations",
  "comments.heading": "Comments",
  "comments.addOnSite": "Add a comment",
  "comments.reply": "Reply",
  "comments.edited": "edited",
  "comments.deleted": "This comment was deleted.",
  "comments.hidden": "This comment was hidden.",
  "comments.none": "No comments yet.",
  "comments.title": "Comments ({count, number})",
  "comments.add": "Add a comment",
  "comments.post": "Post comment",
  "comments.postReply": "Post reply",
  "comments.posted": "Comment posted.",
  "comments.replyTo": "Reply to {name}",
  "comments.replyLabel": "Your reply to {name}",
  "comments.edit": "Edit",
  "comments.editOwn": "Edit your comment",
  "comments.editLabel": "Your comment",
  "comments.save": "Save",
  "comments.saved": "Comment saved.",
  "comments.delete": "Delete",
  "comments.deleteLabel": "Delete {name}'s comment",
  "comments.deleteTitle": "Delete this comment?",
  "comments.deleteBody": "If it has replies, they stay, under “This comment was deleted.”",
  "comments.deletedDone": "Comment deleted.",
  "comments.hide": "Hide",
  "comments.hideLabel": "Hide {name}'s comment",
  "comments.hiddenDone": "Comment hidden. Only people with full access to the page see it.",
  "comments.hiddenTag": "hidden from readers",
  "comments.show": "Show",
  "comments.showLabel": "Show {name}'s comment again",
  "comments.shown": "Comment shown again.",
  "comments.nameShown": "Your name is shown with your comment.",
  "comments.namePublic": "Your name is shown with your comment, also on the published page, where anyone can read it.",
  "comments.cannot": "You can read the comments, but not add any.",
  "comments.pageTitle": "Comments: {title}",
  "comments.backToSite": "Back to the page",
  "comments.openInApp": "Open the page here",
  "comments.toggle": "Comments on this page",
  "comments.toggleHelp": "When off, comments are kept but not shown, here or on the published page, and nobody can add any. Pages inside follow this page unless set otherwise.",
  "comments.follows": "Follows the page above. Pages inside follow this page unless set otherwise.",
  "comments.follow": "Follow the page above",
  "comments.onDone": "Comments turned on.",
  "comments.offDone": "Comments turned off.",
  "comments.followsDone": "Comments now follow the page above.",
  "comments.off": "Comments are turned off for this page.",
  "comments.quoted": "In reply to the comment as it was then",
  "comments.editNeedsApproval": "The time to edit freely is over: your edit goes to people with full access to the page for approval.",
  "comments.proposed": "Edit sent for approval.",
  "comments.proposal": "Proposed edit, waiting for approval",
  "comments.approve": "Approve",
  "comments.approveLabel": "Approve the edit {name} proposed",
  "comments.approved": "Edit approved.",
  "comments.decline": "Decline",
  "comments.declineLabel": "Decline the edit {name} proposed",
  "comments.declined": "Edit declined.",
  "comments.withdraw": "Withdraw",
  "comments.withdrawLabel": "Withdraw your proposed edit",
  "comments.withdrawn": "Proposed edit withdrawn.",
  "comments.editMinutes": "Minutes to edit a comment freely",
  "comments.editMinutesHelp": "After that, authors' edits go to people with full access for approval. 0: every edit needs approval. -1: no limit. Pages inside follow this page unless set otherwise.",
  "comments.editMinutesFollows": "Follows the setting above: {value}.",
  "comments.editMinutesValue": "{minutes, plural, one {# minute} other {# minutes}}",
  "comments.noLimit": "no limit",
  "comments.editMinutesSave": "Save editing time",
  "comments.editMinutesDone": "Editing time saved.",
  "comments.editMinutesFollow": "Use the setting above",
  "comments.editMinutesFollowDone": "Editing time now follows the setting above.",
  "comments.report": "Report",
  "comments.reportLabel": "Report {name}'s comment",
  "comments.reportTitle": "Report this comment",
  "comments.reportBody": "People with full access to the page will see your reason, but not who sent it. They can hide or delete the comment.",
  "comments.reportReason": "Why should they look at it?",
  "comments.reportSend": "Send report",
  "comments.reportDone": "Comment reported.",
  "comments.reportedTag": "reported by you",
  "comments.reports": "{count, plural, one {Reported once:} other {Reported # times:}}",
  "comments.dismiss": "Dismiss reports",
  "comments.dismissLabel": "Dismiss reports of {name}'s comment",
  "comments.dismissed": "Reports dismissed.",
  "inbox.nav": "Inbox",
  "inbox.unread": "unread",
  "inbox.title": "Inbox",
  "inbox.none": "Nothing here yet. Replies to your comments, and what needs your attention on your pages, appear here.",
  "inbox.allRead": "Mark all as read",
  "inbox.allReadDone": "All marked as read.",
  "inbox.items": "notifications",
  "inbox.readSelected": "Mark selected as read",
  "inbox.readCount": "{count, plural, one {# notification marked as read.} other {# notifications marked as read.}}",
  "inbox.new": "New",
  "inbox.someone": "Someone",
  "inbox.comment_reply": "{actor} replied on {page}",
  "inbox.comment_proposal": "{actor} proposed an edit to a comment on {page}",
  "inbox.comment_report": "A comment on {page} was reported",
  "inbox.comment_edit_approved": "{actor} approved your edit on {page}",
  "inbox.comment_edit_declined": "{actor} declined your edit on {page}",
  "discussions.title": "Discussions",
  "discussions.toggle": "Discussions ({count, number})",
  "discussions.comment": "Comment",
  "discussions.close": "Close",
  "discussions.selectText": "Select some text in one paragraph to comment on it.",
  "discussions.newOnText": "Comment on “{text}”",
  "discussions.newOnBlock": "Comment on the block “{text}”",
  "discussions.newOnProperty": "New discussion about the property {text}",
  "discussions.post": "Comment",
  "discussions.posted": "Comment added.",
  "discussions.filter": "Show",
  "discussions.open": "Open ({count, number})",
  "discussions.resolved": "Resolved ({count, number})",
  "discussions.none": "No open discussions. Select text and choose Comment to start one.",
  "discussions.noneResolved": "No resolved discussions.",
  "discussions.showText": "Show “{text}” in the page",
  "discussions.gone": "About text no longer in the page: “{text}”",
  "discussions.onBlock": "About the block “{text}”",
  "discussions.onProperty": "About the property {text}",
  "discussions.resolvedBy": "Resolved by {name}",
  "discussions.resolve": "Resolve",
  "discussions.resolveLabel": "Resolve the discussion about “{text}”",
  "discussions.reopen": "Reopen",
  "discussions.reopenLabel": "Reopen the discussion about “{text}”",
  "discussions.resolvedDone": "Discussion resolved.",
  "discussions.reopenedDone": "Discussion reopened.",
  "discussions.items": "discussions shown",
  "discussions.resolveSelected": "Resolve selected discussions",
  "discussions.reopenSelected": "Reopen selected discussions",
  "discussions.resolvedCount": "{count, plural, one {# discussion resolved.} other {# discussions resolved.}}",
  "discussions.reopenedCount": "{count, plural, one {# discussion reopened.} other {# discussions reopened.}}",
  "exercise.answer": "Your answer",
  "exercise.blank": "Blank to fill in",
  "exercise.send": "Send answers",
  "exercise.sent": "Answers sent {date}. Your teacher will mark them.",
  "exercise.sentDone": "Answers sent.",
  "exercise.marked": "Marked: {mark}",
  "exercise.feedback": "Feedback",
  "exercise.answers": "Answers ({count, number})",
  "exercise.saving": "Saving…",
  "exercise.saved": "Saved",
  "exercise.failed": "Not saved. Your answers will be saved again shortly.",
  "exercise.keyed": "Answer key set",
  "exercise.settings": "Question settings",
  "exercise.blankSettings": "Answers for this blank",
  "exercise.kind": "Kind of question",
  "exercise.kind.short": "Short answer",
  "exercise.kind.long": "Long answer",
  "exercise.kind.choice": "Multiple choice",
  "exercise.options": "Options",
  "exercise.optionsHelp": "One per line, up to 20.",
  "exercise.multiple": "More than one may be chosen",
  "exercise.correct": "Right answers",
  "exercise.accepted": "Accepted answers",
  "exercise.acceptedHelp": "One per line. Students never see them. Capitals and extra spaces don't count when checking.",
  "exercise.keySaved": "Answer key saved.",
  "exercise.answersTitle": "Answers",
  "exercise.students": "Students",
  "exercise.noStudents": "No one has answered yet.",
  "exercise.noAnswer": "No answer",
  "exercise.matches": "matches the key",
  "exercise.differs": "differs from the key",
  "exercise.markFor": "Mark for “{n}”",
  "exercise.overall": "Overall mark",
  "exercise.saveMarks": "Save marks",
  "exercise.markedDone": "{name}'s answers marked.",
  "exercise.reopen": "Allow another try",
  "exercise.reopenedDone": "{name} can answer again.",
  "exercise.status.draft": "not sent yet",
  "exercise.status.sent": "sent",
  "exercise.status.marked": "marked",
  "inbox.exercise_sent": "{actor} sent answers on {page}",
  "inbox.exercise_marked": "{actor} marked your answers on {page}",
  "inbox.exercise_reopened": "{actor} lets you answer again on {page}",
  "comments.formatHelp": "Format with Markdown (**bold**, _italic_, `code`, [link](address)) or {bold}, I, U, E. Type @ to mention someone. {send} sends.",
  "comments.react": "React",
  "comments.reactLabel": "React to {name}'s comment",
  "comments.reactions": "Reactions",
  "comments.reactionLabel": "{emoji} {count, number}, from {names}",
  "inbox.comment_mention": "{actor} mentioned you on {page}",
  "inbox.access_request": "{actor} asks for access to {page}",
  "inbox.access_granted": "{actor} gave you access to {page}",
  "page.makeDatabase": "Turn into database",
  "page.madeDatabase": "“{title}” is now a database.",
  "error.page_locked": "The page is locked. Unlock it to edit it.",
  "error.has_subpages": "Only a page without sub-pages can become a database.",
  "error.database_parent": "Add rows to a database from its views.",
  "error.row_move": "Rows stay in their database.",
  "error.too_many_rows": "A database can hold up to 5,000 rows.",
  "error.too_many_properties": "A database can have up to 100 properties.",
  "error.too_many_views": "A database can have up to 50 views.",
  "error.last_view": "A database keeps at least one view.",
  "error.invalid_value": "That value doesn’t fit this property.",
  "error.invalid_config": "Those settings aren’t valid.",
  "database.label": "Database",
  "database.peek.openIn": "Open pages in",
  "database.peek.mode.side": "Side peek",
  "database.peek.mode.center": "Centre peek",
  "database.peek.mode.page": "Full page",
  "database.peek.short.side": "Side",
  "database.peek.short.center": "Centre",
  "database.peek.label": "Peek: {title}",
  "database.peek.fullPage": "Open as full page",
  "database.peek.layout": "Open pages in: {mode}",
  "database.peek.close": "Close peek",
  "database.peek.unavailable": "This page cannot be opened here.",
  "database.peek.openSide": "Open in side peek",
  "database.peek.openCenter": "Open in centre peek",
  "database.peek.openInIs": "Open pages in {mode}",
  "database.peek.previous": "Peek at the previous row",
  "database.peek.next": "Peek at the next row",
  "database.details.showAs": "Show as",
  "database.details.show.number": "Number",
  "database.details.show.bar": "Bar",
  "database.details.show.ring": "Ring",
  "database.details.outOf": "Out of",
  "database.details.shownAs": "“{name}” shown as",
  "database.details.showAsIs": "Show “{name}” as {show}",
  "database.details.subGroupBy": "Sub-group by",
  "database.details.noSubGroups": "No sub-groups",
  "database.details.subGroupByNamed": "Sub-group by {name}",
  "database.details.layout": "Layout",
  "database.details.rowHeight": "Row height",
  "database.details.height.short": "Short",
  "database.details.height.medium": "Medium",
  "database.details.height.tall": "Tall",
  "database.details.rowHeightIs": "Row height: {height}",
  "database.details.wrapAll": "Wrap all columns",
  "database.details.freezeUpTo": "Freeze up to “{name}”",
  "database.details.freezeHere": "Freeze up to this column",
  "database.details.unfreeze": "Unfreeze columns",
  "database.details.duplicateProperty": "Duplicate property",
  "database.details.duplicateNamed": "Duplicate property “{name}”",
  "database.details.copyName": "{name} (copy)",
  "database.details.duplicated": "“{name}” added.",
  "database.details.editDescription": "View description…",
  "database.details.descriptionEdit": "Edit description",
  "database.details.descriptionTitle": "View description",
  "database.details.description": "Description",
  "database.details.copyLink": "Copy link to view",
  "database.details.linkCopied": "Link to the view copied.",
  "database.details.linkNotCopied": "The link could not be copied.",
  "calendar.week.showBy": "Show calendar by",
  "calendar.week.by.month": "Month",
  "calendar.week.by.week": "Week",
  "calendar.week.command.month": "Show the calendar by month",
  "calendar.week.command.week": "Show the calendar by week",
  "calendar.week.previous": "Previous week",
  "calendar.week.next": "Next week",
  "calendar.week.allDay": "All day",
  "calendar.week.timed": "At set times",
  "database.propertyAccess": "Who can see this property…",
  "database.propertyAccessTitle": "Who can see {name}",
  "database.columnWho": "Who can see it",
  "database.columnAll": "Everyone with access to the database",
  "database.columnSome": "Only the people chosen",
  "database.columnHelp": "People with full access to the database always see and change it.",
  "database.columnEveryone": "Everyone in the workspace",
  "database.columnPrincipal": "Who, in line {n}",
  "database.columnLevel": "Access, in line {n}",
  "database.columnRemove": "Remove line {n}",
  "database.columnAdd": "Add someone",
  "database.columnSaved": "Property access saved.",
  "database.linkedLabel": "Linked view of {title}",
  "database.inlineLabel": "Database {title}",
  "database.linkedUnavailable": "This linked database isn’t available to you.",
  "database.linkedNoViews": "This linked database has no views yet.",
  "database.views": "Views",
  "database.addView": "Add a view",
  "database.viewAdded": "View added.",
  "database.viewDeleted": "View deleted.",
  "database.viewSaved": "View saved.",
  "database.view.table": "Table",
  "database.view.board": "Board",
  "database.view.list": "List",
  "database.view.gallery": "Gallery",
  "database.view.calendar": "Calendar",
  "database.view.timeline": "Timeline",
  "database.view.chart": "Chart",
  "database.turnOnSubItems": "Turn on sub-items",
  "database.turnOnDependencies": "Turn on dependencies",
  "database.turnOffSubItems": "Turn off sub-items",
  "database.turnOffDependencies": "Turn off dependencies",
  "database.parentItem": "Parent item",
  "database.subItems": "Sub-items",
  "database.blockedBy": "Blocked by",
  "database.blocking": "Blocking",
  "database.subItemsOn": "Sub-items are on: rows can go under others.",
  "database.dependenciesOn": "Dependencies are on: rows can be blocked by others.",
  "database.subItemsOff": "Sub-items are off. Their two properties stay, with their values, as a relation.",
  "database.dependenciesOff": "Dependencies are off. Their two properties stay, with their values, as a relation.",
  "database.addSubItem": "Add a sub-item",
  "database.showSubItems": "Show the sub-items of {row} ({count, number})",
  "database.subItemOf": "Sub-item of {row}:",
  "database.subItemsShow": "Sub-items",
  "database.subItemsShow.nested": "Under their parents",
  "database.subItemsShow.flat": "All alike",
  "database.subItemsShow.parents": "Parents only",
  "database.timescale": "Scale",
  "database.timescale.week": "Week",
  "database.timescale.month": "Month",
  "database.timescale.quarter": "Quarter",
  "database.timescale.year": "Year",
  "database.timelineTable": "Show the table beside it",
  "database.timelineNeedsDate": "A timeline lays rows out by a date property. Add one to use this view.",
  "database.timelineBars": "Bars",
  "database.timelineOutside": "Outside this period",
  "database.previousPeriod": "Previous",
  "database.nextPeriod": "Next",
  "database.noDate": "No date",
  "database.blockedByList": "Blocked by {rows}",
  "database.blockedLate": "Blocked by {rows}, which ends after this starts",
  "database.chartType": "Chart",
  "database.chart.bar": "Bars",
  "database.chart.line": "Line",
  "database.chart.donut": "Donut",
  "database.chart.number": "Number",
  "database.chartGroupBy": "By",
  "database.chartMeasure": "Measure",
  "database.chartMeasure.count": "Count of rows",
  "database.chartMeasure.sum": "Sum",
  "database.chartMeasure.average": "Average",
  "database.chartMeasure.min": "Minimum",
  "database.chartMeasure.max": "Maximum",
  "database.chartProperty": "Of the property",
  "database.chartNeedsGroup": "A chart groups rows by a property such as a select, a status or a date. Add one to use this view.",
  "database.chartSummary": "{measure} by {property}",
  "database.chartRowsOf": "Rows in {name}",
  "database.toolbar": "View tools",
  "database.search": "Search this view",
  "database.filter": "Filter",
  "database.filterActive": "{count, plural, one {# filter} other {# filters}}",
  "database.sort": "Sort",
  "database.sortActive": "{count, plural, one {# sort} other {# sorts}}",
  "database.properties": "Properties",
  "database.moreActions": "More view actions",
  "database.viewSettings": "View settings",
  "database.duplicateView": "Duplicate view",
  "database.deleteView": "Delete view",
  "database.addProperty": "Add a property",
  "database.importCsv": "Import CSV…",
  "database.exportCsv": "Export CSV",
  "database.csvTooLarge": "That file is too large to import (5 MB at most).",
  "database.imported": "{count, plural, one {# row imported.} other {# rows imported.}}",
  "database.resetView": "Reset view",
  "database.new": "New",
  "database.newRow": "New row",
  "database.newIn": "New row in {group}",
  "database.newOn": "New row on {date}",
  "database.rowCount": "{count, plural, =0 {No rows} one {# row} other {# rows}}",
  "database.truncated": "Showing the first {count, number} rows.",
  "database.loadFailed": "The database couldn’t be loaded.",
  "database.showMore": "Show {count, plural, one {# more row} other {# more rows}}",
  "database.view.feed": "Feed",
  "database.sources": "Data sources of {title}",
  "database.addSource": "Add a data source",
  "database.addSourceButton": "Add data source",
  "database.sourceHelp": "A data source is another set of rows kept in this database, with its own properties, views and access rules. It is shared as the database is.",
  "database.sourceName": "Name of the data source",
  "database.sourceAdded": "Data source {name} added.",
  "database.colorRules": "Colour rules",
  "database.colorRulesHelp": "Rows, or one property's values, that meet a rule's conditions take its colour. The first rule that matches wins. A rule's name is read out with the row, so the colour is not the only sign.",
  "database.noColorRules": "No colour rules yet.",
  "database.addColorRule": "Add a colour rule",
  "database.colorRule": "Rule {n}",
  "database.colorRuleName": "Name (read out with the row)",
  "database.colorRuleTarget": "What to colour",
  "database.colorWholeRow": "The whole row",
  "database.colorRuleColor": "Colour",
  "database.colorRuleUp": "Move rule {n} up",
  "database.colorRuleDown": "Move rule {n} down",
  "database.colorRuleRemove": "Remove rule {n}",
  "database.commentOnRow": "Comment",
  "database.commentOnValue": "Comment on {property}",
  "database.commentOnProperty": "Comment on the property {property}",
  "database.commentOnPropertyCount": "Comment on {property}{count, plural, =0 {} one { (# open discussion)} other { (# open discussions)}}",
  "database.commentsOn": "Comments on {title}",
  "database.openRow": "Open the page",
  "database.customizeLayout": "Customize layout",
  "database.layoutHelp": "How the pages of this database's rows show their properties: pinned ones under the title, hidden ones on request, relations as tabs of their rows.",
  "database.layoutPanel": "Properties",
  "database.layoutTop": "Above the text",
  "database.layoutSide": "Beside the text",
  "database.layoutProperty": "Property",
  "database.layoutPinned": "Pinned",
  "database.layoutHidden": "Hidden",
  "database.layoutTab": "As a tab",
  "database.layoutOrder": "Order",
  "database.pinNamed": "Pin {name}",
  "database.hideNamed": "Hide {name}",
  "database.tabNamed": "Show {name} as a tab",
  "database.moveUpNamed": "Move {name} up",
  "database.moveDownNamed": "Move {name} down",
  "database.layoutSaved": "Layout saved.",
  "database.showHiddenCount": "Show {count, plural, one {# hidden property} other {# hidden properties}}",
  "database.showHiddenProperties": "Show the hidden properties",
  "database.hideHiddenProperties": "Hide the hidden properties",
  "database.relatedTabs": "Related rows",
  "database.relatedTitle": "Name",
  "database.noRelated": "No rows in {property} yet.",
  "database.templates": "Templates",
  "database.templatesHelp": "New rows can start from a template: its values, icon and text. Templates are kept apart from the rows.",
  "database.defaultTemplate": "New rows in this view start from",
  "database.blankRow": "An empty row",
  "database.newBlank": "New empty row",
  "database.default": "Default",
  "database.noTemplates": "No templates yet.",
  "database.newTemplate": "New template",
  "database.newFrom": "New from a template",
  "database.newFromNamed": "New from {name}",
  "database.editTemplate": "Edit {name}",
  "database.scheduleTemplate": "Repeat {name}",
  "database.deleteTemplate": "Delete {name}",
  "database.templateDeleted": "Template {name} moved to the trash.",
  "database.repeat": "Repeat",
  "database.repeatOff": "Never",
  "database.repeat.day": "Daily",
  "database.repeat.week": "Weekly",
  "database.repeat.month": "Monthly",
  "database.repeatInterval": "Every how many {every, select, day {days} week {weeks} other {months}}",
  "database.repeatNext": "Next row on",
  "database.repeatTime": "At",
  "database.repeatZone": "Time zone",
  "database.timeZones": "Time zones",
  "database.unknownZone": "Not a time zone this browser knows: the schedule keeps the last one that was.",
  "database.repeats": "Adds a row every {interval, plural, one {{every, select, day {day} week {week} other {month}}} other {# {every, select, day {days} week {weeks} other {months}}}}; next on {next} at {time} ({zone} time), within the hour.",
  "database.saveSchedule": "Save schedule",
  "database.scheduleSaved": "Schedule saved.",
  "database.scheduleOff": "The template no longer repeats.",
  "database.scheduleThisTemplate": "Repeat this template",
  "database.templateBanner": "This is a template: new rows can start from it, with its values and text.",
  "database.feedEmpty": "Nothing posted yet.",
  "database.feedComments": "{count, plural, =0 {Comment} one {# comment} other {# comments}}",
  "database.reactTo": "{emoji}{count, plural, =0 {} other { #}}, react to {title}",
  "database.cellLabel": "{property} of {row}",
  "database.rename": "Rename {row}",
  "database.empty": "Empty",
  "database.escape": "Press Escape to close.",
  "database.invalidValue": "That value doesn’t fit this property.",
  "database.checked": "Checked",
  "database.unchecked": "Not checked",
  "database.someone": "Someone",
  "database.me": "Me",
  "database.today": "Today",
  "database.clear": "Clear",
  "database.noOptions": "No options yet. Add them in the property’s settings.",
  "database.dateStart": "Date",
  "database.dateEnd": "End date",
  "database.dateRange": "End date",
  "database.dateTime": "Include time",
  "database.noValue": "No {property}",
  "database.propertyMenu": "{name} column options",
  "database.editProperty": "Edit property",
  "database.editPropertyTitle": "Edit property",
  "database.sortAscending": "Sort ascending",
  "database.sortDescending": "Sort descending",
  "database.hideProperty": "Hide in view",
  "database.deleteProperty": "Delete property",
  "database.propertyDeleted": "Property “{name}” deleted.",
  "database.propertySaved": "Property “{name}” saved.",
  "database.calculate": "Calculate {name}",
  "database.calculateShort": "Calculate",
  "database.calc.none": "None",
  "database.calc.count_all": "Count all",
  "database.calc.count_values": "Count values",
  "database.calc.count_empty": "Count empty",
  "database.calc.count_not_empty": "Count not empty",
  "database.calc.count_unique": "Count unique values",
  "database.calc.percent_empty": "Percent empty",
  "database.calc.percent_not_empty": "Percent not empty",
  "database.calc.sum": "Sum",
  "database.calc.average": "Average",
  "database.calc.median": "Median",
  "database.calc.min": "Min",
  "database.calc.max": "Max",
  "database.calc.range": "Range",
  "database.calc.earliest": "Earliest date",
  "database.calc.latest": "Latest date",
  "database.calc.checked": "Checked",
  "database.calc.unchecked": "Unchecked",
  "database.calc.percent_checked": "Percent checked",
  "database.boardNeedsGroup": "A board groups rows by a select or status property. Add one to use this view.",
  "database.calendarNeedsDate": "A calendar lays rows out by a date property. Add one to use this view.",
  "database.moveCard": "Move {row} to another group",
  "database.previousMonth": "Previous month",
  "database.nextMonth": "Next month",
  "database.filters": "Filters",
  "database.filterMode": "Rows must match",
  "database.filterAll": "All of the filters",
  "database.filterAny": "Any of the filters",
  "database.noFilters": "No filters: every row shows.",
  "database.filterProperty": "Property of filter {n}",
  "database.filterOperator": "Condition of filter {n}",
  "database.filterValue": "Value of filter {n}",
  "database.removeFilter": "Remove filter {n}",
  "database.addFilter": "Add a filter",
  "database.nestedKept": "{count, plural, one {# group of filters made elsewhere is kept.} other {# groups of filters made elsewhere are kept.}}",
  "database.op.equals": "Is",
  "database.op.not_equals": "Is not",
  "database.op.contains": "Contains",
  "database.op.not_contains": "Does not contain",
  "database.op.starts_with": "Starts with",
  "database.op.ends_with": "Ends with",
  "database.op.greater": "Greater than",
  "database.op.less": "Less than",
  "database.op.greater_or_equal": "Greater than or equal to",
  "database.op.less_or_equal": "Less than or equal to",
  "database.op.before": "Before",
  "database.op.after": "After",
  "database.op.on_or_before": "On or before",
  "database.op.on_or_after": "On or after",
  "database.op.is_empty": "Is empty",
  "database.op.is_not_empty": "Is not empty",
  "database.op.group_is": "Is in group",
  "database.statusGroup.todo": "To do",
  "database.statusGroup.in_progress": "In progress",
  "database.statusGroup.complete": "Complete",
  "database.status.todo": "Not started",
  "database.status.doing": "In progress",
  "database.status.done": "Done",
  "database.sorts": "Sorts",
  "database.noSorts": "No sorts: rows show in the order they were added or arranged.",
  "database.sortProperty": "Property of sort {n}",
  "database.sortDirection": "Direction of sort {n}",
  "database.removeSort": "Remove sort {n}",
  "database.addSort": "Add a sort",
  "database.ascending": "Ascending",
  "database.descending": "Descending",
  "database.propertiesShown": "Properties shown",
  "database.noProperties": "This database has no properties besides its title.",
  "database.propertyName": "Name",
  "database.sharedHelp": "A property of this name is the same everywhere: its type and options come with it, and values stay this database’s own.",
  "database.sharedList": "Properties in use",
  "database.sharedDetail": "{name} — {type} · on {pages, plural, one {# page} other {# pages}} and {databases, plural, one {# database} other {# databases}}",
  "database.nameRequired": "Give the property and each option a name.",
  "database.propertyType": "Type",
  "database.typeChangeHelp": "Values are converted where they fit the new type; the others are cleared.",
  "database.options": "Options",
  "database.optionName": "Name of option {n}",
  "database.optionColor": "Colour of option {n}",
  "database.optionGroup": "Group of option {n}",
  "database.removeOption": "Remove option {name}",
  "database.addOption": "Add an option",
  "database.numberFormat": "Number format",
  "database.format.number": "Number",
  "database.format.comma": "Number with commas",
  "database.format.percent": "Percent",
  "database.format.currency": "Currency",
  "database.currency": "Currency code (ISO 4217)",
  "database.idPrefix": "Prefix",
  "database.propertyDescription": "Description",
  "database.type.title": "Title",
  "database.type.text": "Text",
  "database.type.number": "Number",
  "database.type.select": "Select",
  "database.type.multi_select": "Multi-select",
  "database.type.status": "Status",
  "database.type.date": "Date",
  "database.type.person": "Person",
  "database.type.checkbox": "Checkbox",
  "database.type.url": "URL",
  "database.type.email": "Email",
  "database.type.phone": "Phone",
  "database.type.created_time": "Created time",
  "database.type.created_by": "Created by",
  "database.type.last_edited_time": "Last edited time",
  "database.type.last_edited_by": "Last edited by",
  "database.type.unique_id": "ID",
  "database.viewName": "Name",
  "database.layout": "Layout",
  "database.groupBy": "Group by",
  "database.noGrouping": "None",
  "database.hideEmptyGroups": "Hide empty groups",
  "database.wrap": "Wrap cell contents",
  "database.cardSize": "Card size",
  "database.size.small": "Small",
  "database.size.medium": "Medium",
  "database.size.large": "Large",
  "database.dateProperty": "Show rows by",
  "database.hideWeekends": "Hide weekends",
  "database.rowProperties": "Properties",
  "settings.security.allowPublishing.label": "Who may publish pages to the web",
  "settings.security.allowPublishing.help": "Of the people with full access to a page. Others see that they cannot publish, and the server refuses them; pages already published stay until they are unpublished. Workspace owners may narrow this for their workspace.",
  "settings.security.allowExport.label": "Who may export pages",
  "settings.security.allowExport.help": "Of the people who can read a page. Covers the Export action and tools reading pages as Markdown through the API; people can still copy what they can read. Workspace owners may narrow this.",
  "settings.security.allowExternalSharing.label": "Who may share pages outside their workspace",
  "settings.security.allowExternalSharing.help": "Of the people with full access to a page: sharing it with people who are not members, or with everyone signed in. Sharing inside the workspace is not affected. Workspace owners may narrow this.",
  "settings.security.teamspaceCreation.label": "Who can create teamspaces",
  "settings.security.teamspaceCreation.help": "Members of a workspace, or only its owners.",
  "settings.security.teamspaceCreation.option.members": "Members",
  "settings.security.teamspaceCreation.option.owners": "Owners only",
  "settings.retention.trashDays.label": "Days pages stay in the trash",
  "settings.retention.trashDays.help": "After this many days, pages in the trash are deleted for good, once a day. 0 keeps them until someone deletes them.",
  "admin.audit.title": "Audit log",
  "admin.audit.intro": "Every change to settings, sharing, members, sign-ins and publishing, newest first. Kept for {days, plural, =0 {ever} one {# day} other {# days}} (Settings → Security).",
  "admin.audit.who": "Who",
  "admin.audit.whoList": "People",
  "admin.audit.anyone": "Anyone",
  "admin.audit.what": "What",
  "admin.audit.whatList": "Actions",
  "admin.audit.anything": "Any action",
  "admin.audit.item": "Page or item",
  "admin.audit.itemList": "Pages and items",
  "admin.audit.from": "From",
  "admin.audit.to": "To",
  "admin.audit.export": "Export as CSV",
  "admin.audit.more": "Show more",
  "admin.audit.count": "{shown, number} of {total, plural, one {# entry} other {# entries}} shown.",
  "admin.audit.none": "No entries match.",
  "admin.audit.when": "When",
  "admin.audit.details": "Details",
  "admin.audit.system": "The system",
  "admin.audit.unknownItem": "An item since removed",
  "admin.audit.table": "Audit log entries",
  "command.audit": "Audit log",
  "settings.retention.auditDays.label": "Days the audit log is kept",
  "settings.retention.auditDays.help": "Older entries are removed once a day. 0 keeps them for ever. Changing this requires confirming with your passkey.",
  "settings.security.ipAllowlistOn.label": "Allow sign-in only from these networks",
  "settings.security.ipAllowlistOn.help": "Applies to every sign-in, administrators included; sessions already open from elsewhere end at their next request.",
  "settings.security.ipAllowlist.label": "Networks (one per line: an address or a range)",
  "settings.security.ipAllowlist.help": "IPv4 or IPv6 addresses, or ranges in CIDR form, such as 203.0.113.0/24 or 2001:db8::/32. A list that would shut you out cannot be saved.",
  "settings.security.ipAllowlist.youAllowed": "Your address now: {address} · allowed.",
  "settings.security.ipAllowlist.youNot": "Your address now: {address} · not in this list, so it cannot be saved while the allowlist is on.",
  "error.would_lock_you_out": "This list leaves out the network you are on, so saving it would shut you out. Add your network first.",
  "error.network_not_allowed": "Signing in is allowed only from certain networks, and this is not one of them. Ask an administrator.",
  "audit.action.account.passkey_added": "Added a passkey",
  "audit.action.account.passkey_removed": "Removed a passkey",
  "audit.action.account.recovery_codes_created": "Made new recovery codes",
  "audit.action.admin.recovery_link_created": "Made a recovery link",
  "audit.action.admin.user_made_admin": "Made someone an administrator",
  "audit.action.admin.user_admin_removed": "Removed an administrator",
  "audit.action.admin.user_disabled": "Disabled an account",
  "audit.action.admin.user_enabled": "Enabled an account",
  "audit.action.admin.user_signed_out": "Signed someone out everywhere",
  "audit.action.admin.user_deleted": "Deleted an account",
  "audit.action.admin.job_run": "Ran a job now",
  "audit.action.admin.backup_downloaded": "Downloaded a backup",
  "audit.action.admin.content_searched": "Searched pages’ content",
  "audit.action.admin.page_read": "Read a page from content search",
  "audit.action.appearance.changed": "Changed the app's appearance",
  "audit.action.appearance.logo_changed": "Changed the app's logo",
  "audit.action.appearance.logo_removed": "Removed the app's logo",
  "audit.action.auth.login": "Signed in",
  "audit.action.auth.logout": "Signed out",
  "audit.action.auth.oauth_linked": "Linked a sign-in account",
  "audit.action.auth.recovered": "Recovered an account",
  "audit.action.auth.signed_up": "Created an account",
  "audit.action.block.inheritance_restored": "Gave a block its page's permissions again",
  "audit.action.block.shared": "Shared a block",
  "audit.action.block.unshared": "Stopped sharing a block",
  "audit.action.comment.deleted": "Deleted a comment",
  "audit.action.comment.edit_approved": "Approved a comment's edit",
  "audit.action.comment.edit_declined": "Declined a comment's edit",
  "audit.action.comment.hidden": "Hid a comment",
  "audit.action.comment.reports_dismissed": "Dismissed reports on a comment",
  "audit.action.comment.shown": "Showed a hidden comment",
  "audit.action.database.access_rules": "Changed a database's access rules",
  "audit.action.database.column_access": "Changed who sees a database property",
  "audit.action.database.property_deleted": "Deleted a database property",
  "audit.action.database.source_added": "Added a data source",
  "audit.action.file.deleted": "Deleted a file",
  "audit.action.file.renamed": "Renamed a file",
  "audit.action.file.texts": "Changed a file's texts",
  "audit.action.file.uploaded": "Uploaded a file",
  "audit.action.font.deleted": "Deleted a font",
  "audit.action.font.uploaded": "Uploaded a font",
  "audit.action.group.created": "Created a group",
  "audit.action.group.deleted": "Deleted a group",
  "audit.action.group.manager_added": "Added a group manager",
  "audit.action.group.manager_removed": "Removed a group manager",
  "audit.action.group.member_added": "Added someone to a group",
  "audit.action.group.member_removed": "Removed someone from a group",
  "audit.action.group.renamed": "Renamed a group",
  "audit.action.instance.invite_created": "Invited someone to the installation",
  "audit.action.instance.invite_revoked": "Withdrew an invitation to the installation",
  "audit.action.language.audience": "Changed who is offered a language",
  "audit.action.language.created": "Added a language",
  "audit.action.language.deleted": "Removed a language",
  "audit.action.language.updated": "Changed a language",
  "audit.action.locale_data.saved": "Changed a language's formats",
  "audit.action.page.address_changed": "Changed a page's address",
  "audit.action.page.archived": "Archived a page",
  "audit.action.page.comment_edit_minutes": "Changed how long comments may be edited",
  "audit.action.page.comments_setting": "Turned a page's comments on or off",
  "audit.action.page.deleted": "Deleted a page for good",
  "audit.action.page.inheritance_restored": "Gave a page its parent's permissions again",
  "audit.action.page.language": "Changed a page's language",
  "audit.action.page.made_database": "Turned a page into a database",
  "audit.action.page.moved_section": "Moved a page to another section",
  "audit.action.page.previewed_as": "Previewed a page as someone else",
  "audit.action.page.published": "Published a page",
  "audit.action.page.restored": "Restored a page",
  "audit.action.page.shared": "Shared a page",
  "audit.action.page.trashed": "Moved a page to the trash",
  "audit.action.page.unarchived": "Unarchived a page",
  "audit.action.page.unpublished": "Unpublished a page",
  "audit.action.page.unshared": "Stopped sharing a page",
  "audit.action.page.version_restored": "Brought back an earlier version of a page",
  "audit.action.page.width": "Changed a page's width",
  "audit.action.settings.updated": "Changed a setting",
  "audit.action.setup.completed": "Set up the installation",
  "audit.action.site.address_changed": "Changed a site's address",
  "audit.action.site.block_style_added": "Added a block style to a site",
  "audit.action.site.settings_published": "Published a site's settings",
  "audit.action.teamspace.changed": "Changed a teamspace",
  "audit.action.teamspace.created": "Created a teamspace",
  "audit.action.teamspace.member_removed": "Removed someone from a teamspace",
  "audit.action.teamspace.member_set": "Added someone to a teamspace or changed their role",
  "audit.action.translations.imported": "Imported translations",
  "audit.action.translations.published": "Published translations",
  "audit.action.translations.restored": "Brought back earlier translations",
  "audit.action.translations.role_granted": "Gave someone a translation role",
  "audit.action.translations.role_removed": "Took away a translation role",
  "audit.action.workspace.created": "Created a workspace",
  "audit.action.workspace.invite_accepted": "Accepted an invitation to a workspace",
  "audit.action.workspace.invite_created": "Invited someone to a workspace",
  "audit.action.workspace.invite_revoked": "Withdrew an invitation to a workspace",
  "audit.action.workspace.member_role_changed": "Changed someone's role in a workspace",
  "audit.action.workspace.updated": "Changed a workspace",
  "settings.retention.historyDays.label": "Days of page history kept",
  "settings.retention.historyDays.help": "Older versions are removed as pages are edited, up to the history's own limit of 30 days and 100 versions. 0 keeps the most the history allows.",
  "error.publishing_off": "Publishing is turned off on this installation.",
  "error.export_off": "Export is turned off on this installation.",
  "error.external_sharing_off": "Pages can only be shared with members of their workspace.",
  "error.teamspace_creation_off": "Only owners can create teamspaces here.",
  "error.too_many_reminders": "You have too many reminders waiting.",
  "error.too_many_favorites": "You have too many favourites.",
  "error.bad_filter": "That search filter isn’t valid.",
  "inbox.comment_reaction": "{actor} reacted {detail} to your comment on {page}",
  "inbox.page_comment": "{actor} commented on {page}",
  "inbox.page_updated": "{actor} edited {page}",
  "inbox.reminder": "Reminder: {page}",
  "inbox.button_notice": "{actor} pressed a button on {page}",
  "sidebar.library": "Library",
  "sidebar.files": "Files",
  "teamspace.ownersCreate": "Only owners of this workspace can create teamspaces.",
  "follow.favorite": "Favourite",
  "follow.favorited": "Added to Favourites.",
  "follow.unfavorited": "Removed from Favourites.",
  "follow.title": "Notifications",
  "follow.notify": "Tell me about",
  "follow.mode.all": "All comments and edits",
  "follow.mode.all.help": "You follow this page.",
  "follow.mode.default": "Replies and mentions",
  "follow.mode.default.help": "Replies in discussions you wrote in, and mentions of you.",
  "follow.mode.mute": "Mentions only",
  "follow.mode.mute.help": "Replies are muted.",
  "follow.saved": "Notifications changed.",
  "follow.reminders": "Reminders",
  "follow.noReminders": "No reminders about this page.",
  "follow.remindAt": "Remind me on",
  "follow.reminderNote": "Note (optional)",
  "follow.addReminder": "Add reminder",
  "follow.reminderSet": "Reminder set. It will appear in your inbox.",
  "follow.reminderRemoved": "Reminder removed.",
  "follow.removeReminder": "Remove the reminder for {when}",
  "follow.updates": "Updates",
  "follow.noUpdates": "No updates yet.",
  "follow.edited": "{people} edited the page",
  "follow.commented": "{people} commented",
  "discussions.saveForLater": "Save for later",
  "discussions.savedDone": "Saved for later.",
  "discussions.unsavedDone": "No longer saved.",
  "discussions.muteReplies": "Mute replies",
  "discussions.mutedDone": "Replies muted. A mention, or replying yourself, turns them back on.",
  "discussions.unmutedDone": "Replies on.",
  "discussions.saved": "Saved ({count})",
  "discussions.noneSaved": "No discussions saved for later.",
  "library.title": "Library",
  "library.recents": "Recents",
  "library.favorites": "Favourites",
  "library.private": "Private",
  "library.shared": "Shared",
  "library.teamspaces": "Teamspaces",
  "library.noRecents": "Pages you open appear here.",
  "library.noFavorites": "No favourites yet. Use the star at the top of a page.",
  "library.noPages": "No pages here.",
  "library.noTeamspaces": "You are not in any teamspace.",
  "library.removeFavorite": "Remove {title} from Favourites",
  "search.action.library": "Library",
  "search.action.library.keywords": "library favourites favorites recent recents",
  "search.action.files": "Files",
  "search.action.files.keywords": "files images media uploads library pictures",
  "search.action.filters": "Search with filters",
  "search.action.filters.keywords": "search filter advanced find",
  "searchPage.title": "Search",
  "searchPage.query": "Search for",
  "searchPage.titleOnly": "In titles only",
  "searchPage.createdBy": "Created by",
  "searchPage.anyone": "Anyone",
  "searchPage.me": "Me",
  "searchPage.teamspace": "Teamspace",
  "searchPage.anywhere": "Anywhere",
  "searchPage.inPage": "In page",
  "searchPage.edited": "Last edited",
  "searchPage.edited.any": "Any time",
  "searchPage.edited.day": "In the past day",
  "searchPage.edited.week": "In the past week",
  "searchPage.edited.month": "In the past month",
  "searchPage.edited.year": "In the past year",
  "searchPage.sort": "Order",
  "searchPage.sort.relevance": "Best match",
  "searchPage.sort.edited": "Last edited",
  "searchPage.sort.created": "Newest",
  "searchPage.archived": "Include archived pages",
  "searchPage.search": "Search",
  "searchPage.results": "Results",
  "searchPage.hint": "Type at least two characters and choose filters.",
  "searchPage.none": "No pages match.",
  "searchPage.count": "{count, plural, one {# page found} other {# pages found}}",
  "library.filter": "Filter by title",
  "library.sort": "Sort by",
  "library.sort.default": "As listed",
  "library.sort.title": "Title",
  "library.sort.edited": "Last edited",
  "library.sort.created": "Newest",
  "database.type.row_position": "Row number",
  "database.type.formula": "Formula",
  "database.type.relation": "Relation",
  "database.type.rollup": "Rollup",
  "database.propertyIncomplete": "Give the property and each option a name, and choose what it relates to or rolls up.",
  "database.formula": "Formula",
  "database.formulaHelp": "Notion's formula language: for example {example} + \" (draft)\". Text in double quotes; properties by name.",
  "database.formulaInvalid": "Not a valid formula: {error}",
  "database.formulaError": "Formula error: {error}",
  "database.relatedDatabase": "Related database",
  "database.chooseDatabase": "Choose a database…",
  "database.thisDatabase": "This database",
  "database.relationLimit": "One row only",
  "database.relationTwoWay": "Show on the related database too (two-way)",
  "database.relationReverseName": "Its name there",
  "database.relatedTo": "Related to {title}",
  "database.relationIsTwoWay": "Two-way: the related database shows this relation too, and they stay in step.",
  "database.relationSearch": "Search rows",
  "database.relationNone": "No rows to relate to.",
  "database.relationNoAccess": "You cannot open the related database.",
  "database.relationOpen": "Open {title}",
  "database.rollupNeedsRelation": "Add a relation first: a rollup summarises the rows it relates to.",
  "database.rollupRelation": "Relation",
  "database.chooseRelation": "Choose a relation…",
  "database.rollupProperty": "Property",
  "database.rollupCalculate": "Calculate",
  "database.rollup.show_original": "Show original",
  "database.rollup.show_unique": "Show unique values",
  "database.rollup.count": "Count all",
  "database.rollup.count_values": "Count values",
  "database.rollup.count_unique": "Count unique values",
  "database.rollup.count_empty": "Count empty",
  "database.rollup.count_not_empty": "Count not empty",
  "database.rollup.percent_empty": "Percent empty",
  "database.rollup.percent_not_empty": "Percent not empty",
  "database.rollup.sum": "Sum",
  "database.rollup.average": "Average",
  "database.rollup.median": "Median",
  "database.rollup.min": "Min",
  "database.rollup.max": "Max",
  "database.rollup.range": "Range",
  "database.rollup.earliest": "Earliest date",
  "database.rollup.latest": "Latest date",
  "database.rollup.date_range": "Date range",
  "database.rollup.checked": "Checked",
  "database.rollup.unchecked": "Unchecked",
  "database.rollup.percent_checked": "Percent checked",
  "error.view_cycle": "Views can’t use each other’s row numbers in a circle.",
  "database.thisView": "In this view",
  "database.inViewNamed": "In view {name}",
  "database.filterView": "View of the row number in filter {n}",
  "database.sortView": "View of the row number in sort {n}",
  "database.countIn": "Count in",
  "database.countInShowing": "The view showing it",
  "database.rowActions": "Row actions for {row}",
  "database.move.up": "Move up",
  "database.move.down": "Move down",
  "database.move.top": "Move to top",
  "database.move.bottom": "Move to bottom",
  "database.moved": "Moved {row}.",
  "database.accessRules": "Access rules",
  "database.accessRulesHelp": "The people a person property names (or the person who created the row) get this access to their rows, and can open this database to see only those rows. To keep rows private, give everyone else less access to the database in Share: what they get there applies to every row.",
  "database.accessRulesNoPeople": "Add a Person or Created by property to make rules with.",
  "database.ruleProperty": "Property of rule {n}",
  "database.ruleLevel": "Access of rule {n}",
  "database.removeRule": "Remove rule {n}",
  "database.addRule": "Add a rule",
  "database.accessRulesSaved": "Access rules saved.",
  "error.invalid_rule": "Rules name Person or Created by properties, each once.",
  "language.blockTitle": "Block language",
  "language.textTitle": "Language of the selected text",
  "language.which": "Language to use",
  "language.followWorkspace": "Same as the workspace ({language})",
  "language.followAbove": "Same as the page above ({language})",
  "language.followAround": "Same as around it ({language})",
  "language.followDefault": "The installation’s default ({language})",
  "language.own": "Another language",
  "language.label": "Language",
  "language.help": "Choose from the list, or type a language tag such as la-x-classic or pt-BR.",
  "language.invalid": "That isn’t a language tag.",
  "language.matches": "Matching languages",
  "language.none": "No language matches; a language tag such as la-x-classic can be typed.",
  "language.useTag": "Use the tag “{tag}”",
  "language.saved": "Language saved.",
  "language.pageDialogTitle": "Language of “{title}”",
  "language.thisPage": "This page’s language",
  "language.pagesUnder": "The pages under it follow, unless they have their own.",
  "command.onPage": "{action}: {title}",
  "command.onFile": "{action}: {name}",
  "command.favorite": "Add this page to Favourites",
  "command.unfavorite": "Remove this page from Favourites",
  "command.notifications": "This page’s notifications",
  "command.updates": "This page’s updates",
  "command.share": "Share this page",
  "command.publish": "Publish this page",
  "command.inbox": "Go to the inbox",
  "command.shared": "Go to pages shared with me",
  "command.security": "Go to account security",
  "command.newWorkspace": "Create a workspace",
  "command.teamspaces": "Go to the teamspaces",
  "command.teamspace": "Go to the teamspace {name}",
  "command.workspace": "Open workspace: {name}",
  "command.groups": "Go to groups",
  "command.vimOn": "Turn Vim keys on",
  "command.vimOff": "Turn Vim keys off",
  "command.quotesOn": "Turn typographic quotes on",
  "command.quotesOff": "Turn typographic quotes off",
  "command.pairOn": "Close {name} as I type",
  "command.pairOff": "Stop closing {name} as I type",
  "command.subOn": "Replace {from} by {to} as I type",
  "command.subOff": "Stop replacing {from} by {to}",
  "editor.command.discussions": "Show or hide the comments panel",
  "editor.command.commentsOff": "Turn off comments on this page",
  "editor.command.commentsOn": "Turn on comments on this page",
  "editor.html.menu": "Edit as HTML…",
  "editor.html.title": "Edit as HTML",
  "editor.html.label": "{kind}: its text as HTML",
  "editor.html.help": "Marks, links, passages in other languages (lang), colours, line breaks, mentions and equations are kept. The block keeps its type and settings; anything else is left out.",
  "editor.html.dropped": "Some of this cannot be kept: elements or attributes the editor does not know, or unsafe links. Save anyway to keep the rest.",
  "editor.html.saveAnyway": "Save anyway",
  "editor.html.saved": "Block updated from its HTML.",
  "editor.html.discussions": "Comments are about some of this block's text, so it cannot be edited as HTML. Resolve them, or edit it in the page.",
  "editor.command.goToHeading": "Go to “{heading}”",
  "typing.greekOn": "Greek (Beta Code) in any text",
  "typing.greekOff": "Greek (Beta Code) in Greek text only",
  "account.typing.emoji": "Suggest emoji after “:” and a name (:smile → 😄)",
  "account.typing.emojiOn": "Emoji suggestions on",
  "account.typing.emojiOff": "Emoji suggestions off",
  "account.typing.beta": "Type polytonic Greek in Beta Code in Greek text",
  "account.typing.betaHelp": "In text whose language is Greek, Latin letters type Greek ones, as on TypeGreek: diacritics after their letter, in any order; Shift for capitals; s or j for sigma, final at the end of a word; : for the raised dot. {toggle} types Greek in any text, and back.",
  "account.typing.betaOn": "Beta Code on",
  "account.typing.betaOff": "Beta Code off",
  "account.typing.betaKey": "Beta Code keys",
  "account.typing.key": "Key",
  "account.typing.gives": "Gives",
  "command.emojiOn": "Turn emoji suggestions after “:” on",
  "command.emojiOff": "Turn emoji suggestions after “:” off",
  "command.betaOn": "Turn Beta Code (polytonic Greek) on",
  "command.betaOff": "Turn Beta Code (polytonic Greek) off",
  "command.greekEverywhereOn": "Type Greek in Beta Code in any text",
  "command.greekEverywhereOff": "Type Greek in Beta Code in Greek text only",
  "keyboard.currencies": "Currencies",
  "keyboard.czech": "Czech",
  "keyboard.danish": "Danish",
  "keyboard.dutch": "Dutch",
  "keyboard.esperanto": "Esperanto",
  "keyboard.finnish": "Finnish",
  "keyboard.french": "French",
  "keyboard.german": "German",
  "keyboard.greek": "Greek",
  "keyboard.hungarian": "Hungarian",
  "keyboard.icelandic": "Icelandic",
  "keyboard.ipa": "IPA (English)",
  "keyboard.ipa-full": "IPA (full)",
  "keyboard.italian": "Italian",
  "keyboard.maori": "Māori",
  "keyboard.math": "Mathematics",
  "keyboard.norwegian": "Norwegian",
  "keyboard.pinyin": "Pinyin",
  "keyboard.polish": "Polish",
  "keyboard.portuguese": "Portuguese",
  "keyboard.romanian": "Romanian",
  "keyboard.russian": "Russian",
  "keyboard.spanish": "Spanish",
  "keyboard.swedish": "Swedish",
  "keyboard.symbols": "Symbols",
  "keyboard.turkish": "Turkish",
  "keyboard.ukrainian": "Ukrainian",
  "keyboard.vietnamese": "Vietnamese",
  "keyboard.welsh": "Welsh",
  "chars.title": "Special characters",
  "chars.keyboard": "Keyboard",
  "chars.automatic": "{name} (as the text)",
  "chars.choose": "Choose a keyboard",
  "chars.turnedOn": "Turned on",
  "chars.others": "Others",
  "chars.letters": "{name} letters in any text ({keys})",
  "chars.close": "Close the special characters",
  "chars.mark": "Add {mark} to the letter before {keys}",
  "chars.times": "{keys} ×{times}",
  "chars.loading": "Loading the keyboard…",
  "chars.none": "Choose a keyboard to see its characters.",
  "chars.noTarget": "Put the cursor where the character goes first.",
  "chars.help": "A character goes where the cursor is, which keeps the focus. Shift (or Shift+click) types capitals. With {alt}, a character's key types it; pressed again at once, the next one on the same key. Or type the letter, then tap {tap}. Escape goes back to the text.",
  "chars.indicator": "Special characters: {name}",
  "chars.indicatorLabel": "Special characters: {name}. Change the keyboard ({next} picks the next one)",
  "chars.useKeyboard": "Use the {name} keyboard",
  "chars.byLanguage": "By the text's language",
  "chars.showPanel": "Show the characters panel",
  "chars.indicatorOff": "Special characters: off",
  "chars.indicatorOffLabel": "Special characters are off. Turn them on",
  "chars.turnOn": "Turn special characters on",
  "chars.turnOff": "Turn special characters off",
  "chars.allOn": "Special characters turned on.",
  "chars.allOff": "Special characters turned off. Your keyboards are kept.",
  "typing.lettersOn": "{name} letters in any text",
  "typing.lettersOff": "{name} letters in {name} text only",
  "account.typing.keyboards": "Special characters",
  "account.typing.keyboardsSwitch": "Turn on special characters",
  "account.typing.keyboardsSwitchHelp": "Off by default. While off, nothing is typed through the keyboards, and the keyboards you choose below are kept for when you turn them on.",
  "account.typing.keyboardsHelp": "As on TypeIt, for the keyboards turned on, wherever you type: hold {alt} and press a letter ({altE} é, pressed again è, ê…), or type the letter and tap {tap} (tapped again, the next one). The keyboard of the text's language answers first, then the others turned on; {next} picks the next one for now, as does the special-characters indicator. The Greek, Russian and Ukrainian keyboards type their alphabet with the letter keys in text of their language, and Pinyin and Vietnamese add tones with the digits; {altEnter} does it in any text.",
  "account.typing.keyboardOn": "{name} keyboard on",
  "account.typing.keyboardOff": "{name} keyboard off",
  "account.typing.showChars": "Show the characters panel",
  "command.charsShow": "Show the special characters",
  "command.charsHide": "Hide the special characters",
  "command.charsOn": "Turn special characters on",
  "command.charsOff": "Turn special characters off",
  "command.keyboardPick": "Type special characters with the {name} keyboard",
  "command.keyboardAuto": "Type special characters with the keyboard of the text's language",
  "command.keyboardNext": "Type special characters with the next keyboard turned on",
  "command.keyboardOn": "Turn the {name} keyboard on",
  "command.keyboardOff": "Turn the {name} keyboard off",
  "command.lettersOn": "Type {name} letters in any text",
  "command.lettersOff": "Type {name} letters in {name} text only",
  "command.inboxOpen": "Open: {item}",
  "command.comment": "{action}: “{text}”",
  "command.react": "React with {emoji} to {name}’s comment",
  "command.unreact": "Take back {emoji} from {name}’s comment",
  "command.commentNew": "Write a comment on this page",
  "command.discussionsClose": "Close the discussions",
  "command.discussionsOpen": "Show the open discussions",
  "command.discussionsSaved": "Show the discussions saved for later",
  "command.discussionsResolved": "Show the resolved discussions",
  "command.discussionSave": "Save for later the discussion about “{text}”",
  "command.discussionUnsave": "Stop saving the discussion about “{text}”",
  "command.discussionMute": "Mute replies to the discussion about “{text}”",
  "command.discussionUnmute": "Unmute replies to the discussion about “{text}”",
  "command.databaseNewRow": "New row",
  "command.databaseView": "Go to the view {view} of {title}",
  "command.databaseSource": "Go to the data source {source} of {title}",
  "command.databaseAddView": "Add a {type} view to {title}",
  "command.goToField": "Go to the field “{name}”",
  "command.toggle": "Turn “{name}” on or off",
  "command.choose": "Choose “{name}”",
  "command.followLink": "Open “{name}”",
  "vimHelp.insertKeys.ctrlWApple": "Delete the word before the cursor.",
  "account.typing.keyboardsMac": "Only the right ⌥ is taken: the left one still types the characters macOS gives it.",
  "translations.field.scripts": "Scripts",
  "translations.field.fallbacks": "Languages to fall back on",
  "translations.audiencePeopleList": "People",
  "field.people": "People",
  "field.languages": "Languages",
  "command.siteSettings": "Site settings",
  "command.appearance": "App appearance",
  "sites.settings": "Settings of {workspace}’s site",
  "style.title": "Style",
  "style.presets": "Starting points",
  "style.presets.help": "Each sets every value below, all readable in light and dark; change any of them after.",
  "style.preset.use": "Use the {name} style",
  "style.preset.default": "Pāginæ",
  "style.preset.classic": "Classic",
  "style.preset.modern": "Modern",
  "style.preset.high-contrast": "High contrast",
  "style.colours": "Colours",
  "style.mode": "Shown in",
  "style.mode.system": "Light or dark, as each reader’s device is set",
  "style.mode.light": "Light only",
  "style.mode.dark": "Dark only",
  "style.mode.app": "The app is light or dark as each person’s device is set, so both sets of colours are used.",
  "style.light": "Light",
  "style.dark": "Dark",
  "style.color.bg": "Background",
  "style.color.surface": "Surfaces (callouts, code, cards)",
  "style.color.text": "Text",
  "style.color.muted": "Secondary text",
  "style.color.border": "Borders",
  "style.color.accent": "Links and buttons",
  "style.color.accentText": "Text on buttons",
  "style.color.picker": "{name}: choose a colour",
  "style.color.invalid": "A colour as #rrggbb, like #1f4fbf.",
  "style.contrast": "Contrast",
  "style.contrast.ok": "Every colour can be read against what it is on.",
  "style.contrast.count": "{count, plural, one {# pair of colours is} other {# pairs of colours are}} too close to read. Change them to publish.",
  "style.contrast.issue": "{palette}: {foreground} on {background}, {ratio}:1; needs {required}:1",
  "style.part.block": "{colour} text",
  "style.part.fill": "{colour} highlight",
  "style.part.danger": "Warnings",
  "style.part.success": "Confirmations",
  "style.colourName.gray": "Grey",
  "style.colourName.brown": "Brown",
  "style.colourName.orange": "Orange",
  "style.colourName.yellow": "Yellow",
  "style.colourName.green": "Green",
  "style.colourName.blue": "Blue",
  "style.colourName.purple": "Purple",
  "style.colourName.pink": "Pink",
  "style.colourName.red": "Red",
  "style.type": "Text",
  "style.font.body": "Font of the text",
  "style.font.heading": "Font of headings",
  "style.font.code": "Font of code",
  "style.font.list": "Fonts",
  "style.font.unknown": "Choose one of the fonts suggested.",
  "style.font.system.sans": "The device’s own sans-serif",
  "style.font.system.serif": "The device’s own serif",
  "style.font.system.mono": "The device’s own monospace",
  "style.font.greek": "{name} (with Greek)",
  "style.font.polytonic": "{name} (with polytonic Greek)",
  "style.font.uploaded": "{family} (uploaded)",
  "style.size": "Text size",
  "style.size.help": "In any unit that grows with zoom, such as 16px or 1.1rem. Readers can still make it larger.",
  "style.lineHeight": "Space between lines",
  "style.letterSpacing": "Space between letters",
  "style.letterSpacing.help": "0em is the font’s own.",
  "style.headingScale": "Heading sizes",
  "style.headingScale.help": "How much larger each heading level is than the next.",
  "style.headingWeight": "Heading weight",
  "style.weight.400": "Regular",
  "style.weight.500": "Medium",
  "style.weight.600": "Semibold",
  "style.weight.700": "Bold",
  "style.layout": "Layout",
  "style.width": "Max text width",
  "style.width.help": "Such as 44rem, 70ch or 90vw. Pages set to full width use the whole window.",
  "style.radius": "Rounded corners",
  "style.density": "Spacing",
  "style.density.compact": "Compact",
  "style.density.normal": "Normal",
  "style.density.roomy": "Roomy",
  "style.components": "Blocks",
  "style.links": "Links",
  "style.links.always": "Always underlined",
  "style.links.hover": "Underlined on hover and focus",
  "style.callout": "Callouts",
  "style.callout.filled": "Filled",
  "style.callout.outlined": "Outlined",
  "style.quote": "Quotes",
  "style.quote.bar": "With a bar in the text’s colour",
  "style.quote.accent": "With a bar in the links’ colour",
  "style.quote.plain": "Indented, in italics",
  "style.tables": "Tables",
  "style.tables.grid": "Lines around every cell",
  "style.tables.rows": "Lines between rows",
  "style.css": "Your own CSS",
  "style.css.label": "CSS",
  "style.css.siteHelp": "Added after the style. It cannot run scripts, and the site loads nothing from elsewhere but images.",
  "style.css.appHelp": "Added after the style, for everyone. Saving changes to it asks you to confirm it’s you.",
  "style.export": "Export the style",
  "style.import": "Import a style",
  "style.import.invalid": "That file is not a style exported from Pāginæ.",
  "style.imported": "Style imported. Check it, then save or publish.",
  "style.reset": "Reset the style",
  "siteSettings.title": "Site settings",
  "siteSettings.intro": "The published site’s name, menus, style, search engines and addresses.",
  "siteSettings.open.settings": "Open the site settings",
  "siteSettings.noSite": "This workspace has no site address yet. An administrator gives it one in Administration → Settings → Sites.",
  "siteSettings.help": "For {hostname}. Changes are kept as a draft and shown in the preview; publishing them changes every page at once.",
  "siteSettings.open": "Open the site",
  "siteSettings.actions": "Draft",
  "siteSettings.publish": "Publish changes",
  "siteSettings.discard": "Discard changes",
  "siteSettings.saving": "Saving the draft…",
  "siteSettings.draftSaved": "Draft saved, not published yet.",
  "siteSettings.draftBlocked": "Draft saved. Fix what is listed before publishing.",
  "siteSettings.upToDate": "No unpublished changes.",
  "siteSettings.published": "Changes published.",
  "siteSettings.discarded": "Changes discarded.",
  "siteSettings.unpublished": "These pages are in a menu but not published: {pages}. Publish them, or take them out.",
  "siteSettings.identity": "Name and images",
  "siteSettings.name": "Site name",
  "siteSettings.name.help": "In the header and in titles. Empty: the workspace’s name.",
  "siteSettings.tagline": "Tagline",
  "siteSettings.logo": "Logo",
  "siteSettings.logo.help": "Shown in the header.",
  "siteSettings.favicon": "Icon",
  "siteSettings.favicon.help": "Shown in browser tabs and bookmarks; a square image.",
  "siteSettings.socialImage": "Sharing image",
  "siteSettings.socialImage.help": "Shown where links to the site are shared.",
  "siteSettings.logoAlt": "What the logo says",
  "siteSettings.logoAlt.help": "Read out instead of the logo when the name is not shown beside it.",
  "siteSettings.image.none": "None",
  "siteSettings.image.chosen": "An image from the library",
  "siteSettings.image.choose": "Choose the {name}",
  "siteSettings.image.remove": "Remove the {name}",
  "siteSettings.image.upload": "Upload an image",
  "siteSettings.image.empty": "The library has no images yet.",
  "siteSettings.image.unnamed": "Unnamed image",
  "siteSettings.header": "Header",
  "siteSettings.header.show": "Show a header on every page",
  "siteSettings.header.showName": "Show the site’s name",
  "siteSettings.header.sticky": "Keep it in view when scrolling",
  "siteSettings.header.align": "Position",
  "siteSettings.header.align.start": "Name at the start, menu at the end",
  "siteSettings.header.align.center": "Centred",
  "siteSettings.header.items": "Menu",
  "siteSettings.footer": "Footer",
  "siteSettings.footer.text": "Text",
  "siteSettings.footer.copyright": "Copyright line",
  "siteSettings.footer.items": "Footer links",
  "siteSettings.links.none": "No links yet.",
  "siteSettings.links.label": "Link {n}: text",
  "siteSettings.links.target": "Link {n}: goes to",
  "siteSettings.links.page": "A published page",
  "siteSettings.links.url": "An address",
  "siteSettings.links.pageField": "Link {n}: page",
  "siteSettings.links.urlField": "Link {n}: address",
  "siteSettings.links.url.help": "A path on the site (/about) or an https:// address.",
  "siteSettings.links.up": "Move link {n} up",
  "siteSettings.links.down": "Move link {n} down",
  "siteSettings.links.remove": "Remove link {n}",
  "siteSettings.links.add": "Add a link to {list}",
  "siteSettings.links.new": "New link",
  "siteSettings.pages": "Published pages",
  "siteSettings.seo": "Search engines and sharing",
  "siteSettings.seo.title": "Page titles",
  "siteSettings.seo.title.help": "{page} is the page’s title and {site} the site’s name. Empty: the page’s title alone.",
  "siteSettings.seo.description": "Description",
  "siteSettings.seo.indexable": "Let search engines list the site",
  "siteSettings.seo.indexable.help": "Off, every page asks them not to.",
  "siteSettings.seo.sitemap": "Give search engines a list of the pages (sitemap)",
  "siteSettings.analytics": "Visitor statistics",
  "siteSettings.analytics.token": "Cloudflare Web Analytics token",
  "siteSettings.analytics.help": "From your Cloudflare dashboard; it counts visits without cookies. Empty: no statistics, and no script on the site.",
  "siteSettings.addresses": "Addresses",
  "siteSettings.notFound": "Page for addresses with nothing",
  "siteSettings.notFound.help": "A published page, shown with “not found”. Empty: a short message.",
  "siteSettings.redirects": "Redirects",
  "siteSettings.redirects.help": "Send an old address to a page’s path or another site. Pages that move redirect by themselves.",
  "siteSettings.redirects.from": "Redirect {n}: from",
  "siteSettings.redirects.to": "Redirect {n}: to",
  "siteSettings.redirects.permanent": "Redirect {n} is permanent",
  "siteSettings.redirects.remove": "Remove redirect {n}",
  "siteSettings.redirects.add": "Add a redirect",
  "siteSettings.comments": "Readers’ comments",
  "siteSettings.comments.toggle": "Show comments on the site’s pages",
  "siteSettings.comments.help": "Off hides them on every page, whatever each page says.",
  "siteSettings.preview": "Preview",
  "siteSettings.preview.page": "Page shown",
  "siteSettings.preview.frame": "Preview of {hostname}",
  "appearance.title": "Appearance",
  "appearance.help": "How the app looks for everyone. Changes show on this screen as you make them, and for everyone once saved.",
  "appearance.brand": "Logo",
  "appearance.brand.help": "Shown before “{name}” in the header and on the sign-in page. The name is changed in Settings → Branding.",
  "appearance.logo.upload": "Upload a logo",
  "appearance.logo.replace": "Replace the logo",
  "appearance.logo.remove": "Remove the logo",
  "appearance.logo.set": "Logo saved.",
  "appearance.logo.removed": "Logo removed.",
  "appearance.logoAlt": "What the logo says",
  "appearance.logoAlt.help": "Only if it says more than the name beside it; otherwise leave it empty.",
  "appearance.previewCss": "Your own CSS while editing",
  "appearance.previewCss.on": "Show it on this screen",
  "appearance.previewCss.off": "Leave it out until saved",
  "appearance.safeMode": "If your CSS ever makes the app hard to use, open it with {address} at the end of the address: it shows the app’s own look until you reload.",
  "appearance.save": "Save the appearance",
  "appearance.saved": "Appearance saved.",
  "appearance.blocked": "Some colours are too close to read; change them to save.",
  "appearance.fonts": "Fonts",
  "appearance.fonts.help": "Fonts of your own, for the app and every site. Upload each weight and style as a file (WOFF2 is best); make sure their licence allows it.",
  "appearance.fonts.none": "No fonts uploaded.",
  "appearance.fonts.face": "{family}, {weight}, {style}",
  "appearance.fonts.remove": "Remove {name}",
  "appearance.fonts.removed": "{family} removed.",
  "appearance.fonts.added": "{family} added.",
  "appearance.fonts.family": "Family",
  "appearance.fonts.family.help": "Letters, digits, spaces and hyphens. Faces of one family share its name.",
  "appearance.fonts.weight": "Weight",
  "appearance.fonts.styleLabel": "Style",
  "appearance.fonts.style.normal": "Upright",
  "appearance.fonts.style.italic": "Italic",
  "appearance.fonts.file": "Font file",
  "appearance.fonts.upload": "Upload the font",
  "contextMenu.label": "Actions",
  "contextMenu.block": "This block",
  "contextMenu.page": "Page “{title}”",
  "contextMenu.screen": "This screen",
  "contextMenu.open": "Open",
  "contextMenu.openTab": "Open in a new tab",
  "contextMenu.copyLink": "Copy link",
  "contextMenu.linkCopied": "Link copied.",
  "contextMenu.all": "All commands…",
  "contextMenu.browserHint": "The browser’s own menu: right-click again, or press {keys} again.",
  "editor.command.cut": "Cut",
  "editor.command.copy": "Copy",
  "editor.command.paste": "Paste",
  "editor.paste.refused": "The browser did not allow pasting from the menu; paste with the keyboard instead.",
  "editor.command.linkOpen": "Open the link",
  "editor.command.linkOpenTab": "Open the link in a new tab",
  "editor.command.linkCopy": "Copy the link’s address",
  "editor.command.linkCopied": "Address copied.",
  "editor.command.deleteBlock": "Delete block",
  "account.contextMenu.title": "Right-click menu",
  "account.contextMenu.toggle": "Pāginæ’s right-click menu",
  "account.contextMenu.help": "Off: the browser’s own menu everywhere. On, the browser’s is still a second right-click away (or Shift+right-click).",
  "account.contextMenu.on": "Pāginæ’s right-click menu is on.",
  "account.contextMenu.off": "Pāginæ’s right-click menu is off; right-clicks show the browser’s.",
  "command.contextMenuOn": "Turn on Pāginæ’s right-click menu",
  "command.contextMenuOff": "Turn off Pāginæ’s right-click menu",
  "editor.image.size": "Size",
  "editor.image.size.original": "Its own size",
  "editor.image.size.full": "The full width",
  "editor.image.size.custom": "Custom",
  "editor.image.width": "Width",
  "editor.image.align": "Alignment",
  "editor.image.resize": "Width of the image",
  "editor.image.resized": "{pct}% of the width",
  "editor.html.imageLabel": "{kind}: its HTML",
  "editor.html.imageHelp": "The description (alt), the width (a width in pixels, or the classes img-full and img-w-5 to img-w-100), the alignment (img-align-left, img-align-center, img-align-right), a link and a caption are kept. The image itself stays: choose another from its details. The description and caption are kept with the image in the workspace's files.",
  "editor.html.treeLabel": "{kind}: its HTML, with the blocks in it",
  "editor.html.pageLabel": "{kind}: its title and blocks as HTML",
  "editor.html.treeHelp": "Each block is an element with its ID (data-block-id) and its settings (data-…); text is as in a text block's HTML. Blocks that keep their IDs stay the same blocks, with their permissions, comments and links; new elements, such as p or h2, become new blocks; blocks taken out are removed. Linked databases, synced copies and buttons are shown but cannot be changed here. What the editor does not know is left out.",
  "editor.html.page": "Page",
  "editor.html.pageMenu": "Edit page as HTML…",
  "editor.html.block": "Block",
  "editor.html.pageDiscussions": "Comments are about some of this page's text, so it cannot be edited as HTML as a whole. Edit its other blocks as HTML one by one, or resolve the comments.",
  "editor.image.widthHelp": "Any CSS length, such as 50%, 320px, 12em or 8cm.",
  "editor.columns.widths": "Column widths",
  "editor.columns.widthsMenu": "Column widths…",
  "editor.columns.widthsCommand": "Column widths",
  "editor.columns.widthsHelp": "Each column’s width, in any CSS unit, such as 30%, 20em or 6cm. Leave one empty to share the rest of the row equally. Dragging between columns gives them shares again, the same on every screen.",
  "editor.columns.width": "Width of column {n}",
  "editor.columns.widthsSaved": "Column widths saved.",
  "editor.command.clearOn": "Start this block below floating blocks",
  "editor.command.clearOff": "Let this block sit beside floating blocks",
  "action.remove": "Remove",
  "style.more": "More",
  "style.more.help": "Each part opens on its own. What is left unset follows the settings above.",
  "style.more.colours": "Further colours",
  "style.more.coloursHelp": "Links, headings, selections, focus rings, code and table headers. Unless set, each follows the colour it names.",
  "style.more.blockColours": "Blocks’ colours",
  "style.more.blockColoursHelp": "The nine text colours and backgrounds blocks can take, in each mode. Each is checked against the page.",
  "style.more.blockColoursReset": "Use the usual blocks’ colours",
  "style.more.fonts": "More fonts",
  "style.more.fontsHelp": "Fonts headings and block styles may use, besides the three above. They are served with the style, from this installation only.",
  "style.more.font": "Font {n}",
  "style.more.fontAdd": "Add a font",
  "style.more.fontRemove": "Remove {name}",
  "style.more.body": "Body text",
  "style.more.headings": "Headings",
  "style.more.links": "Links",
  "style.more.code": "Code",
  "style.more.layout": "Layout",
  "style.more.blocks": "Each kind of block",
  "style.more.blockStyles": "Block styles",
  "style.unset.default": "As the style has it if empty.",
  "style.unset.short": "As the style has it",
  "style.color.own": "A colour of its own for {name}",
  "style.color.follows": "Follows {name}.",
  "style.extra.link": "Links",
  "style.extra.linkHover": "Links pointed at",
  "style.extra.heading": "Headings",
  "style.extra.selection": "Selected text’s background",
  "style.extra.focus": "Focus ring",
  "style.extra.codeText": "Code text",
  "style.extra.codeBg": "Code background",
  "style.extra.tableHeader": "Table header background",
  "style.part.token": "Code: {token}",
  "style.part.named": "Text of the block style “{name}”",
  "style.part.namedFill": "Background of the block style “{name}”",
  "style.token.keyword": "keywords",
  "style.token.string": "strings",
  "style.token.comment": "comments",
  "style.token.number": "numbers",
  "style.token.title": "names",
  "style.token.type": "types",
  "style.token.attr": "attributes",
  "style.token.meta": "other",
  "style.text.paragraphSpacing": "Space between paragraphs",
  "style.text.indent": "First-line indent",
  "style.text.indentHelp": "For each paragraph after another. None if empty.",
  "style.text.justify": "Justify paragraphs",
  "style.text.justifyHelp": "Paragraphs with an alignment of their own keep it.",
  "style.text.hyphens": "Break words at line ends (hyphenation)",
  "style.text.ligatures": "Ligatures",
  "style.text.oldstyle": "Old-style numerals",
  "style.text.oldstyleHelp": "Where the font has them.",
  "style.heading.level": "Heading level",
  "style.heading.h": "H{n}",
  "style.heading.help": "Unset, a heading follows the style’s headings: its font, the heading scale and the heading weight.",
  "style.heading.titleHelp": "H1 is the page’s title.",
  "style.heading.font": "Font of H{n}",
  "style.heading.size": "Size of H{n}",
  "style.heading.sizeHelp": "From the heading scale if empty.",
  "style.heading.weight": "Weight of H{n}",
  "style.heading.lineHeight": "Line height of H{n}",
  "style.heading.letterSpacing": "Letter spacing of H{n}",
  "style.heading.case": "Capitals of H{n}",
  "style.heading.above": "Space above H{n}",
  "style.heading.below": "Space below H{n}",
  "style.case.none": "As written",
  "style.case.upper": "CAPITALS",
  "style.case.smallcaps": "Small capitals",
  "style.weight.100": "Thin",
  "style.weight.200": "Extra light",
  "style.weight.300": "Light",
  "style.weight.800": "Extra bold",
  "style.weight.900": "Black",
  "style.links.style": "Underline",
  "style.links.thickness": "Underline thickness",
  "style.links.offset": "Space below the text",
  "style.line.solid": "Solid",
  "style.line.dotted": "Dotted",
  "style.line.dashed": "Dashed",
  "style.line.wavy": "Wavy",
  "style.line.double": "Double",
  "style.code.size": "Code size",
  "style.code.theme": "Syntax colours",
  "style.code.theme.default": "Pāginæ",
  "style.code.theme.solarized": "Solarized",
  "style.code.theme.contrast": "High contrast",
  "style.code.theme.mono": "Monochrome",
  "style.layout.padding": "Space at the page’s sides",
  "style.layout.spacing": "Spacing",
  "style.layout.spacingHelp": "The space between everything, as a factor: 0.8 is compact, 1 normal, 1.25 roomy. Density’s if empty.",
  "style.layout.corners": "Corners of each kind of block",
  "style.layout.cornersHelp": "The corners above if empty.",
  "style.layout.corners.buttons": "Buttons",
  "style.layout.corners.images": "Images",
  "style.layout.corners.callouts": "Callouts",
  "style.layout.corners.code": "Code",
  "style.layout.corners.cards": "Bookmarks and embeds",
  "style.layout.borderWidth": "Border width",
  "style.layout.borderStyle": "Borders",
  "style.layout.shadow": "Shadows",
  "style.shadow.none": "None",
  "style.shadow.soft": "Soft",
  "style.shadow.strong": "Strong",
  "style.blocks.callouts": "Callouts",
  "style.blocks.calloutPadding": "Space inside callouts",
  "style.blocks.calloutIconSize": "Callout icon size",
  "style.blocks.quotes": "Quotes",
  "style.blocks.quoteItalic": "Quotes in italics",
  "style.blocks.quoteSize": "Quote size",
  "style.blocks.tables": "Tables",
  "style.blocks.tableStriped": "Striped rows",
  "style.blocks.tableHeader": "Header cells",
  "style.blocks.tableHeader.plain": "Plain",
  "style.blocks.tableHeader.bold": "Bold",
  "style.blocks.tableHeader.filled": "Filled",
  "style.blocks.images": "Images",
  "style.blocks.imageBorder": "A border around images",
  "style.blocks.captionAlign": "Captions",
  "style.blocks.captionAlign.start": "At the start",
  "style.blocks.captionAlign.center": "Centred",
  "style.blocks.captionAlign.end": "At the end",
  "style.blocks.captionSize": "Caption size",
  "style.blocks.captionColor": "Caption colour",
  "style.blocks.dividers": "Dividers",
  "style.blocks.dividerStyle": "Line",
  "style.blocks.dividerThickness": "Thickness",
  "style.blocks.dividerWidth": "Width",
  "style.blocks.dividerWidthHelp": "The full width if empty; shorter ones are centred.",
  "style.blocks.lists": "Lists",
  "style.blocks.bullets": "Bullets, level {n}",
  "style.blocks.numbers": "Numbers, level {n}",
  "style.bullet.disc": "• Disc",
  "style.bullet.circle": "◦ Circle",
  "style.bullet.square": "▪ Square",
  "style.bullet.dash": "– Dash",
  "style.bullet.none": "None",
  "style.number.decimal": "1, 2, 3",
  "style.number.lower-alpha": "a, b, c",
  "style.number.lower-roman": "i, ii, iii",
  "style.number.upper-alpha": "A, B, C",
  "style.number.upper-roman": "I, II, III",
  "style.blocks.toggleMarker": "Toggles’ marker",
  "style.toggle.triangle": "▸ Triangle",
  "style.toggle.plus": "+ Plus",
  "style.toggle.chevron": "› Chevron",
  "style.blocks.buttons": "Buttons",
  "style.blocks.cardBorder": "Borders on bookmarks and embeds",
  "style.blocks.cardBorderHelp": "Without them, they keep their background.",
  "style.blockStyles.help": "Named styles any block in this workspace can use, such as “Lead paragraph” or “Note”. A block’s own settings go over its style. Changes reach published pages when the site’s settings are published.",
  "style.blockStyles.none": "No block styles yet.",
  "style.blockStyles.name": "Name",
  "style.blockStyles.newName": "Block style {n}",
  "style.blockStyles.add": "Add a block style",
  "style.blockStyles.edit": "Set “{name}”",
  "style.blockStyles.close": "Done with “{name}”",
  "style.blockStyles.remove": "Remove “{name}”",
  "blockStyle.title": "Style this block",
  "blockStyle.use": "Block style",
  "blockStyle.uses": "Block styles",
  "blockStyle.useNone": "None",
  "blockStyle.useHelp": "One of the workspace’s block styles; the settings below go over it.",
  "blockStyle.useNoneYet": "The workspace has no block styles yet; its owners set them in the site’s Style.",
  "blockStyle.text": "Text",
  "blockStyle.box": "Box",
  "blockStyle.colour": "Colour",
  "blockStyle.background": "Background",
  "blockStyle.colour.default": "The page’s",
  "blockStyle.colour.custom": "Custom",
  "blockStyle.colour.light": "{name} (light mode)",
  "blockStyle.colour.dark": "{name} (dark mode)",
  "blockStyle.colour.ownDark": "Another colour in dark mode",
  "blockStyle.contrast": "Text and background are too close to read in {mode} ({ratio}:1; 4.5:1 is needed).",
  "blockStyle.font": "Font",
  "blockStyle.font.page": "The page’s",
  "blockStyle.font.body": "The body font",
  "blockStyle.font.heading": "The headings’ font",
  "blockStyle.font.code": "The code font",
  "blockStyle.size": "Size",
  "blockStyle.sizeHelp": "In units that grow with zoom, such as rem or px. As the page has it if empty.",
  "blockStyle.weight": "Weight",
  "blockStyle.italic": "Italics",
  "blockStyle.case": "Capitals",
  "blockStyle.lineHeight": "Line height",
  "blockStyle.letterSpacing": "Letter spacing",
  "blockStyle.width": "Width",
  "blockStyle.maxHelp": "The width there is if empty.",
  "blockStyle.place": "Place",
  "blockStyle.spaceAbove": "Space above",
  "blockStyle.spaceBelow": "Space below",
  "blockStyle.padding": "Space inside",
  "blockStyle.borderWidth": "Border width",
  "blockStyle.borderHelp": "1px if a border is chosen and this is empty.",
  "blockStyle.borderStyle": "Border",
  "blockStyle.borderColor": "Border colour",
  "blockStyle.corners": "Corners",
  "blockStyle.showOn": "Show on",
  "blockStyle.showOnHelp": "Unticked, the block is not shown on that screen of published pages (in the editor it is dimmed there). It is always shown somewhere.",
  "blockStyle.screen.xs": "Phones (below 576 px)",
  "blockStyle.screen.phones": "phones",
  "blockStyle.saveAs": "Save as block style…",
  "blockStyle.saveAsName": "Name of the block style",
  "blockStyle.saveAsConfirm": "Save the block style",
  "blockStyle.saveAsFailed": "The block style could not be saved.",
  "blockStyle.reset": "Clear the style",
  "editor.style.menu": "Style…",
  "editor.style.copyMenu": "Copy style",
  "editor.style.pasteMenu": "Paste style",
  "editor.style.command": "Style this block…",
  "editor.style.copy": "Copy this block’s style",
  "editor.style.paste": "Paste the copied style on this block",
  "editor.style.clear": "Clear this block’s style",
  "editor.style.use": "Use the block style “{name}”",
  "editor.style.copied": "Style copied.",
  "editor.style.savedAs": "Block style “{name}” added to the site’s Style draft.",
  "editor.style.hiddenOn": "Hidden on {screens}",
  "database.calendar.menu": "Subscribe in a calendar app…",
  "database.calendar.title": "Subscribe in a calendar app",
  "database.calendar.intro": "Google Calendar, Apple Calendar, Outlook and others show this view's items and keep them up to date (they check every few hours). Only you can see the subscription; it shows what you may see.",
  "database.calendar.dates": "Dates from",
  "database.calendar.shows": "Each event shows",
  "database.calendar.showsTitle": "Its title",
  "database.calendar.showsProperties": "Its title and properties",
  "database.calendar.address": "Address to subscribe to",
  "database.calendar.secret": "Anyone who has this address can read these events: keep it to yourself. It is shown only now; to see one again, make a new address.",
  "database.calendar.existing": "You made an address on {made}; last read by a calendar app: {used}. Addresses are shown only when made: make a new one to copy it again (the old one stops working).",
  "database.calendar.neverUsed": "never",
  "database.calendar.changeNeedsNew": "Your changes apply to the new address.",
  "database.calendar.make": "Make an address",
  "database.calendar.makeNew": "Make a new address",
  "database.calendar.copy": "Copy the address",
  "database.calendar.copied": "Address copied",
  "database.calendar.made": "Address made",
  "database.calendar.stop": "Stop subscribing",
  "database.calendar.stopped": "The address no longer works",
  "database.calendar.close": "Close",
  "database.calendar.off": "Calendar feeds are turned off in this workspace by its owners.",
  "database.calendar.noDates": "This database has no property with dates.",
  "calendarFeeds.title": "Calendar feeds",
  "calendarFeeds.label": "Members may subscribe to database views in calendar apps",
  "calendarFeeds.help": "Each address shows only what its owner may see. Turning this off stops every address at once; turning it on again restarts them.",
  "command.calendarFeedsOn": "Turn on calendar feeds in this workspace",
  "command.calendarFeedsOff": "Turn off calendar feeds in this workspace",
  "error.calendar_feeds_off": "Calendar feeds are turned off in this workspace.",
  "error.not_a_date_property": "Choose a property with dates.",
  "audit.action.calendar_feed.created": "Made a calendar feed address",
  "audit.action.calendar_feed.deleted": "Stopped a calendar feed",
  "page.analytics.menu": "Analytics…",
  "analytics.title": "Analytics: {title}",
  "analytics.period": "Period",
  "analytics.days": "{days, plural, one {# day} other {# days}}",
  "analytics.views": "{n, plural, one {view} other {views}}",
  "analytics.viewers": "{n, plural, one {person viewed it} other {people viewed it}}",
  "analytics.editors": "{n, plural, one {person edited it} other {people edited it}}",
  "analytics.chart": "Views per day, {from} to {to}: most on {busiest} ({most, number})",
  "analytics.chartEmpty": "Views per day, {from} to {to}: none",
  "analytics.editedBy": "Edited by",
  "analytics.noEdits": "No one edited it in this period.",
  "analytics.note": "Views are counted once per person per hour, from the app and the published site (anonymous there). People who turned off “Show my page views” count without their name. Days are in UTC.",
  "analytics.close": "Close",
  "account.privacy.title": "Privacy",
  "account.pageViews.toggle": "Show my page views",
  "account.pageViews.help": "Off, your views still count in pages’ analytics, but without your name, and you are not among the people who viewed them.",
  "account.pageViews.on": "Your page views show your name",
  "account.pageViews.off": "Your page views no longer show your name",
  "command.pageViewsOn": "Show my name on my page views",
  "command.pageViewsOff": "Hide my name from my page views",
  "sidebar.people": "People",
  "search.action.people": "People",
  "search.action.people.keywords": "people directory members team colleagues profiles",
  "directory.title": "People",
  "directory.intro": "Everyone in {workspace}. Name, email, role and teamspaces come from the workspace; the other properties each person fills in for themselves, and owners add or import more.",
  "directory.find": "Find someone",
  "directory.findPlaceholder": "Name, email, title…",
  "directory.teamspace": "Teamspace",
  "directory.teamspaceList": "Teamspaces",
  "directory.addProperty": "Add a property",
  "directory.import": "Import from CSV",
  "directory.importNoEmail": "The file needs a column named “email”, to know whose values each row has.",
  "directory.imported": "Imported values for {people, plural, one {# person} other {# people}}; {added, plural, =0 {no new properties} one {# new property} other {# new properties}}; {unknown, plural, =0 {everyone found} one {# email not in the workspace} other {# emails not in the workspace}}.",
  "directory.editMine": "Edit my details",
  "directory.table": "People in the workspace",
  "directory.name": "Name",
  "directory.email": "Email",
  "directory.role": "Role",
  "directory.teamspaces": "Teamspaces",
  "directory.role.owner": "Owner",
  "directory.role.membership_admin": "Membership admin",
  "directory.role.member": "Member",
  "directory.role.guest": "Guest",
  "directory.count": "{shown, plural, one {# person} other {# people}} of {total, number}. Guests see only those they share pages with.",
  "directory.propertyHelp": "Text everyone fills in for themselves, such as a title, a location or pronouns. Importing a CSV adds a property for each new column.",
  "directory.propertyName": "Name of the new property",
  "directory.properties": "Properties",
  "directory.removeProperty": "Remove {name}, with everyone’s values",
  "directory.remove": "Remove",
  "directory.propertyRemoved": "{name} removed",
  "directory.propertyAdded": "{name} added",
  "directory.add": "Add",
  "directory.close": "Close",
  "directory.save": "Save",
  "directory.cancel": "Cancel",
  "directory.detailsSaved": "Your details are saved",
  "error.property_exists": "A property has this name already.",
  "error.too_many_people_properties": "The people directory can have up to 50 properties.",
  "error.unknown_property": "One of these properties no longer exists. Reload the page.",
  "audit.action.people.property_added": "Added a property to the people directory",
  "audit.action.people.property_removed": "Removed a property from the people directory",
  "audit.action.people.imported": "Imported people's details",
  "workspace.settings.nav": "Workspace settings",
  "workspace.settings.general": "General",
  "workspace.settings.connections": "Connections",
  "command.connections": "Go to Connections (tools and the API)",
  "command.integrations": "Go to Integrations (your connected tools)",
  "inbox.webhook_paused": "A webhook is paused: {detail}",
  "inbox.webhookResume": "It failed for about an hour. Check its address, then resume it in:",
  "admin.settings.category.email": "Email",
  "settings.email.provider.label": "Send email with",
  "settings.email.provider.help": "Off, Pāginæ sends no email: everything stays in people’s inboxes in the app, and nobody can sign in by email. On, it sends sign-in links and codes, the notifications people choose, and notices such as a paused webhook.",
  "settings.email.provider.option.none": "Nothing (in-app only)",
  "settings.email.provider.option.resend": "Resend",
  "settings.email.from.label": "Default sender",
  "settings.email.from.help": "An address on a domain verified in Resend, optionally with a name in front, such as: Pāginæ '<'notices@example.org'>'.",
  "email.key": "Resend API key",
  "email.keyHelp": "Kept encrypted and never shown again. Changing it needs your passkey.",
  "email.keySet": "A key is saved; it is never shown again. Type a new one to replace it. Changing it needs your passkey.",
  "email.saveKey": "Save key",
  "email.removeKey": "Remove key",
  "email.keySaved": "Key saved.",
  "email.keyRemoved": "Key removed.",
  "email.test": "Send a test email to me",
  "email.sent": "Sent to {to} · {when}",
  "email.limits": "Resend's free plan sends up to 100 emails a day and 3,000 a month.",
  "email.noEncryption": "Email needs the PAGINAE_ENCRYPTION_KEY secret, which keeps the provider's key encrypted. See the self-hosting guide.",
  "connections.tools": "Tools",
  "connections.toolsHelp": "Programs people here may connect to their own accounts, to work through the API in the places you choose. Each person's connection acts as them: it reaches only what they can, in those places, and does only what you allow here.",
  "connections.approve": "Approve a tool",
  "connections.approveButton": "Approve",
  "connections.tool": "Tool",
  "connections.worksIn": "Where it works",
  "connections.mayShort": "May",
  "connections.may": "What it may do there",
  "connections.mayThere": "What it may do there",
  "connections.connectWith": "Connect with",
  "connections.peopleConnected": "People connected",
  "connections.peopleConnectedCount": "People connected ({n})",
  "connections.workspaceConnections": "Workspace connections",
  "connections.workspaceHelp": "Connections that belong to the workspace, not to a person, for jobs that must not stop when someone leaves (backups, a site build). Only owners make and see them.",
  "connections.newConnection": "New workspace connection",
  "connections.name": "Name",
  "connections.webhooks": "Webhooks",
  "connections.webhooksPaused": "{n} · {paused} paused",
  "connections.lastUsed": "Last used",
  "connections.never": "Never",
  "connections.audited": "Every change made through a tool or connection is in the audit log, with whose account it acted for.",
  "connections.everywhere": "All of this workspace",
  "connections.everywhereToggle": "Works in all of this workspace",
  "connections.where": "Where it works",
  "connections.whereHelp": "Pages and databases, with the pages inside them. People's connections reach these only.",
  "connections.wherePages": "Pages and databases",
  "connections.wherePlaces": "Chosen places",
  "connections.hiddenPage": "A page you cannot see",
  "connections.removePlace": "Remove {name}",
  "connections.database": "database",
  "connections.how": "How people connect it",
  "connections.howSignIn": "Sign-in (OAuth) from the tool, for tools that support it",
  "connections.howToken": "A personal token, made in Account → Integrations, for scripts",
  "connections.redirect": "Address to return to after sign-in",
  "connections.redirectHelp": "The tool's own HTTPS address that receives the sign-in code. Its makers give it to you.",
  "connections.signInMade": "Give these to the tool's makers. The secret is shown only now.",
  "connections.clientId": "Client ID",
  "connections.clientSecret": "Secret",
  "connections.signIn": "Sign-in (OAuth)",
  "connections.signInHelp": "Give these to the tool's makers. Return address: {redirect}",
  "connections.newSecret": "Make a new secret",
  "connections.withSignIn": "Sign-in",
  "connections.withToken": "Personal token",
  "connections.create": "Create",
  "connections.cancel": "Cancel",
  "connections.done": "Done",
  "connections.save": "Save",
  "connections.saved": "Saved.",
  "connections.change": "Change",
  "connections.back": "← Connections",
  "connections.approvedBy": "Approved by {who} on {when}.",
  "connections.madeBy": "Made by {who} on {when}.",
  "connections.token": "Token",
  "connections.tokenHelp": "Shown only when made. A new token stops the old one at once.",
  "connections.newToken": "Make a new token",
  "connections.nobody": "Nobody has connected it yet.",
  "connections.person": "Person",
  "connections.with": "With",
  "connections.since": "Since",
  "connections.actions": "Actions",
  "connections.disconnect": "Disconnect",
  "connections.disconnectPerson": "Disconnect {name}",
  "connections.disconnected": "Disconnected.",
  "connections.removeHeading": "Remove",
  "connections.removeTool": "Remove this tool",
  "connections.removeToolHelp": "Disconnects everyone at once, and their webhooks stop.",
  "connections.removeConnection": "Delete this connection",
  "connections.removeConnectionHelp": "Its token and webhooks stop at once.",
  "connections.remove": "Remove",
  "connections.removed": "Removed.",
  "connections.onceHelp": "Copy it now: it is not shown again.",
  "connections.copy": "Copy",
  "connections.copied": "Copied.",
  "connections.capability.read_content": "Read content",
  "connections.capability.update_content": "Update content",
  "connections.capability.insert_content": "Insert content",
  "connections.capability.read_comments": "Read comments",
  "connections.capability.insert_comments": "Insert comments",
  "connections.capability.read_user_names": "Read people's names (never emails)",
  "connections.event.page.created": "A page is created",
  "connections.event.page.content_updated": "A page is updated",
  "connections.event.page.moved": "A page is moved",
  "connections.event.page.deleted": "A page is deleted",
  "connections.event.page.published": "A page is published",
  "connections.event.row.created": "A row is added",
  "connections.event.row.properties_updated": "A row is changed",
  "connections.event.comment.created": "A comment is added",
  "connections.event.database.schema_updated": "A database's properties change",
  "connections.webhook.add": "Add a webhook",
  "connections.webhook.addButton": "Add webhook",
  "connections.webhook.address": "Address",
  "connections.webhook.addressHelp": "Public HTTPS addresses only. Each event is a POST with JSON, signed with a secret shown next.",
  "connections.webhook.when": "Send when",
  "connections.webhook.whenHelp": "Only for the places it works in. Failed deliveries are tried again 5 times over about an hour, then the webhook pauses and you are told.",
  "connections.webhook.secret": "Signing secret",
  "connections.webhook.secretHelp": "Copy it now: it is not shown again. Check the Paginae-Signature header with it.",
  "connections.webhook.none": "No webhooks yet.",
  "connections.webhook.sends": "Sends",
  "connections.webhook.last": "Last delivery",
  "connections.webhook.lastAt": "{status} · {when}",
  "connections.webhook.never": "None yet",
  "connections.webhook.noAnswer": "No answer",
  "connections.webhook.paused": "Paused",
  "connections.webhook.test": "Send a test event",
  "connections.webhook.tested": "Test event sent: {status}.",
  "connections.webhook.resume": "Resume",
  "connections.webhook.resumed": "Webhook resumed.",
  "connections.webhook.removeFor": "Remove the webhook to {url}",
  "connections.webhook.removed": "Webhook removed.",
  "integrations.title": "Integrations",
  "integrations.tools": "Tools you may connect",
  "integrations.toolsHelp": "Approved by your workspaces' owners. A tool you connect acts as you, only where the owners let it work, and never sees more than you can.",
  "integrations.none": "No tools have been approved in your workspaces yet.",
  "integrations.connected": "Connected · {how}",
  "integrations.notConnected": "Not connected",
  "integrations.where": "{workspace} · works in {places} · may {may}",
  "integrations.lastUsed": "last used {when}",
  "integrations.webhooks": "Your webhooks",
  "integrations.connectFromTool": "Connect it from {name}: it sends you here to sign in.",
  "integrations.makeToken": "Make a personal token",
  "integrations.newToken": "Make a new token",
  "integrations.disconnected": "{name} disconnected.",
  "integrations.services": "Other services",
  "integrations.servicesSoon": "The Claude API comes with the AI module.",
  "integrations.tokenFor": "Personal token for {name}",
  "integrations.tokenHelp": "Paste it into {name}. It acts as you in {places}, and may {may}.",
  "integrations.tokenOnce": "Make a new one from here at any time; it replaces this one. Disconnecting stops it.",
  "integrations.promptAdd": "{name} can add to this page as you, once you connect your account.",
  "integrations.promptRead": "{name} can work with this page as you, once you connect your account.",
  "integrations.connectAccount": "Connect your account",
  "integrations.notNow": "Not now",
  "oauth.title": "Connect a tool",
  "oauth.invalid": "This sign-in link is not valid: the tool is not approved, or its return address does not match. Ask the workspace's owners.",
  "oauth.wants": "Connect {tool} to your account in {workspace}",
  "oauth.where": "It will work as you in: {places}.",
  "oauth.help": "It reaches only what you can, there, and you can disconnect it at any time in Account → Integrations.",
  "oauth.connect": "Connect",
  "oauth.cancel": "Cancel",
  "error.bad_place": "One of the places is not a page or database of this workspace.",
  "error.no_places": "Choose at least one place for it to work in.",
  "error.no_sign_in": "This tool cannot be connected by signing in.",
  "error.no_way_to_connect": "Choose at least one way for people to connect it.",
  "error.not_a_connection": "That is not a workspace connection.",
  "error.not_a_tool": "That is not a tool.",
  "error.not_everywhere": "This connection works in all of the workspace; it has no places to choose.",
  "error.tokens_not_allowed": "This tool is connected by signing in from it, not with a personal token.",
  "error.too_many_webhooks": "It already has as many webhooks as it may (10).",
  "error.email_failed": "The email could not be sent. Check the key and the sender address.",
  "error.encryption_unavailable": "This needs the PAGINAE_ENCRYPTION_KEY secret, which is not set.",
  "error.invalid_client": "The tool's sign-in details are not valid.",
  "error.invalid_grant": "The sign-in code is not valid or has expired.",
  "error.unsupported_grant_type": "That kind of sign-in is not supported.",
  "audit.action.api.change": "Made a change through the API",
  "audit.action.api.connected": "Connected a tool",
  "audit.action.api.connection_changed": "Changed a tool or connection",
  "audit.action.api.connection_created": "Made a workspace connection",
  "audit.action.api.connection_deleted": "Removed a tool or connection",
  "audit.action.api.disconnected": "Disconnected a tool",
  "audit.action.api.person_disconnected": "Disconnected someone from a tool",
  "audit.action.api.personal_token_made": "Made a personal token",
  "audit.action.api.secret_renewed": "Made a new sign-in secret",
  "audit.action.api.token_renewed": "Made a new connection token",
  "audit.action.api.tool_approved": "Approved a tool",
  "audit.action.api.webhook_added": "Added a webhook",
  "audit.action.api.webhook_removed": "Removed a webhook",
  "audit.action.email.key_changed": "Changed the email provider's key",
  "database.automations": "Automations…",
  "database.automationsButton": "⚡ Automations",
  "inbox.automation_notice": "{page}: {detail}",
  "inbox.automation_paused": "An automation in {page} paused: {detail}",
  "automations.title": "Automations in {title}",
  "automations.help": "They run on the server whenever their trigger happens, even when nobody has the database open. Each runs as the person who last saved it, and only on pages they may edit.",
  "automations.none": "No automations yet.",
  "automations.list": "Automations",
  "automations.name": "Name",
  "automations.when": "When",
  "automations.does": "Does",
  "automations.lastRun": "Last run",
  "automations.on": "On",
  "automations.onFor": "{name} on",
  "automations.never": "Never",
  "automations.and": " and ",
  "automations.or": ", or ",
  "automations.new": "New automation",
  "automations.untitled": "Automation",
  "automations.turnedOn": "{name} is on.",
  "automations.turnedOff": "{name} is off.",
  "automations.activityOf": "Activity of {name}",
  "automations.paused.failures": "Paused after an error",
  "automations.paused.access": "Paused: the person it runs as lost access",
  "automations.pausedHelp": "It failed three times in a row. The last error: {detail}",
  "automations.pausedAccessHelp": "The person it ran as no longer has full access to this database. Save it, or turn it back on, to make it run as you.",
  "automations.resume": "Resume",
  "automations.edit": "Edit",
  "automations.back": "← Automations",
  "automations.noRuns": "It has not run yet.",
  "automations.runs": "Runs",
  "automations.runWhen": "When",
  "automations.runPage": "Page",
  "automations.runTrigger": "Trigger",
  "automations.runResult": "Result",
  "automations.runTrigger.added": "Page added",
  "automations.runTrigger.edited": "Property edited",
  "automations.runTrigger.schedule": "Schedule",
  "automations.runsKept": "The last 100 runs, kept for 30 days.",
  "automations.status.done": "Done",
  "automations.status.failed": "Failed",
  "automations.status.skipped": "Skipped",
  "automations.match": "How the triggers combine",
  "automations.matchAny": "Any of these happens",
  "automations.matchAll": "All of these hold",
  "automations.trigger.pageAdded": "A page is added",
  "automations.trigger.propertyEdited": "A property is edited",
  "automations.trigger.every": "On a schedule",
  "automations.removeTrigger": "Remove trigger {n}",
  "automations.addTrigger": "Add a trigger",
  "automations.when.pageAdded": "Page added",
  "automations.summary.any": "{name} edited",
  "automations.summary.is": "{name} set to {value}",
  "automations.summary.added": "{value} added to {name}",
  "automations.summary.removed": "{value} removed from {name}",
  "automations.summary.empty": "{name} emptied",
  "automations.summary.filled": "{name} filled in",
  "automations.summary.every": "Every {n, plural, one {} other {# }}{unit}, {time} ({zone})",
  "automations.every.day": "{n, plural, one {day} other {days}}",
  "automations.every.week": "{n, plural, one {week} other {weeks}}",
  "automations.every.month": "{n, plural, one {month} other {months}}",
  "automations.everyHowMany": "Every",
  "automations.everyUnit": "Unit",
  "automations.starting": "Starting on",
  "automations.at": "At",
  "automations.zone": "Time zone",
  "automations.zones": "Time zones",
  "automations.property": "Property",
  "automations.countsWhen": "Counts when",
  "automations.value": "Value",
  "automations.change.any": "any change",
  "automations.change.is": "set to",
  "automations.change.added": "added",
  "automations.change.removed": "removed",
  "automations.change.empty": "emptied",
  "automations.change.filled": "filled in",
  "automations.checked": "Checked",
  "automations.unchecked": "Unchecked",
  "automations.scope": "On pages in",
  "automations.scopeAll": "All of {title}",
  "automations.scopeView": "Only those the view {view} shows",
  "automations.do": "Do",
  "automations.noActions": "No actions yet.",
  "automations.addAction": "Add an action",
  "automations.kind.editThis": "Edit a property of the page",
  "automations.kind.addPage": "Add a page to",
  "automations.kind.editPages": "Edit pages in",
  "automations.kind.notify": "Send a notification",
  "automations.kind.email": "Send an email",
  "automations.kind.webhook": "Send a webhook",
  "automations.kind.variable": "Define a variable",
  "automations.value.actor": "The person who made the change",
  "automations.value.useActor": "Use the person who made the change",
  "automations.value.today": "Today (when it runs)",
  "automations.value.useToday": "Use the day it runs",
  "automations.to": "To (at most {max} people)",
  "automations.toActor": "The person who made the change",
  "automations.toProperty": "The people in {name}",
  "automations.subject": "Subject",
  "automations.message": "Message",
  "automations.namesHelp": "Names in braces are filled in: '{page}', a property such as '{Status}', or a variable.",
  "automations.webhookUrl": "Address (HTTPS)",
  "automations.webhookProperties": "Properties to send",
  "automations.webhookHelp": "A POST with JSON: the automation, the database, and the page with these properties. Public HTTPS addresses only; an answer other than 2xx is a failure.",
  "automations.variableName": "Name",
  "automations.formula": "Formula",
  "automations.variableHelp": "Worked out each run, like a formula property of the page. Later actions use it as '{'{name}'}'.",
  "automations.runAsYou": "Runs as you, on pages you may edit. Changes it makes don't start other automations.",
  "automations.runAsOther": "Runs as {name}. Saving it makes it run as you.",
  "automations.saveOn": "Save and turn on",
  "automations.saved": "{name} saved.",
  "automations.delete": "Delete automation",
  "automations.deleteSure": "Delete it for good?",
  "automations.deleted": "{name} deleted.",
  "automations.error.name": "Give it a name.",
  "automations.error.triggers": "Add a trigger.",
  "automations.error.actions": "Add an action.",
  "automations.error.property": "Choose a property for the trigger.",
  "automations.error.value": "Choose a value for the trigger.",
  "automations.error.database": "Choose a database for each action that needs one.",
  "automations.error.people": "Choose who is told.",
  "automations.error.subject": "Give the email a subject.",
  "automations.error.url": "A webhook needs an https:// address.",
  "automations.error.variable": "Give each variable a name and a formula.",
  "automations.error.invalid": "Something in the automation is not valid.",
  "error.invalid_automation": "The automation is not complete.",
  "error.too_many_automations": "This database has all the automations it may (20).",
  "error.bad_view": "That view is not one of this database's.",
  "audit.action.automation.created": "Made an automation",
  "audit.action.automation.changed": "Changed an automation",
  "audit.action.automation.on": "Turned an automation on",
  "audit.action.automation.off": "Turned an automation off",
  "audit.action.automation.deleted": "Deleted an automation",
  "error.invalid_url": "A webhook needs a public HTTPS address.",
  "database.view.form": "Form",
  "editor.slash.form": "Form",
  "editor.slash.form.keywords": "form survey questions sign up answers",
  "forms.viewName": "Form",
  "forms.answers": "Answers",
  "forms.view": "form",
  "forms.title": "Form",
  "forms.editing": "Editing the form",
  "forms.previewing": "Previewing the form as people will fill it in",
  "forms.edit": "Edit the form",
  "forms.preview": "Preview",
  "forms.settings": "Form settings",
  "forms.share": "Share form",
  "forms.formTitle": "Form title",
  "forms.description": "Description",
  "forms.questions": "Questions",
  "forms.addQuestion": "Add a question",
  "forms.newProperty": "New property…",
  "forms.shownWhen": "Shown only for some answers to “{question}”.",
  "forms.question": "Question",
  "forms.questionText": "Question",
  "forms.questionDescription": "Description (optional)",
  "forms.goesInto": "Answers go into {name} ({type}).",
  "forms.required": "Required",
  "forms.showAs": "Show as",
  "forms.display.list": "A list",
  "forms.display.dropdown": "A dropdown",
  "forms.max": "At most this many choices",
  "forms.showQuestion": "Show this question",
  "forms.always": "Always",
  "forms.onlyWhen": "Only when…",
  "forms.whenQuestion": "The answer to",
  "forms.whenAnyOf": "Is any of",
  "forms.whenNone": "Choose at least one answer, or the question is never shown.",
  "forms.moveUp": "Move up",
  "forms.moveDown": "Move down",
  "forms.removeQuestion": "Remove question",
  "forms.buttonText": "Button text",
  "forms.buttonColor": "Button colour",
  "forms.color.accent": "Accent",
  "forms.color.green": "Green",
  "forms.color.orange": "Orange",
  "forms.color.red": "Red",
  "forms.color.purple": "Purple",
  "forms.color.gray": "Grey",
  "forms.thanksTitleLabel": "Thank-you title",
  "forms.thanksTitle": "Thank you!",
  "forms.thanksMessage": "Thank-you message",
  "forms.emailCopy": "Email a copy of their answers to the person",
  "forms.emailCopyNone": "No copy",
  "forms.emailCopyTo": "To the address in “{name}”",
  "forms.emailCopyHelp": "Needs email to be set up (Administration → Settings → Email).",
  "forms.emailCopyNoQuestion": "Add an Email question to send a copy.",
  "forms.accepting": "Accept answers",
  "forms.closesOn": "Stop accepting on (optional)",
  "forms.shareTitle": "Share “{title}”",
  "forms.shareSaved": "Sharing saved.",
  "forms.who": "Who can fill it in",
  "forms.access.closed": "Nobody: the form is closed",
  "forms.access.workspace": "People in the workspace, with the link",
  "forms.access.public": "Anyone with the link, on the web",
  "forms.publicHelp": "On the web, each answer passes Cloudflare Turnstile (no puzzles for most people), and at most 5 answers an hour come from one address.",
  "forms.publicNeedsTurnstile": "Forms on the web need Cloudflare Turnstile: an administrator sets its keys in Administration → Settings → Security.",
  "forms.link": "Link",
  "forms.copy": "Copy",
  "forms.copied": "Link copied.",
  "forms.newLink": "Make a new link",
  "forms.newLinkMade": "A new link is made; the old one stopped working.",
  "forms.anonymous": "Anonymous answers",
  "forms.respondent": "Record who answered in",
  "forms.respondentNone": "Nowhere",
  "forms.respondentNoProperty": "Add a Person property to record who answered.",
  "forms.after": "After answering, the person can",
  "forms.after.none": "Nothing more",
  "forms.after.view": "See their answer",
  "forms.after.edit": "Edit their answer",
  "forms.afterHelp": "Only people signed in, and only their own answer.",
  "forms.ownOnly": "Answers open only to who gave them and people with full access",
  "forms.brandingToggle": "Show “Made with Pāginæ”",
  "forms.done": "Done",
  "forms.submit": "Send",
  "forms.choose": "Choose…",
  "forms.upTo": "(up to {n})",
  "forms.missing": "{n, plural, one {One required question is} other {# required questions are}} not answered yet.",
  "forms.turnstileFailed": "The check that you are a person could not load. Reload the page to try again.",
  "forms.branding": "Made with Pāginæ · Your answers go to {workspace}.",
  "forms.signedInNote": "You are signed in: your answer may be recorded as yours.",
  "forms.emailed": "A copy of your answers was sent to you.",
  "forms.seeAnswer": "See your answer",
  "forms.closed": "This form is closed.",
  "forms.notShared": "This form is not shared yet. Its owners share it from the form view.",
  "forms.signInNeeded": "This form is for the people of its workspace. Sign in to fill it in.",
  "forms.signIn": "Sign in",
  "settings.security.turnstileSiteKey.label": "Cloudflare Turnstile site key",
  "settings.security.turnstileSiteKey.help": "For forms anyone on the web may fill in. With its secret (below), such forms pass Turnstile; without both, forms can be shared only within workspaces.",
  "turnstile.secret": "Cloudflare Turnstile secret",
  "turnstile.secretHelp": "Kept encrypted and never shown again. Changing it needs your passkey.",
  "turnstile.secretSet": "A secret is saved; it is never shown again. Type a new one to replace it.",
  "turnstile.save": "Save secret",
  "turnstile.remove": "Remove secret",
  "turnstile.saved": "Secret saved.",
  "turnstile.removed": "Secret removed.",
  "turnstile.noEncryption": "Turnstile needs the PAGINAE_ENCRYPTION_KEY secret, which keeps its secret encrypted. See the self-hosting guide.",
  "error.turnstile_not_set": "Set up Cloudflare Turnstile before sharing a form on the web.",
  "error.not_a_person_property": "Choose a Person property.",
  "error.form_closed": "This form is closed.",
  "error.sign_in_required": "Sign in to fill in this form.",
  "error.turnstile_failed": "The check that you are a person failed. Try again.",
  "error.invalid_answers": "Some answers need a look.",
  "audit.action.form.shared": "Changed how a form is shared",
  "audit.action.form.link_renewed": "Made a new link for a form",
  "audit.action.turnstile.secret_changed": "Changed the Turnstile secret",
  "database.view.dashboard": "Dashboard",
  "dashboard.view": "dashboard",
  "dashboard.summary": "{count, plural, =0 {Dashboard, no widgets yet} one {Dashboard · # widget} other {Dashboard · # widgets}} · the view’s filters apply to every widget",
  "dashboard.editingHelp": "Editing the dashboard: drag widgets to move them and a corner to resize them, or use each widget’s menu.",
  "dashboard.edit": "Edit dashboard",
  "dashboard.done": "Done",
  "dashboard.add": "Add a widget",
  "dashboard.addButton": "Add",
  "dashboard.editTitle": "Edit widget",
  "dashboard.editWidget": "Edit widget “{title}”",
  "dashboard.removeWidget": "Remove widget “{title}”",
  "dashboard.widgetMenu": "Actions for widget “{title}”",
  "dashboard.editMenu": "Edit…",
  "dashboard.moveEarlier": "Move earlier",
  "dashboard.moveLater": "Move later",
  "dashboard.sizeTo": "Make it {size}",
  "dashboard.remove": "Remove",
  "dashboard.untitled": "Untitled widget",
  "dashboard.empty": "This dashboard has no widgets yet.",
  "dashboard.emptyEditor": "This dashboard has no widgets yet. Choose “Edit dashboard”, then “Add a widget”.",
  "dashboard.kind": "Kind",
  "dashboard.kind.number": "Number",
  "dashboard.kind.chart": "Chart",
  "dashboard.kind.view": "View",
  "dashboard.kindHelp.number": "One figure: a count, sum, average… of a property",
  "dashboard.kindHelp.chart": "Bars, line or donut, from any property",
  "dashboard.kindHelp.view": "One of this database’s views: table, board, list, calendar…",
  "dashboard.title": "Title",
  "dashboard.showing": "Showing",
  "dashboard.of": "Of",
  "dashboard.measure.count": "Number of rows",
  "dashboard.measure.sum": "Sum",
  "dashboard.measure.average": "Average",
  "dashboard.measure.min": "Least",
  "dashboard.measure.max": "Most",
  "dashboard.measure.percent": "Percentage of rows",
  "dashboard.onlyRows": "Only rows where",
  "dashboard.outOf": "Out of rows where",
  "dashboard.compare": "Compare with",
  "dashboard.compare.none": "Nothing",
  "dashboard.compare.week": "A week before",
  "dashboard.compare.month": "A month before",
  "dashboard.compare.year": "A year before",
  "dashboard.compareBy": "By the date in",
  "dashboard.compareNeedsDate": "Comparing with a period before needs a date property.",
  "dashboard.compared": "{direction, select, up {Up {delta}} down {Down {delta}} other {No change}} since a {period, select, week {week} month {month} other {year}} ago",
  "dashboard.whichView": "View",
  "dashboard.chooseView": "Choose a view…",
  "dashboard.noViews": "This database has no other view to show. Add one first.",
  "dashboard.noView": "The view this widget showed is gone. Edit the widget to choose another.",
  "dashboard.fromView": "From the view “{view}” · {count, plural, one {# row} other {# rows}}",
  "dashboard.size": "Size",
  "dashboard.size.small": "small (a third of the width)",
  "dashboard.size.medium": "medium (half the width)",
  "dashboard.size.large": "large (two thirds of the width)",
  "dashboard.size.full": "full width",
  "dashboard.sizeOption.small": "Small (a third of the width)",
  "dashboard.sizeOption.medium": "Medium (half the width)",
  "dashboard.sizeOption.large": "Large (two thirds of the width)",
  "dashboard.sizeOption.full": "Full width",
  "audit.action.workspace.capabilities_changed": "Changed who may publish, export or share outside a workspace",
  "capabilities.who.everyone": "Everyone",
  "capabilities.who.only": "Only these people",
  "capabilities.who.nobody": "Nobody",
  "capabilities.admins": "Administrators",
  "capabilities.owners": "Workspace owners",
  "capabilities.groups": "Groups",
  "capabilities.addGroup": "Add a group",
  "capabilities.removeGroup": "Remove {group}",
  "capabilities.rule.everyone": "Everyone the installation allows",
  "capabilities.rule.owners": "Owners only",
  "capabilities.rule.groups": "Owners and these groups",
  "capabilities.title": "Publishing, exporting and sharing",
  "capabilities.intro": "Who in {workspace} may, within what this installation allows. Its owners and the installation’s administrators always may, when the installation allows them.",
  "capabilities.name.publish": "Publishing pages to the web",
  "capabilities.name.export": "Exporting pages",
  "capabilities.name.shareOutside": "Sharing pages outside {workspace}",
  "capabilities.installation.everyone": "The installation allows everyone.",
  "capabilities.installation.nobody": "Turned off for this installation.",
  "capabilities.installation.only": "The installation allows only: {who}.",
  "capabilities.saved": "Saved.",
  "capabilities.save": "Save who may",
  "database.view.map": "Map",
  "database.type.place": "Place",
  "settings.maps.addressSearch.label": "Search for addresses in Place properties",
  "settings.maps.addressSearch.help": "Place fields look addresses up with OpenStreetMap’s Nominatim, through this installation: only when someone presses Enter, at most a few searches a minute for everyone, and each search kept a week.",
  "audit.action.maps.uploaded": "Uploaded a map file",
  "audit.action.maps.removed": "Removed the map file",
  "map.view": "map",
  "map.label": "{count, plural, =0 {Map, with no places} one {Map of # place} other {Map of # places}}",
  "map.places": "Places",
  "map.fit": "Fit all places",
  "map.list": "Show the list",
  "map.showList": "Show the list of places",
  "map.hideList": "Hide the list of places",
  "map.zoomIn": "Zoom in",
  "map.zoomOut": "Zoom out",
  "map.directions": "Directions",
  "map.closeCard": "Close",
  "map.missing": "{count, plural, one {# row has no place} other {# rows have no place}}",
  "map.needsPlace": "A map shows rows by a Place property. Add one to this database first.",
  "map.noBasemap": "Country outlines only: an administrator can add a detailed map in Administration → Settings → Maps.",
  "map.attribution": "© OpenStreetMap contributors · Protomaps · Natural Earth",
  "map.attributionOutlines": "Natural Earth",
  "map.pickLabel": "Map: choose a point",
  "map.pickCentre": "Use the centre of the map",
  "map.placeProperty": "Place property",
  "map.colorBy": "Colour pins by",
  "map.noColor": "One colour",
  "place.search": "Search for a place",
  "place.searchHelp": "Press Enter to search. Places come from OpenStreetMap’s Nominatim.",
  "place.searching": "Searching…",
  "place.results": "Places found",
  "place.none": "Nothing found.",
  "place.paste": "Or paste coordinates or a map link",
  "place.pasted": "Found {at}.",
  "place.notFound": "No coordinates in that: paste “41.9055, 12.4839” or a link from OpenStreetMap, Google Maps or Apple Maps.",
  "place.pickOnMap": "Pick on the map",
  "place.hideMap": "Hide the map",
  "place.loadingMap": "Loading the map…",
  "place.name": "Name",
  "place.address": "Address",
  "place.at": "At {at}.",
  "place.remove": "Remove place",
  "maps.title": "Maps",
  "maps.intro": "Map views draw their maps from one PMTiles file kept in this installation’s storage, so no other server is asked for map tiles. Without one, maps show country outlines only.",
  "maps.current": "Current map",
  "maps.file": "{name} · {size} · uploaded {date}",
  "maps.outside": "Where the file does not reach, maps show country outlines.",
  "maps.none": "No map file yet: maps show country outlines only.",
  "maps.makingTitle": "Making a map file",
  "maps.making": "Cut the region you need from Protomaps’ daily world build with “pmtiles extract” (a bounding box and the most detailed zoom), as docs/operations/maps.md explains. Storage on the free plan is 10 GB: a country to street level is usually 0.5–3 GB; the whole world at street level is about 120 GB.",
  "maps.upload": "Upload a map file (.pmtiles)",
  "maps.replace": "Replace it with another file (.pmtiles)",
  "maps.uploading": "Uploading the map file",
  "maps.progress": "{percent} uploaded",
  "maps.uploaded": "The map file is uploaded.",
  "maps.cancelled": "The upload was stopped.",
  "maps.remove": "Remove the map file",
  "maps.removed": "The map file is removed.",
  "maps.gb": "{n} GB",
  "maps.mb": "{n} MB",
  "suggest.mode.menu": "Editing mode",
  "suggest.mode.editing": "Editing",
  "suggest.mode.suggesting": "Suggesting",
  "suggest.mode.viewing": "Viewing",
  "suggest.mode.editing.help": "Change the page directly",
  "suggest.mode.suggesting.help": "Your changes become suggestions the page’s editors accept or reject",
  "suggest.mode.viewing.help": "Read only, with suggestions hidden",
  "suggest.mode.editing.on": "Editing: changes go straight into the page.",
  "suggest.mode.suggesting.on": "Suggesting: your changes become suggestions.",
  "suggest.mode.viewing.on": "Viewing: suggestions are hidden.",
  "suggest.mode.editing.command": "Edit the page directly",
  "suggest.mode.suggesting.command": "Suggest edits",
  "suggest.mode.viewing.command": "View the page without suggestions",
  "suggest.toggle": "{count, plural, one {# suggestion} other {# suggestions}}",
  "suggest.title": "{count, plural, =0 {Suggestions} one {# suggestion} other {# suggestions}}",
  "suggest.close": "Close",
  "suggest.none": "No suggestions.",
  "suggest.add": "Add",
  "suggest.delete": "Delete",
  "suggest.replace": "Replace",
  "suggest.with": "with",
  "suggest.accept": "Accept",
  "suggest.reject": "Reject",
  "suggest.withdraw": "Withdraw",
  "suggest.acceptAll": "Accept all suggestions",
  "suggest.rejectAll": "Reject all suggestions",
  "suggest.accepted": "Suggestion accepted.",
  "suggest.rejected": "Suggestion rejected.",
  "suggest.acceptedAll": "All suggestions accepted.",
  "suggest.rejectedAll": "All suggestions rejected.",
  "suggest.command.panel": "Show the suggestions",
  "suggest.refused": "Only text can be suggested: typing, deleting and pasting text.",
  "suggest.someone": "Someone",
  "audit.action.page.imported": "Imported a page",
  "sidebar.import": "Import",
  "command.import": "Import pages…",
  "import.title": "Import",
  "import.from": "From",
  "import.source.notion": "Notion",
  "import.source.notion.help": "The .zip from Export (Markdown & CSV, or HTML)",
  "import.source.markdown": "Markdown",
  "import.source.markdown.help": ".md files, or a .zip of them (Obsidian vaults too)",
  "import.source.html": "HTML",
  "import.source.html.help": ".html files, or a .zip",
  "import.source.text": "Text",
  "import.source.text.help": ".txt files",
  "import.source.word": "Word",
  "import.source.word.help": ".docx files",
  "import.source.csv": "CSV",
  "import.source.csv.help": "A table becomes a database",
  "import.source.confluence": "Confluence",
  "import.source.confluence.help": "A space export (HTML .zip)",
  "import.source.evernote": "Evernote",
  "import.source.evernote.help": ".enex notebooks",
  "import.source.trello": "Trello",
  "import.source.trello.help": "A board’s JSON export",
  "import.drop": "Drop the {source} files here",
  "import.choose": "Choose files…",
  "import.limit": "Up to 500 MB. Nothing is sent until you start.",
  "import.chosen": "Chosen: {names}",
  "import.tooLarge": "That is more than 500 MB: import it in parts.",
  "import.nothing": "Nothing to import was found in those files for this source.",
  "import.where": "Put the pages in",
  "import.where.private": "Private",
  "import.where.workspace": "The workspace",
  "import.where.page": "The page open now",
  "import.start": "Import",
  "import.importing": "Importing “{name}”",
  "import.finished": "Imported “{name}”",
  "import.progressLabel": "Import progress",
  "import.counts": "{pages, plural, one {# page} other {# pages}} · {databases, plural, one {# database} other {# databases}} · {rows, plural, one {# row} other {# rows}} · {files, plural, one {# file} other {# files}} uploaded",
  "import.waiting": "Waiting a minute: the server takes only so many requests at a time. The import goes on by itself.",
  "import.report": "Report",
  "import.keepOpen": "Keep this tab open until the import ends.",
  "import.stop": "Stop",
  "import.done": "Import done: {pages, plural, one {# page} other {# pages}}, {databases, plural, one {# database} other {# databases}}.",
  "import.made.page": "✓ {title}",
  "import.made.database": "✓ {title} (database, {rows, plural, one {# row} other {# rows}}, {properties, plural, one {# property} other {# properties}})",
  "import.note.files": "⚠ Files other than pictures (PDFs, videos, sounds) were not imported: add them from Files.",
  "import.note.footnotes": "⚠ Footnotes were left out.",
  "import.note.todos": "⚠ Evernote’s check boxes became plain text.",
  "import.note.confluenceFlat": "⚠ The space’s page tree was not found: its pages are side by side.",
  "import.note.imageTooLarge": "⚠ The picture “{name}” is larger than 10 MB and was left out.",
  "import.note.contentFailed": "⚠ A page’s content could not be kept (too large or not valid).",
  "import.note.stopped": "The import was stopped: what was made so far stays.",
  "audit.action.page.version_linked": "Linked a version of a page in another language",
  "audit.action.page.duplicated": "Duplicated a page",
  "audit.action.page.version_unlinked": "Unlinked a version of a page",
  "versions.label": "This page in other languages",
  "versions.alsoIn": "Also in:",
  "versions.manage": "Languages…",
  "versions.intro": "Versions of the same page in other languages, linked to one another. Each is a page of its own, with its own text, sharing and address; on a published site, readers can go from one to the others.",
  "versions.section": "Versions in other languages",
  "versions.language": "Language",
  "versions.page": "Page",
  "versions.actions": "Actions",
  "versions.thisPage": "· this page",
  "versions.unlink": "Unlink",
  "versions.unlinkNamed": "Unlink the {language} version",
  "versions.add": "Add a version",
  "versions.addOpen": "Add a version…",
  "versions.noLanguage": "None chosen",
  "versions.chooseLanguage": "Choose a language…",
  "versions.taken": "This page already has a version in that language.",
  "versions.how": "How",
  "versions.copy": "Make a new page, a copy of this one to translate",
  "versions.link": "Link a page that already exists",
  "versions.copyHelp": "The new page goes beside this one, in the language chosen; its text is this page’s until you translate it.",
  "versions.noPage": "No page chosen",
  "versions.choosePage": "Choose a page…",
  "versions.done": "Done",
  "versions.addButton": "Add",
  "versions.added": "{language} version added.",
  "versions.unlinked": "{language} version unlinked.",
  "audit.action.account.email_changed": "Changed their email address",
  "audit.action.account.email_change_requested": "Asked to change their email address",
  "audit.action.account.email_sign_in": "Turned email sign-in on or off",
  "audit.action.auth.reauthenticated": "Confirmed it was them",
  "mail.greeting": "Hello {name},",
  "mail.greetingNoName": "Hello,",
  "mail.codeIntro": "Or type this code where you asked:",
  "mail.requested": "Requested from {device}, at {time}. If it wasn’t you, ignore this email: nothing happens without it.",
  "mail.signIn.subject": "Sign in to {site}",
  "mail.signIn.body": "Use this button to sign in. It works once, for 15 minutes.",
  "mail.signIn.button": "Sign in to {site}",
  "handover.title": "Signing you in to {workspace}…",
  "handover.text": "You are signed in to {site} at {central}. This address, {host}, needs its own sign-in, which happens by itself.",
  "handover.continue": "Continue to {workspace}",
  "handover.help": "If nothing happens, your browser may be holding it back: continue yourself. The sign-in works once, for one minute; after that, {again}.",
  "handover.again": "start again",
  "handover.expired.title": "This sign-in has expired",
  "handover.expired.text": "Sign-in passes work once, for a minute. Start again from the address you wanted to open.",
  "handover.expired.again": "Sign in again",
  "switcher.title": "Your workspaces",
  "switcher.more": "More",
  "switcher.create": "Create a workspace…",
  "switcher.all": "All workspaces",
  "switcher.allAt": "At {host}",
  "switcher.note": "Choosing one opens it at its address.",
  "addresses.nav": "Address",
  "addresses.ownersOnly": "Only the workspace’s owners manage its addresses.",
  "addresses.signIn.continueTo": "Sign in to continue to <b>{host}</b>.",
  "addresses.status.pending": "Waiting for approval",
  "addresses.status.provisioning": "Being set up",
  "addresses.status.active": "Approved",
  "addresses.status.refused": "Refused",
  "addresses.status.failed": "Failed",
  "addresses.status.not_pointing": "Not pointing here",
  "addresses.status.removing": "Being removed",
  "addresses.kind.subdomain": "Subdomain",
  "addresses.kind.site": "Site address",
  "addresses.kind.domain": "Own domain",
  "addresses.kind.alias": "Old name",
  "addresses.mainChip": "Main",
  "addresses.error.label_taken": "This name, or one that looks like it, is taken.",
  "addresses.error.label_taken_suggested": "This name, or one that looks like it, is taken. {suggestion} is free.",
  "addresses.error.label_invalid": "Use only lowercase letters, digits and hyphens, not at either end.",
  "addresses.error.label_too_short": "Too short: at least 3 characters.",
  "addresses.error.label_reserved": "Too close to a reserved name. Choose another.",
  "addresses.error.zone_full": "The installation’s domain has no addresses left ({limit} at most). Ask an administrator.",
  "addresses.error.no_workspace_domain": "This installation has no domain for workspace names.",
  "addresses.error.hostname_invalid": "Not a domain name such as docs.example.org.",
  "addresses.error.use_subdomain": "Addresses in the installation’s own domain are names: rename the workspace instead.",
  "addresses.error.hostname_reserved": "This domain is the installation’s own.",
  "addresses.error.hostname_taken": "This domain is already in use.",
  "addresses.error.workspace_domains_full": "This workspace has all the own domains it may ({limit}).",
  "addresses.error.domains_full": "The installation has all the own domains it may ({limit}).",
  "addresses.error.address_kept": "A workspace keeps its own name: rename it instead.",
  "addresses.error.address_is_site": "This is the site’s address: change it in Administration → Sites.",
  "addresses.error.not_an_address": "Only an address that answers can be the main one.",
  "addresses.error.not_pending": "This address is no longer waiting for a decision.",
  "addresses.error.not_failed": "This address did not fail.",
  "addresses.error.not_a_subdomain": "Only a workspace’s name can be renamed.",
  "addresses.main.title": "Main address",
  "addresses.main.label": "Main address",
  "addresses.main.help": "The workspace switcher opens it, and pages on no site live there. Its other addresses keep working.",
  "addresses.main.none": "No address answers yet. Once one does, it becomes the main address.",
  "addresses.main.notYet": "{status}: it can be the main address once it answers",
  "addresses.main.saved": "{host} is the main address now.",
  "addresses.main.command": "Make {host} the main address",
  "addresses.name.title": "Name in {domain}",
  "addresses.name.now": "Now <b>{host}</b>.",
  "addresses.name.none": "This workspace has no name in {domain} yet.",
  "addresses.name.renaming.pending": "Renaming to <b>{host}</b>: waiting for an administrator’s approval.",
  "addresses.name.renaming.provisioning": "Renaming to <b>{host}</b>: it answers within a few minutes.",
  "addresses.name.renaming.failed": "Renaming to <b>{host}</b> failed: an administrator can try again.",
  "addresses.rename.label": "Rename",
  "addresses.rename.choose": "Name",
  "addresses.rename.rules": "Lowercase letters, digits and hyphens, at least 3.",
  "addresses.rename.reserved": "Reserved names (such as paginae, www, admin, api) and names that look like them are not available.",
  "addresses.rename.redirect": "After renaming, {current} redirects to {next}, so old links keep working.",
  "addresses.rename.newName": "the new name",
  "addresses.rename.approval": "An administrator approves new names first.",
  "addresses.rename.submit": "Rename to {host}",
  "addresses.rename.submitEmpty": "Rename",
  "addresses.rename.useSuggestion": "Use {label}",
  "addresses.rename.command": "Rename the workspace’s address",
  "addresses.rename.done": "Renamed to {host}.",
  "addresses.rename.waiting": "Asked for {host}: it waits for an administrator’s approval.",
  "addresses.rename.soon": "Renaming to {host}: it answers within a few minutes, and the old name goes on until then.",
  "addresses.list.title": "The workspace’s addresses",
  "addresses.list.help": "Each address opens the app for its members and the published pages for visitors.",
  "addresses.list.none": "No addresses yet.",
  "addresses.shows.main": "The app, the published pages and pages on no site.",
  "addresses.shows.active": "The app and the published pages.",
  "addresses.shows.alias": "Goes to {host}.",
  "addresses.shows.pending": "Nothing yet: it waits for an administrator’s approval.",
  "addresses.shows.pendingDomain": "Nothing yet. Once approved, add a CNAME record for {name} pointing to {central}; then it opens this workspace.",
  "addresses.shows.provisioning": "Nothing yet: it answers within a few minutes.",
  "addresses.shows.failed": "Nothing: it could not be set up. An administrator can try again.",
  "addresses.shows.refused": "Nothing: an administrator refused it.",
  "addresses.shows.notPointing": "Nothing: its DNS no longer points to Pāginæ. Point it here again with a CNAME record to {central}, or it is removed on {date}.",
  "addresses.shows.removing": "Nothing: it is being removed.",
  "addresses.lastError": "Last attempt: {error}",
  "addresses.howTo": "How to point it here",
  "addresses.howToFor": "How to point {host} here",
  "addresses.howToText": "At the company where the domain is registered, add a CNAME record: name {host}, target {central}. Changes can take up to a day to be seen.",
  "addresses.withdraw": "Withdraw",
  "addresses.withdrawFor": "Withdraw the request for {host}",
  "addresses.remove": "Remove",
  "addresses.removeFor": "Remove {host}",
  "addresses.removeTitle": "Remove {host}?",
  "addresses.removeBody": "{host} stops answering at once: links to it stop working, and people signed in there are signed out.",
  "addresses.removeAliasBody": "{host} stops redirecting: old links to it stop working.",
  "addresses.removed": "{host} is being removed.",
  "addresses.own.open": "Use your own domain…",
  "addresses.own.command": "Use your own domain…",
  "addresses.own.title": "Use your own domain",
  "addresses.own.field": "Domain",
  "addresses.own.fieldHelp": "A domain you own, such as docs.example.org. An instance administrator approves it; then you point it here with a CNAME record to {central}.",
  "addresses.own.submit": "Ask for it",
  "addresses.own.help": "A domain you own, such as example.org. An instance administrator approves it; then you point it here with a CNAME record. At most {limit, number} own domains for this workspace ({used, number} so far).",
  "addresses.own.asked": "Asked for {host}. Once an administrator approves it, add a CNAME record pointing to {central}.",
  "addresses.admin.tab": "Addresses",
  "addresses.admin.inUse": "In use",
  "addresses.admin.zone": "Subdomains",
  "addresses.admin.zoneValue": "{used} of {limit} in {domain}",
  "addresses.admin.noDomain": "No domain set for workspace names (PAGINAE_WORKSPACE_DOMAIN)",
  "addresses.admin.ownDomains": "Own domains",
  "addresses.admin.ofLimit": "{used} of {limit}",
  "addresses.admin.limits": "Cloudflare’s limits: {zone} names per domain of this installation, and {own} own domains. Requests waiting for approval do not count until approved.",
  "addresses.admin.provider.fake": "Addresses are not attached to Cloudflare here: this is a test or local installation.",
  "addresses.admin.provider.unconfigured": "Addresses cannot be attached: the Cloudflare token and account are not set.",
  "addresses.admin.all": "All addresses",
  "addresses.admin.col.workspace": "Workspace",
  "addresses.admin.col.address": "Address",
  "addresses.admin.col.kind": "Kind",
  "addresses.admin.col.status": "Status",
  "addresses.admin.col.actions": "Actions",
  "addresses.admin.footer": "The central address, {central}, is not listed: sign-in and administration always live there. The main address of a workspace can be removed only after its owner chooses another.",
  "addresses.admin.approve": "Approve",
  "addresses.admin.approveFor": "Approve {host}",
  "addresses.admin.refuse": "Refuse",
  "addresses.admin.refuseFor": "Refuse {host}",
  "addresses.admin.retry": "Retry",
  "addresses.admin.retryFor": "Retry {host}",
  "addresses.admin.rename": "Rename",
  "addresses.admin.renameFor": "Rename {host}",
  "addresses.admin.remove": "Remove",
  "addresses.admin.removeFor": "Remove {host}",
  "addresses.admin.done.approve": "Approved {host}: it answers within a few minutes.",
  "addresses.admin.done.refuse": "Refused {host}.",
  "addresses.admin.done.retry": "Trying {host} again.",
  "addresses.admin.done.rename": "Renaming to {host}.",
  "addresses.admin.removeBody": "{host} of {workspace} stops answering at once: links to it stop working, and people signed in there are signed out.",
  "addresses.admin.renameTitle": "Rename {host} ({workspace})",
  "addresses.admin.renameHelp": "It takes effect without waiting for approval; {host} then redirects to the new name.",
  "addresses.approval.title": "New subdomains",
  "addresses.approval.label": "New subdomains need approval",
  "addresses.approval.helpOff": "Off: a new workspace gets its name in {domain} at once, and renaming takes effect at once. Turn it on when people other than administrators may create workspaces. Own domains always need approval.",
  "addresses.approval.helpOn": "On: new workspaces’ names in {domain}, and renamed ones, wait for an administrator here. Own domains always need approval.",
  "addresses.approval.on": "New subdomains need approval now.",
  "addresses.approval.off": "New subdomains no longer need approval.",
  "addresses.approval.commandOn": "New subdomains need approval: turn on",
  "addresses.approval.commandOff": "New subdomains need approval: turn off",
  "addresses.reserved.title": "Reserved names",
  "addresses.reserved.help": "No workspace can take these, names that look like them (such as paglnae or adm1n) or names shorter than 3 characters. The first ones are always reserved.",
  "addresses.reserved.add": "Add a reserved name",
  "addresses.reserved.addButton": "Add",
  "addresses.reserved.command": "Add a reserved name",
  "addresses.reserved.added": "{name} is reserved now.",
  "addresses.reserved.removed": "{name} is no longer reserved.",
  "addresses.reserved.removeFor": "Remove the reserved name {name}",
  "mail.signUp.subject": "Confirm your address for {site}",
  "mail.signUp.body": "Use this button to create your account in {site}. It works once, for 15 minutes.",
  "mail.signUp.button": "Create my account",
  "mail.noAccount.subject": "Signing in to {site}",
  "mail.noAccount.body": "Someone asked to sign in to {site} with this address, but it has no account there. To get one, ask whoever runs it for an invitation. If it wasn’t you, ignore this email.",
  "mail.change.subject": "Confirm your new address for {site}",
  "mail.change.body": "Use this button to make this your address in {site}. It works once, for 15 minutes.",
  "mail.change.button": "Confirm this address",
  "mail.changeNotice.subject": "Your address in {site} is changing",
  "mail.changeNotice.body": "Someone signed in to your account in {site} asked to change its address to {email}. If it wasn’t you, sign in and check your account’s security.",
  "mail.reauth.subject": "Your confirmation code for {site}",
  "mail.reauth.body": "Type this code in {site} to confirm it is you. It works once, for 15 minutes.",
  "audit.action.auth.oauth_unlinked": "Unlinked a sign-in account",
  "audit.action.account.email_unsubscribed": "Stopped some notification emails",
  "mail.notice.open": "Open in {site}",
  "mail.notice.unsubscribe": "Stop emails like this",
  "mail.notice.settings": "Choose which emails you get",
  "mail.digest.subject": "Your daily summary from {site}",
  "mail.digest.intro": "Here is what happened since your last summary:",
  "mail.digest.open": "Open your Inbox in {site}",
  "mail.digest.unsubscribe": "Stop all notification emails",
  "emailSignIn.email": "Email address",
  "emailSignIn.continue": "Continue with email",
  "emailSignIn.help": "We’ll email you a link and a code to sign in. No password.",
  "emailSignIn.or": "or",
  "emailSignIn.checkTitle": "Check your email",
  "emailSignIn.checkBody": "If <b>{email}</b> can sign in here, we’ve sent it a link and a code. They work once, for 15 minutes.",
  "emailSignIn.codeLabel": "Code from the email",
  "emailSignIn.codeHelp": "Opened the email on another device? Type the code here instead.",
  "emailSignIn.signIn": "Sign in",
  "emailSignIn.againIn": "Send again (in {seconds} s)",
  "emailSignIn.again": "Send again",
  "emailSignIn.other": "Use another address",
  "emailSignIn.invalidTitle": "Link not valid",
  "emailSignIn.invalid": "This link has expired or was already used. Links work once, for 15 minutes.",
  "emailSignIn.askAgain": "Ask for a new one",
  "emailSignIn.linkTitle": "Sign in",
  "emailSignIn.linkBody": "Sign in as <b>{email}</b>?",
  "emailSignIn.changeTitle": "Confirm your new address",
  "emailSignIn.changeBody": "Make <b>{email}</b> your account’s address?",
  "emailSignIn.confirmAddress": "Confirm this address",
  "emailSignIn.changedTitle": "Address changed",
  "emailSignIn.changed": "Your account’s address is now <b>{email}</b>.",
  "emailSignIn.continueToApp": "Continue",
  "emailSignIn.signUpTitle": "Create your account",
  "emailSignIn.confirmed": "Address confirmed: <b>{email}</b>.",
  "emailSignIn.name": "Your name",
  "emailSignIn.nameHelp": "Shown to people you work with.",
  "emailSignIn.language": "Language",
  "emailSignIn.create": "Create account",
  "reauth.title": "Confirm it’s you",
  "reauth.sending": "Sending a code to your email address…",
  "reauth.sent": "We sent a code to <b>{email}</b>. Type it here to go on.",
  "reauth.confirm": "Confirm",
  "passkeyOffer.title": "Sign in faster next time",
  "passkeyOffer.body": "Add a passkey on this device: your fingerprint, face or screen lock instead of an email each time. It never leaves the device.",
  "passkeyOffer.add": "Add a passkey",
  "passkeyOffer.later": "Not now",
  "passkeyOffer.never": "Don’t ask on this device",
  "unsubscribe.title": "Notification emails",
  "unsubscribe.done": "Done: no more emails for “{kind}”. They still reach your Inbox.",
  "unsubscribe.doneAll": "Done: notification emails are paused. Everything still reaches your Inbox.",
  "unsubscribe.invalid": "This link is not valid. Sign in to choose which emails you get.",
  "unsubscribe.settings": "Choose which emails you get",
  "notifEmail.title": "Notifications",
  "notifEmail.saved": "Saved.",
  "notifEmail.off": "This installation sends no email at the moment; these choices apply once it does.",
  "notifEmail.intro": "Everything is always in your Inbox. Choose what is also sent to <b>{email}</b>.",
  "notifEmail.kind": "Notification",
  "notifEmail.byEmail": "By email",
  "notifEmail.mode.now": "Right away",
  "notifEmail.mode.digest": "In the daily summary",
  "notifEmail.mode.never": "Never",
  "notifEmail.hour": "Daily summary at",
  "notifEmail.timeZone": "Time zone",
  "notifEmail.pause": "Pause all notification emails",
  "notifEmail.help": "Nothing you have already read in the app is emailed. Every email has a link that stops emails of its kind.",
  "signInMethods.title": "Ways to sign in",
  "signInMethods.email": "Email link or code",
  "signInMethods.on": "On",
  "signInMethods.off": "Off",
  "signInMethods.address": "To <b>{email}</b>",
  "signInMethods.change": "Change address",
  "signInMethods.changeTitle": "Change your address",
  "signInMethods.newAddress": "New address",
  "signInMethods.changeHelp": "We’ll send a link to the new address, and a notice to the current one. The address changes when you open the link.",
  "signInMethods.sendLink": "Send the link",
  "signInMethods.changeSent": "Link sent to {email}. Open it to finish.",
  "signInMethods.passkeysOnly": "Passkeys only",
  "signInMethods.passkeysOnlyHelp": "Turn off email sign-in for this account. Only your passkeys and recovery codes sign you in; someone who gets into your mailbox can’t use it to get into this account.",
  "signInMethods.needsPasskey": "Add a passkey first: then email sign-in can be turned off.",
  "signInMethods.onlyOn": "Email sign-in is off for your account.",
  "signInMethods.onlyOff": "Email sign-in is on for your account.",
  "signInMethods.disconnect": "Disconnect",
  "signInMethods.disconnectNamed": "Disconnect {provider}",
  "signInMethods.disconnected": "Disconnected.",
  "command.notificationEmails": "Notification emails",
  "invite.byEmail": "Join with an email link",
  "invite.providerHelp": "With a sign-in provider, use the account whose address is {email}.",
  "email.domainReady": "{domain} is set up for sending (SPF and DMARC found).",
  "email.domainMissing": "{domain} is missing {missing}: receiving servers may treat the emails as spam. Your email provider’s dashboard shows the records to add.",
  "email.senderName": "Sender name",
  "email.senderAddress": "Sender address",
  "email.senderAddressHelp": "On a domain set up for sending with the provider chosen.",
  "settings.email.provider.option.cloudflare": "Cloudflare Email Service (Workers Paid: 3,000 a month included)",
  "settings.auth.emailSignIn.label": "Sign in by email link or code",
  "settings.auth.emailSignIn.help": "For everyone, with the address of their account. Turning it off leaves passkeys, sign-in providers and recovery codes. Needs a way to send email, above.",
  "error.too_many_emails": "Too many emails to this address. Try again in an hour.",
  "error.email_cooldown": "Wait a few seconds before asking again.",
  "error.code_invalid": "That code is not right, or it has expired.",
  "error.link_invalid": "This link has expired or was already used.",
  "error.email_sign_in_off": "Signing in by email is not available here.",
  "error.email_off": "This installation does not send email.",
  "error.email_taken": "Another account has this address.",
  "error.passkey_needed": "Add a passkey before turning email sign-in off.",
  "error.unsubscribe_invalid": "This link is not valid.",
  "error.bad_time_zone": "Unknown time zone.",
  "notifEmail.group.mentions": "Mentions and replies to you",
  "notifEmail.group.access": "Access requests, and access given to you",
  "notifEmail.group.reminders": "Reminders",
  "notifEmail.group.exercises": "Exercises sent, marked or reopened",
  "notifEmail.group.followedComments": "Comments on pages you follow",
  "notifEmail.group.followedChanges": "Changes to pages you follow",
  "notifEmail.group.reactions": "Reactions to your comments",
  "notifEmail.group.moderation": "Moderation: edit proposals and reports",
  "notifEmail.group.notices": "Buttons and automations that notify you",
  "notifEmail.group.paused": "Webhooks and automations that paused",
  "page.addCover": "Add cover",
  "page.addIcon": "Add icon",
  "page.changeIcon": "Change icon…",
  "page.changeCover": "Change cover…",
  "cover.add": "Add cover",
  "icon.add": "Add icon",
  "icon.change": "Change icon",
  "icon.picker": "Icon",
  "icon.tabs": "Where the icon comes from",
  "icon.tab.emoji": "Emoji",
  "icon.tab.upload": "Upload",
  "icon.remove": "Remove",
  "icon.search": "Search emoji",
  "icon.searchPlaceholder": "Search emoji, in your language or English",
  "icon.emoji": "Emoji",
  "icon.found": "Found",
  "icon.recent": "Recent",
  "icon.none": "No emoji with that name.",
  "icon.loadFailed": "The emoji could not be loaded. Try again later.",
  "icon.keys": "Arrow keys move through the emoji, Enter chooses.",
  "icon.choose": "Choose an image…",
  "icon.uploadHelp": "A small image (PNG, SVG, WebP, GIF or JPEG), kept in the workspace’s files.",
  "icon.notImage": "That file is not an image.",
  "icon.uploadFailed": "The image could not be uploaded.",
  "icon.saved": "Icon changed.",
  "icon.removed": "Icon removed.",
  "cover.change": "Change cover",
  "cover.reposition": "Reposition",
  "cover.remove": "Remove",
  "cover.repositionCommand": "Reposition cover",
  "cover.removeCommand": "Remove cover",
  "cover.removed": "Cover removed.",
  "cover.saved": "Cover changed.",
  "cover.picker": "Cover",
  "cover.tabs": "Where the cover comes from",
  "cover.tab.gallery": "Gallery",
  "cover.tab.upload": "Upload",
  "cover.tab.link": "Link",
  "cover.colours": "Colours and gradients",
  "cover.colour.sunrise": "Sunrise gradient",
  "cover.colour.sky": "Sky gradient",
  "cover.colour.mint": "Mint gradient",
  "cover.colour.deep": "Deep sea gradient",
  "cover.colour.red": "Red",
  "cover.colour.green": "Green",
  "cover.colour.orange": "Orange",
  "cover.colour.slate": "Slate",
  "cover.met": "The Metropolitan Museum of Art",
  "cover.publicDomain": "Public domain",
  "cover.work": "{title}, {artist}",
  "cover.drop": "Drop an image here, or",
  "cover.chooseImage": "Choose an image…",
  "cover.uploadHelp": "JPEG, PNG, WebP or AVIF, up to 10 MB. Wider than 1500 pixels looks best.",
  "cover.uploading": "Uploading the cover…",
  "cover.link": "Address of an image",
  "cover.linkHelp": "The image is copied into this workspace's files.",
  "cover.useLink": "Use this image",
  "cover.label": "Cover image",
  "cover.position": "Cover position",
  "cover.positionHelp": "Drag the image to move it, or use the arrow keys. Shift and an arrow move it faster.",
  "cover.positionNow": "Horizontal {x}%, vertical {y}%",
  "cover.zoom": "Zoom",
  "cover.savePosition": "Save position",
  "cover.cancel": "Cancel",
  "cover.metCredit": "{artist}, {title} · The Met",
  "cover.saveKey": "Save Unsplash key",
  "cover.removeKey": "Remove Unsplash key",
  "cover.keySaved": "Unsplash key saved.",
  "cover.keyRemoved": "Unsplash key removed.",
  "error.bad_cover": "That can't be used as a cover.",
  "error.link_unreadable": "That address did not give an image.",
  "cover.photoByLinks": "Photo by {author} on {unsplash}",
  "cover.noEncryption": "Unsplash needs the PAGINAE_ENCRYPTION_KEY secret, which keeps its key encrypted. See the self-hosting guide.",
  "publish.subpagesAt": "Sub-pages are at {path}",
  "siteSettings.links.label.help": "Leave empty to show the page’s title, kept in sync, in the language being read (its version in that language).",
  "blockAccess.menu": "Access…",
  "blockAccess.visibilityMenu": "Visibility…",
  "blockAccess.visibility": "Visibility",
  "blockAccess.permissions": "Permissions",
  "blockAccess.rule": "Rule",
  "blockAccess.showWhen": "Show only when…",
  "blockAccess.hideWhen": "Hide when…",
  "blockAccess.match": "Which conditions",
  "blockAccess.matchAll": "all conditions match",
  "blockAccess.matchAny": "any condition matches",
  "blockAccess.conditions": "Conditions",
  "blockAccess.conditionN": "Condition {n}",
  "blockAccess.removeCondition": "Remove condition {n}",
  "blockAccess.add": "+ Add condition",
  "blockAccess.kind": "Condition",
  "blockAccess.kind.address": "Address",
  "blockAccess.kind.query": "Query parameter",
  "blockAccess.kind.pageLanguage": "Page’s language",
  "blockAccess.kind.readerLanguage": "Reader’s language",
  "blockAccess.kind.schedule": "Schedule",
  "blockAccess.op": "Matching",
  "blockAccess.op.is": "is exactly",
  "blockAccess.op.starts": "starts with",
  "blockAccess.op.glob": "matches pattern (* and **)",
  "blockAccess.op.regex": "matches regex",
  "blockAccess.address": "Address",
  "blockAccess.regexBad": "Not a regular expression that can be used: up to 200 characters, without back-references or repeated groups that repeat inside.",
  "blockAccess.queryName": "Parameter",
  "blockAccess.queryValue": "Value",
  "blockAccess.queryAny": "any value",
  "blockAccess.languages": "Languages",
  "blockAccess.editorsSee": "People who may edit this block always see it, marked “Shown only to some readers”. In the app, “address” is the page’s published address and “reader’s language” the person’s interface language; query parameters apply on published sites only.",
  "blockAccess.test": "Test an address",
  "blockAccess.testShown": "Shown at this address (address and query conditions only).",
  "blockAccess.testHidden": "Not shown at this address (address and query conditions only).",
  "blockAccess.invalid": "Some conditions are incomplete: check each one.",
  "blockAccess.saved": "Visibility saved.",
  "blockAccess.removed": "Visibility conditions removed.",
  "blockAccess.clear": "Remove all conditions",
  "blockAccess.someReaders": "Shown only to some readers",
  "error.bad_conditions": "Those conditions can't be used.",
  "blockAccess.title": "Access to this block",
  "siteSettings.links.texts": "Link {n} in other languages",
  "siteSettings.links.texts.help": "Shown on pages in that language. Left empty: the text above, or the linked page’s title in that language.",
  "siteSettings.links.visibility": "Visibility of link {n}…",
  "siteSettings.links.visibilityTitle": "Visibility of “{label}”",
  "editSite.title": "Editing the site",
  "editSite.open": "Edit the site on screen",
  "editSite.unpublished": "the draft has unpublished changes",
  "editSite.previewAs": "Preview in",
  "editSite.addHeader": "Add to the header",
  "editSite.addFooter": "Add to the footer",
  "editSite.discard": "Discard draft",
  "editSite.publish": "Publish changes",
  "editSite.exit": "Exit",
  "editSite.frame": "The site {hostname}, being edited",
  "editSite.editElement": "Edit “{name}”",
  "editSite.menu": "Element",
  "editSite.saved": "Saved to the draft.",
  "editSite.published": "Published.",
  "editSite.discarded": "Draft discarded.",
  "editSite.newLink": "New link",
  "editSite.newText": "New text",
  "editSite.action.content": "Edit content…",
  "editSite.action.visibility": "Visibility…",
  "editSite.action.permissions": "Permissions…",
  "editSite.action.before": "Add before…",
  "editSite.action.after": "Add after…",
  "editSite.action.left": "Move earlier",
  "editSite.action.right": "Move later",
  "editSite.action.delete": "Delete",
  "editSite.kind.page": "Link to a page",
  "editSite.kind.address": "Link to an address",
  "editSite.kind.text": "Text",
  "editSite.kind.heading": "Heading",
  "editSite.kind.bulleted": "Bulleted list",
  "editSite.kind.quote": "Quote",
  "editSite.kind.callout": "Callout",
  "editSite.kind.divider": "Divider",
  "editSite.kind.html": "Any block (as HTML)",
  "editSite.panel.items": "Link",
  "editSite.panel.blocks": "Block",
  "editSite.tab.content": "Content",
  "editSite.tab.visibility": "Visibility",
  "editSite.tab.permissions": "Permissions",
  "editSite.linksTo": "Links to",
  "editSite.anAddress": "An address…",
  "editSite.address": "Address",
  "editSite.text": "Text",
  "editSite.textsHelp": "A language left empty shows the text above, or the linked page’s title in that language.",
  "editSite.mainContent": "Content (every language)",
  "editSite.htmlHelp": "Each block as HTML, as “Edit as HTML” in pages shows it: any kind of block. A language left empty shows the main content.",
  "editSite.badHtml": "That HTML could not be read as a block.",
  "editSite.permissionsNote": "Published sites don’t know who is reading, so an element can’t be limited to particular people there. Use Visibility to show it by address, language or time.",
  "editSite.delete": "Delete",
  "editSite.saveDraft": "Save to draft",
  "editSite.savePublish": "Save and publish",
  "page.present": "Present",
  "command.present": "Present this page",
  "presentation.label": "Presenting “{title}”",
  "presentation.slide": "Slide {n} of {count}",
  "presentation.slideRole": "slide",
  "presentation.previous": "‹ Previous",
  "presentation.next": "Next ›",
  "presentation.exit": "Exit presentation",
  "page.verify": "Verify…",
  "page.makeWiki": "Turn into wiki",
  "verification.madeWiki": "“{title}” is a wiki now: its pages are its entries, with an owner, verification and tags.",
  "command.verify": "Verify this page…",
  "command.unverify": "Remove this page’s verification",
  "verification.title": "Verify this page",
  "verification.help": "A verified page is marked as up to date and comes first in search. When the verification ends, you are told in your inbox.",
  "verification.for": "Verified for",
  "verification.week": "1 week",
  "verification.month": "30 days",
  "verification.quarter": "90 days",
  "verification.date": "Until a date",
  "verification.indefinitely": "Indefinitely",
  "verification.until": "Until",
  "verification.verify": "Verify",
  "verification.menu": "Verification",
  "verification.byUntil": "Verified by {name} until {date}",
  "verification.byIndefinitely": "Verified by {name}",
  "verification.expired": "Verification expired",
  "verification.again.week": "Verify for 1 week",
  "verification.again.month": "Verify for 30 days",
  "verification.again.quarter": "Verify for 90 days",
  "verification.again.date": "Verify until a date…",
  "verification.again.indefinitely": "Verify indefinitely",
  "verification.remove": "Remove verification",
  "verification.done": "Page verified until {date}.",
  "verification.doneIndefinitely": "Page verified indefinitely.",
  "verification.removed": "Verification removed.",
  "database.type.verification": "Verification",
  "database.verification.verified": "Verified",
  "database.verification.expired": "Expired",
  "inbox.verification_expired": "The verification of {page} has expired",
  "searchPage.verified": "Verified pages only",
  "searchPage.verifiedTag": "Verified",
  "consent.title": "Content from other sites",
  "consent.intro": "This page shows content from {names}. Showing it lets them set cookies and see that you opened the page. Nothing from other sites loads until you choose. Your choice is kept with your account, on every device.",
  "consent.choose": "Choose by source",
  "consent.necessary": "Necessary · always on",
  "consent.necessaryText": "Keeps you signed in and remembers how you left the app (the sidebar, recent pages). Never shared.",
  "consent.fullList": "The full list",
  "consent.others": "Content from other sites",
  "consent.onThisPage": "On this page.",
  "consent.elsewhere": "Not on this page.",
  "consent.mayTrack": "May set cookies and see your visit.",
  "consent.policy": "Its privacy policy",
  "consent.analytics": "Not asked, because it uses no cookies and nothing personal: visit counts on published sites by Cloudflare Web Analytics.",
  "consent.reject": "Reject all",
  "consent.accept": "Accept all",
  "consent.save": "Save my choices",
  "consent.corner": "Cookie choices",
  "consent.saved": "Your choices are saved.",
  "consent.kind.video": "video",
  "consent.kind.recording": "recording",
  "consent.kind.design": "design",
  "consent.kind.code": "code",
  "consent.kind.audio": "audio",
  "consent.kind.board": "board",
  "consent.placeholder.title": "{provider} {kind}",
  "consent.placeholder.text": "It comes from {provider}, which may set cookies and see that you opened this page.",
  "consent.allow.play": "Allow {provider} and play",
  "consent.allow.show": "Allow {provider} and show it",
  "consent.open.watch": "Watch on {provider}",
  "consent.open.listen": "Listen on {provider}",
  "command.cookieChoices": "Cookie choices",
  "command.cookies": "Cookies",
  "cookies.title": "Cookies",
  "cookies.intro": "What this installation stores in people’s browsers, and what other sites can see, made from the app’s own code. The same rules apply to everyone, as EU law asks: content from other sites waits for consent; nothing else needs it.",
  "cookies.necessary": "Necessary",
  "cookies.withoutCookies": "Without cookies",
  "cookies.others": "Content from other sites",
  "cookies.notAsked": "Not asked",
  "cookies.asked": "Asked first",
  "cookies.othersHelp": "Shown in place of the content until the person allows its source; in the app their choice is kept with their account, on sites in one cookie of the site’s own.",
  "cookies.col.name": "Name",
  "cookies.col.kind": "Kind",
  "cookies.col.purpose": "What for",
  "cookies.col.kept": "Kept for",
  "cookies.col.service": "Service",
  "cookies.col.stores": "Stores",
  "cookies.col.source": "Source",
  "cookies.col.loads": "Loads from",
  "cookies.col.policy": "Privacy policy",
  "cookies.kind.cookie": "Cookie",
  "cookies.kind.siteCookie": "Cookie, on sites",
  "cookies.kind.storage": "Local storage",
  "cookies.purpose.session": "Keeps you signed in",
  "cookies.purpose.oauth": "Signing in with Google, Microsoft or GitHub",
  "cookies.purpose.consent": "A visitor’s choices on a published site",
  "cookies.purpose.sidebar": "Which pages are open in the sidebar",
  "cookies.purpose.recent": "Recent pages in Search",
  "cookies.purpose.lastWorkspace": "The workspace you were last in",
  "cookies.purpose.offers": "Offers you closed, so they don’t come back",
  "cookies.purpose.analytics": "Visit counts on sites (when a site turns it on)",
  "cookies.purpose.turnstile": "Telling people from bots on forms",
  "cookies.kept.session": "As long as Security settings say (30 days unless changed)",
  "cookies.kept.oauth": "10 minutes",
  "cookies.kept.consent": "6 months",
  "cookies.kept.sidebar": "Until cleared",
  "cookies.kept.recent": "Until cleared",
  "cookies.kept.lastWorkspace": "Until cleared",
  "cookies.kept.offers": "Until cleared",
  "cookies.service.analytics": "Cloudflare Web Analytics",
  "cookies.service.turnstile": "Cloudflare Turnstile",
  "cookies.nothing": "Nothing",
  "cookies.embedded.video": "Embedded videos",
  "cookies.embedded.recording": "Embedded recordings",
  "cookies.embedded.design": "Embedded designs",
  "cookies.embedded.code": "Embedded code",
  "cookies.embedded.audio": "Embedded audio",
  "cookies.embedded.board": "Embedded boards",
  "cookies.policyOf": "{name}’s privacy policy",
  "cookies.unsplash": "Cover photos chosen from Unsplash are copied into the workspace’s files, so readers never load them from Unsplash.",
  "siteCookies.title": "Cookies",
  "siteCookies.intro": "Made from what this site’s published pages contain. Visitors see the choices only on pages that show content from other sites, with a small “Cookie choices” button after they choose.",
  "siteCookies.category": "Category",
  "siteCookies.onPages": "On pages",
  "siteCookies.thisSite": "(this site)",
  "siteCookies.necessary": "Necessary · not asked",
  "siteCookies.free": "Without cookies · not asked",
  "siteCookies.asked": "Content from other sites · asked",
  "siteCookies.wherever": "Wherever a visitor chooses",
  "siteCookies.all": "All (turned on in Analytics)",
  "siteCookies.note": "A note above the choices",
  "siteCookies.note.help": "Optional, for every language: who to ask about visitors’ data, say.",
  "siteCookies.noteIn": "The note in {language}",
  "siteCookies.public": "Visitors can read this list at {link}.",
  "admin.settings.tabs": "Settings sections",
  "command.settingsTab": "Settings: {tab}",
  "command.hideSidebar": "Hide the sidebar",
  "command.theme.system": "Theme: follow this device",
  "command.theme.light": "Theme: light",
  "command.theme.dark": "Theme: dark",
  "command.showSidebar": "Show the sidebar",
  "siteSettings.tabs": "Site settings sections",
  "command.siteSettingsTab": "Site settings: {tab}",
  "email.senders": "Senders",
  "email.senders.help": "Each needs its domain set up for sending with the service chosen above (an SPF record and a DMARC policy). The default sends whatever has no sender of its own.",
  "email.senders.domain": "Domain",
  "email.senders.default": "Default",
  "email.senders.actions": "Actions",
  "email.senders.add": "Add a sender",
  "email.senders.checking": "Checking…",
  "email.senders.ready": "Ready",
  "email.senders.notReady": "Not set up (missing {missing})",
  "email.senders.makeDefault": "Default sender: {address}",
  "email.senders.edit": "Edit {address}",
  "email.senders.editShort": "Edit",
  "email.senders.remove": "Remove {address}",
  "email.senders.removeShort": "Remove",
  "email.senders.taken": "That address is already a sender",
  "email.senders.invalid": "An email address, like notices@example.org",
  "email.senders.done": "Done",
  "email.senders.cancel": "Cancel",
  "email.purposes": "Who sends what",
  "email.purposes.email": "Email",
  "email.purposes.sender": "Sent by",
  "email.purposes.help": "A sender whose domain isn’t ready can’t be chosen. Changes take effect when you save.",
  "email.purposes.default": "Default ({address})",
  "email.purposes.notReady": "{address} (domain not set up)",
  "email.purpose.signIn": "Sign-in and sign-up links and codes",
  "email.purpose.notifications": "Notifications",
  "email.purpose.digest": "Daily summary",
  "email.purpose.automations": "Automation emails",
  "email.purpose.forms": "Form answers",
  "email.purpose.test": "Test emails",
  "settings.email.senders.label": "Other senders",
  "settings.email.senders.help": "Addresses besides the default that some emails can come from.",
  "settings.email.purposes.label": "Who sends what",
  "settings.email.purposes.help": "The sender for each kind of email; those left out come from the default.",
  "pageProperty.label": "Properties",
  "pageProperty.add": "Add a property",
  "pageProperty.addShort": "Add property",
  "pageProperty.added": "Property “{name}” added.",
  "pageProperty.removed": "Property “{name}” removed from the page.",
  "pageProperty.saved": "Property saved.",
  "pageProperty.actionsFor": "Property “{name}”: actions",
  "pageProperty.settings": "Settings…",
  "pageProperty.removeFromPage": "Remove from this page",
  "pageProperty.settingsCommand": "Property settings: {name}",
  "pageProperty.removeCommand": "Remove property from page: {name}",
  "pageProperty.valueOf": "{name}",
  "pageProperty.verified": "Verified by {name}",
  "pageProperty.verifiedUntil": "Verified by {name} until {date}",
  "pageProperty.notVerified": "Not verified",
  "pageProperty.usedOn": "{value} ({pages, plural, one {# page} other {# pages}})",
  "pageProperty.onlySet": "Only the property’s own values may be chosen.",
  "pageProperty.onlySetHelp": "This property takes only its own values.",
  "pageProperty.removeValue": "Remove {value}",
  "pageProperty.chooseValue": "Value",
  "pageProperty.addValue": "Add a value",
  "pageProperty.choose": "Choose",
  "pageProperty.addValueButton": "Add",
  "pageProperty.clear": "Clear",
  "pageProperty.addPage": "Add a page",
  "pageProperty.file": "File {n}",
  "pageProperty.addFile": "Add a file…",
  "pageProperty.addFileTo": "Add a file to {name}",
  "pageProperty.name": "Name",
  "pageProperty.inUse": "Properties already used",
  "pageProperty.inUseDetail": "{type} · {pages, plural, one {# page} other {# pages}}",
  "pageProperty.newOfType": "Or a new property “{name}” of type",
  "pageProperty.newType": "Or a new property of type",
  "pageProperty.types": "Property types",
  "pageProperty.settingsTitle": "Property “{name}”",
  "pageProperty.notYours": "Only whoever made this property, or an administrator, changes its name and settings.",
  "pageProperty.type": "Type",
  "pageProperty.values": "Values",
  "pageProperty.anyValue": "Any value (suggests values already used)",
  "pageProperty.onlyThese": "Only these values",
  "pageProperty.pages": "{pages, plural, one {# page} other {# pages}}",
  "pageProperty.remove": "Remove",
  "pageProperty.newValue": "New value",
  "pageProperty.fill": "Fill from values already used",
  "pageProperty.fillHelp": "Values already used are those this property has on pages you can see, and in database columns of the same name and type. Values on pages you can’t see aren’t shown or added.",
  "pageProperty.format": "Number format",
  "pageProperty.expression": "Formula",
  "pageProperty.rollupRelation": "Relation",
  "pageProperty.rollupTarget": "Property of the related pages",
  "pageProperty.rollupFunction": "Calculate",
  "pageProperty.prefix": "Prefix",
  "pageProperty.buttonSummary": "“{label}” · {n, plural, =0 {does nothing yet} one {# action} other {# actions}}",
  "pageProperty.buttonActions": "What it does…",
  "pageProperty.save": "Save",
  "pageProperty.cancel": "Cancel",
  "pageProperty.type.text": "Text",
  "pageProperty.type.number": "Number",
  "pageProperty.type.select": "Select",
  "pageProperty.type.multi_select": "Multi-select",
  "pageProperty.type.status": "Status",
  "pageProperty.type.date": "Date",
  "pageProperty.type.person": "Person",
  "pageProperty.type.files": "Files and media",
  "pageProperty.type.checkbox": "Checkbox",
  "pageProperty.type.url": "URL",
  "pageProperty.type.email": "Email",
  "pageProperty.type.phone": "Phone",
  "pageProperty.type.list": "List",
  "pageProperty.type.tags": "Tags",
  "pageProperty.type.aliases": "Aliases",
  "pageProperty.type.formula": "Formula",
  "pageProperty.type.relation": "Relation",
  "pageProperty.type.rollup": "Rollup",
  "pageProperty.type.place": "Place",
  "pageProperty.type.button": "Button",
  "pageProperty.type.unique_id": "ID",
  "pageProperty.type.verification": "Verification",
  "pageProperty.type.created_time": "Created time",
  "pageProperty.type.created_by": "Created by",
  "pageProperty.type.last_edited_time": "Last edited time",
  "pageProperty.type.last_edited_by": "Last edited by",
  "pageProperty.suggested": "Values of “{name}”",
  "pageProperty.pagesList": "Pages",
  "alternatives.list": "Options: one of them shows",
  "alternatives.add": "Add an option",
  "alternatives.otherwise": "Otherwise",
  "alternatives.numbered": "{n} · {label}",
  "alternatives.order": "Options are tried in order; the first whose conditions hold is shown, else “Otherwise”.",
  "alternatives.otherwiseSummary": "Shown when no option before it applies.",
  "alternatives.unset": "No conditions yet: shown to no one until they are set.",
  "alternatives.shownFirstIf": "Shown first if: {conditions}.",
  "alternatives.shownIf": "Shown if: {conditions}, and no option before it applies.",
  "alternatives.cond.signedIn": "the reader is signed in",
  "alternatives.cond.signedOut": "the reader is not signed in",
  "alternatives.cond.group": "the reader is in {count, plural, one {the group} other {one of the groups}} {names}",
  "alternatives.cond.person": "the reader is {names}",
  "alternatives.cond.address.is": "the address is {value}",
  "alternatives.cond.address.starts": "the address starts with {value}",
  "alternatives.cond.address.glob": "the address matches {value}",
  "alternatives.cond.address.regex": "the address matches the regex {value}",
  "alternatives.cond.query": "the query parameter {name} is {value}",
  "alternatives.cond.queryPresent": "the address has the query parameter {name}",
  "alternatives.cond.pageLanguage": "the page is in {languages}",
  "alternatives.cond.readerLanguage": "the reader reads {languages}",
  "alternatives.cond.schedule": "it is within its schedule",
  "alternatives.conditionsMenu": "Conditions…",
  "alternatives.conditionsTitle": "Conditions of “{label}”",
  "alternatives.makeOtherwise": "Make it “Otherwise”",
  "alternatives.help": "Readers see only the option that applies to them: the first, in order, whose conditions hold. People who may edit the page see every option, as tabs. On published sites, visitors are never signed in. Use block permissions to keep something private: conditions choose what shows, they do not protect it.",
  "alternatives.saved": "Conditions saved.",
  "alternatives.madeOtherwise": "The option is now “Otherwise”.",
  "blockAccess.kind.signedIn": "Signed in",
  "blockAccess.kind.group": "Group",
  "blockAccess.kind.person": "Person",
  "blockAccess.signedIn": "Is signed in",
  "blockAccess.signedOut": "Is not signed in",
  "blockAccess.groups": "Groups",
  "blockAccess.people": "People",
  "blockAccess.addPerson": "Add a person",
  "slash.alternatives": "Alternatives",
  "slash.alternatives.description": "Options of which each reader sees one, by conditions",
  "calendar.note": "Times in your time zone ({zone}).",
  "calendar.busy": "Busy",
  "calendar.busyOnly": "Only busy times are shown, updated every few minutes.",
  "calendar.previousWeek": "Previous week",
  "calendar.nextWeek": "Next week",
  "calendar.detailsNote": "Details show only to people who may see them.",
  "calendar.name": "Calendar",
  "calendar.settingsButton": "Calendar settings…",
  "calendar.empty": "Choose what this calendar shows in its settings.",
  "calendar.loading": "Loading…",
  "calendar.failed": "The calendar could not be read just now.",
  "calendar.thisWeek": "This week",
  "calendar.ical": "iCal address",
  "calendar.settings.title": "Calendar settings",
  "calendar.settings.name": "Name",
  "calendar.settings.shows": "Shows",
  "calendar.settings.availability": "Availability from my calendars",
  "calendar.settings.schedule": "A regular weekly schedule from a database",
  "calendar.settings.database": "Database",
  "calendar.settings.databases": "Databases",
  "calendar.settings.databaseHelp": "Its rows are the weekly slots.",
  "calendar.settings.properties": "Properties",
  "calendar.settings.days": "Days",
  "calendar.settings.start": "Start",
  "calendar.settings.end": "End",
  "calendar.settings.kind": "Kind (its options are the legend)",
  "calendar.settings.details": "Details shown in slots",
  "calendar.settings.addDetail": "Add a property",
  "calendar.settings.detailsHelp": "Only to people who may see each property; on published pages, only properties anyone may see.",
  "calendar.settings.calendars": "Calendars",
  "calendar.settings.calendarsHelp": "Only when they are busy shows, never what the events are. Calendars are connected in Account → Integrations.",
  "calendar.settings.noCalendars": "You have no calendars connected yet: connect them in Account → Integrations.",
  "calendar.settings.daysShown": "Days shown",
  "calendar.settings.from": "From",
  "calendar.settings.to": "To",
  "calendar.settings.zone": "The schedule’s time zone",
  "calendar.settings.zones": "Time zones",
  "calendar.settings.zoneHelp": "Shown in each viewer’s own.",
  "calendar.settings.badHours": "Write the hours as 8:00 and 19:00, the first before the second.",
  "calendar.settings.badZone": "Choose a time zone from the list.",
  "calendar.settings.incomplete": "Choose the database and its Days, Start and End properties.",
  "calendars.title": "Calendars",
  "calendars.help": "Calendars whose busy times your calendar blocks may show. Only when you are busy is read, and kept a few minutes, never what your events are.",
  "calendars.noEncryption": "Calendars cannot be connected on this installation: its administrator has not set an encryption key.",
  "calendars.google": "Google · {account}",
  "calendars.icalNamed": "{name} (iCal address)",
  "calendars.chosen": "{count, plural, =0 {No calendars chosen yet} one {1 calendar: {names}} other {# calendars: {names}}}",
  "calendars.added": "Added {date} · read {read}",
  "calendars.notRead": "not yet",
  "calendars.expired": "Google no longer lets it read: connect the account again.",
  "calendars.unreachable": "Could not be read the last time: its busy times count as free until it answers.",
  "calendars.choose": "Choose calendars…",
  "calendars.chooseFor": "Choose the calendars of {name}…",
  "calendars.chooseTitle": "Choose calendars",
  "calendars.calendars": "Calendars whose busy times may show",
  "calendars.shared": "shared with you",
  "calendars.rename": "Rename…",
  "calendars.renameFor": "Rename {name}…",
  "calendars.renameTitle": "Rename the calendar",
  "calendars.renamed": "Calendar renamed.",
  "calendars.disconnect": "Disconnect",
  "calendars.remove": "Remove",
  "calendars.removeFor": "Remove {name}",
  "calendars.removed": "{name} removed.",
  "calendars.connectGoogle": "Connect a Google account",
  "calendars.addIcal": "Add an iCal address…",
  "calendars.addIcalTitle": "Add an iCal address",
  "calendars.icalName": "Name",
  "calendars.icalAddress": "Secret iCal address",
  "calendars.icalHelp": "The private address your calendar gives for other apps (https:// or webcal://). It is kept encrypted.",
  "calendars.add": "Add",
  "calendars.addedOne": "{name} added.",
  "calendars.saved": "Calendars saved.",
  "calendars.connected": "Google account connected. Choose its calendars.",
  "calendars.failed": "The Google account could not be connected."
}
